// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --surface-a: #ffffff;
  --surface-b: #f8f9fa;
  --surface-c: #e9ecef;
  --surface-d: #dee2e6;
  --surface-e: #ffffff;
  --surface-f: #ffffff;
  --text-color: #495057;
  --text-color-secondary: #6c757d;
  --primary-color: #6366f1;
  --primary-color-text: #ffffff;
  --font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  --surface-0: #ffffff;
  --surface-50: #fafafa;
  --surface-100: #f5f5f5;
  --surface-200: #eeeeee;
  --surface-300: #e0e0e0;
  --surface-400: #bdbdbd;
  --surface-500: #9e9e9e;
  --surface-600: #757575;
  --surface-700: #616161;
  --surface-800: #424242;
  --surface-900: #212121;
  --gray-50: #fafafa;
  --gray-100: #f5f5f5;
  --gray-200: #eeeeee;
  --gray-300: #e0e0e0;
  --gray-400: #bdbdbd;
  --gray-500: #9e9e9e;
  --gray-600: #757575;
  --gray-700: #616161;
  --gray-800: #424242;
  --gray-900: #212121;
  --content-padding: 1.25rem;
  --inline-spacing: 0.5rem;
  --border-radius: 6px;
  --surface-ground: #eff3f8;
  --surface-section: #ffffff;
  --surface-card: #ffffff;
  --surface-overlay: #ffffff;
  --surface-border: #dfe7ef;
  --surface-hover: #f6f9fc;
  --focus-ring: 0 0 0 0.2rem #c7d2fe;
  --maskbg: rgba(0, 0, 0, 0.4);
  --highlight-bg: #eef2ff;
  --highlight-text-color: #4338ca;
  color-scheme: light;
}

* {
  box-sizing: border-box;
}

.p-component {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: normal;
}

.p-component-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  transition-duration: 0.2s;
}

.p-disabled,
.p-component:disabled {
  opacity: 0.6;
}

.p-error {
  color: #e24c4c;
}

.p-text-secondary {
  color: #6c757d;
}

.pi {
  font-size: 1rem;
}

.p-icon {
  width: 1rem;
  height: 1rem;
}

.p-link {
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  border-radius: 6px;
}

.p-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-component-overlay-enter {
  animation: p-component-overlay-enter-animation 150ms forwards;
}

.p-component-overlay-leave {
  animation: p-component-overlay-leave-animation 150ms forwards;
}

@keyframes p-component-overlay-enter-animation {
  from {
    background-color: transparent;
  }
  to {
    background-color: var(--maskbg);
  }
}
@keyframes p-component-overlay-leave-animation {
  from {
    background-color: var(--maskbg);
  }
  to {
    background-color: transparent;
  }
}
:root {
  --blue-50: #f5f9ff;
  --blue-100: #d0e1fd;
  --blue-200: #abc9fb;
  --blue-300: #85b2f9;
  --blue-400: #609af8;
  --blue-500: #3b82f6;
  --blue-600: #326fd1;
  --blue-700: #295bac;
  --blue-800: #204887;
  --blue-900: #183462;
  --green-50: #f4fcf7;
  --green-100: #caf1d8;
  --green-200: #a0e6ba;
  --green-300: #76db9b;
  --green-400: #4cd07d;
  --green-500: #22c55e;
  --green-600: #1da750;
  --green-700: #188a42;
  --green-800: #136c34;
  --green-900: #0e4f26;
  --yellow-50: #fefbf3;
  --yellow-100: #faedc4;
  --yellow-200: #f6de95;
  --yellow-300: #f2d066;
  --yellow-400: #eec137;
  --yellow-500: #eab308;
  --yellow-600: #c79807;
  --yellow-700: #a47d06;
  --yellow-800: #816204;
  --yellow-900: #5e4803;
  --cyan-50: #f3fbfd;
  --cyan-100: #c3edf5;
  --cyan-200: #94e0ed;
  --cyan-300: #65d2e4;
  --cyan-400: #35c4dc;
  --cyan-500: #06b6d4;
  --cyan-600: #059bb4;
  --cyan-700: #047f94;
  --cyan-800: #036475;
  --cyan-900: #024955;
  --pink-50: #fef6fa;
  --pink-100: #fad3e7;
  --pink-200: #f7b0d3;
  --pink-300: #f38ec0;
  --pink-400: #f06bac;
  --pink-500: #ec4899;
  --pink-600: #c93d82;
  --pink-700: #a5326b;
  --pink-800: #822854;
  --pink-900: #5e1d3d;
  --indigo-50: #f7f7fe;
  --indigo-100: #dadafc;
  --indigo-200: #bcbdf9;
  --indigo-300: #9ea0f6;
  --indigo-400: #8183f4;
  --indigo-500: #6366f1;
  --indigo-600: #5457cd;
  --indigo-700: #4547a9;
  --indigo-800: #363885;
  --indigo-900: #282960;
  --teal-50: #f3fbfb;
  --teal-100: #c7eeea;
  --teal-200: #9ae0d9;
  --teal-300: #6dd3c8;
  --teal-400: #41c5b7;
  --teal-500: #14b8a6;
  --teal-600: #119c8d;
  --teal-700: #0e8174;
  --teal-800: #0b655b;
  --teal-900: #084a42;
  --orange-50: #fff8f3;
  --orange-100: #feddc7;
  --orange-200: #fcc39b;
  --orange-300: #fba86f;
  --orange-400: #fa8e42;
  --orange-500: #f97316;
  --orange-600: #d46213;
  --orange-700: #ae510f;
  --orange-800: #893f0c;
  --orange-900: #642e09;
  --bluegray-50: #f7f8f9;
  --bluegray-100: #dadee3;
  --bluegray-200: #bcc3cd;
  --bluegray-300: #9fa9b7;
  --bluegray-400: #818ea1;
  --bluegray-500: #64748b;
  --bluegray-600: #556376;
  --bluegray-700: #465161;
  --bluegray-800: #37404c;
  --bluegray-900: #282e38;
  --purple-50: #fbf7ff;
  --purple-100: #ead6fd;
  --purple-200: #dab6fc;
  --purple-300: #c996fa;
  --purple-400: #b975f9;
  --purple-500: #a855f7;
  --purple-600: #8f48d2;
  --purple-700: #763cad;
  --purple-800: #5c2f88;
  --purple-900: #432263;
  --red-50: #fff5f5;
  --red-100: #ffd0ce;
  --red-200: #ffaca7;
  --red-300: #ff8780;
  --red-400: #ff6259;
  --red-500: #ff3d32;
  --red-600: #d9342b;
  --red-700: #b32b23;
  --red-800: #8c221c;
  --red-900: #661814;
  --primary-50: #f7f7fe;
  --primary-100: #dadafc;
  --primary-200: #bcbdf9;
  --primary-300: #9ea0f6;
  --primary-400: #8183f4;
  --primary-500: #6366f1;
  --primary-600: #5457cd;
  --primary-700: #4547a9;
  --primary-800: #363885;
  --primary-900: #282960;
}

.p-autocomplete .p-autocomplete-loader {
  right: 0.75rem;
}

.p-autocomplete.p-autocomplete-dd .p-autocomplete-loader {
  right: 3.75rem;
}

.p-autocomplete .p-autocomplete-multiple-container {
  padding: 0.375rem 0.75rem;
}

.p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled):hover {
  border-color: #6366f1;
}

.p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token {
  padding: 0.375rem 0;
}

.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token input {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  color: #495057;
  padding: 0;
  margin: 0;
}

.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {
  padding: 0.375rem 0.75rem;
  margin-right: 0.5rem;
  background: #eef2ff;
  color: #4338ca;
  border-radius: 6px;
}

.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token .p-autocomplete-token-icon {
  margin-left: 0.5rem;
}

.p-autocomplete.p-invalid.p-component > .p-inputtext {
  border-color: #e24c4c;
}

.p-autocomplete-panel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-autocomplete-panel .p-autocomplete-items {
  padding: 0.75rem 0;
}

.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
  margin: 0;
  padding: 0.75rem 1.25rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:hover {
  color: #495057;
  background: #e9ecef;
}

.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item-group {
  margin: 0;
  padding: 0.75rem 1.25rem;
  color: #343a40;
  background: #ffffff;
  font-weight: 700;
}

.p-calendar.p-invalid.p-component > .p-inputtext {
  border-color: #e24c4c;
}

.p-datepicker {
  padding: 0.5rem;
  background: #ffffff;
  color: #495057;
  border: 1px solid #ced4da;
  border-radius: 6px;
}

.p-datepicker:not(.p-datepicker-inline) {
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {
  background: #ffffff;
}

.p-datepicker .p-datepicker-header {
  padding: 0.5rem;
  color: #495057;
  background: #ffffff;
  font-weight: 600;
  margin: 0;
  border-bottom: 1px solid #dee2e6;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-datepicker .p-datepicker-header .p-datepicker-prev,
.p-datepicker .p-datepicker-header .p-datepicker-next {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,
.p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-datepicker .p-datepicker-header .p-datepicker-prev:focus,
.p-datepicker .p-datepicker-header .p-datepicker-next:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-datepicker .p-datepicker-header .p-datepicker-title {
  line-height: 2rem;
}

.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
  color: #495057;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  font-weight: 600;
  padding: 0.5rem;
}

.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {
  color: #6366f1;
}

.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
  margin-right: 0.5rem;
}

.p-datepicker table {
  font-size: 1rem;
  margin: 0.5rem 0;
}

.p-datepicker table th {
  padding: 0.5rem;
}

.p-datepicker table th > span {
  width: 2.5rem;
  height: 2.5rem;
}

.p-datepicker table td {
  padding: 0.5rem;
}

.p-datepicker table td > span {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  transition: box-shadow 0.2s;
  border: 1px solid transparent;
}

.p-datepicker table td > span.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-datepicker table td > span:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-datepicker table td.p-datepicker-today > span {
  background: #ced4da;
  color: #495057;
  border-color: transparent;
}

.p-datepicker table td.p-datepicker-today > span.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-datepicker .p-datepicker-buttonbar {
  padding: 1rem 0;
  border-top: 1px solid #dee2e6;
}

.p-datepicker .p-datepicker-buttonbar .p-button {
  width: auto;
}

.p-datepicker .p-timepicker {
  border-top: 1px solid #dee2e6;
  padding: 0.5rem;
}

.p-datepicker .p-timepicker button {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-datepicker .p-timepicker button:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-datepicker .p-timepicker button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-datepicker .p-timepicker button:last-child {
  margin-top: 0.2em;
}

.p-datepicker .p-timepicker span {
  font-size: 1.25rem;
}

.p-datepicker .p-timepicker > div {
  padding: 0 0.5rem;
}

.p-datepicker.p-datepicker-timeonly .p-timepicker {
  border-top: 0 none;
}

.p-datepicker .p-monthpicker {
  margin: 0.5rem 0;
}

.p-datepicker .p-monthpicker .p-monthpicker-month {
  padding: 0.5rem;
  transition: box-shadow 0.2s;
  border-radius: 6px;
}

.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-datepicker .p-yearpicker {
  margin: 0.5rem 0;
}

.p-datepicker .p-yearpicker .p-yearpicker-year {
  padding: 0.5rem;
  transition: box-shadow 0.2s;
  border-radius: 6px;
}

.p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
  border-left: 1px solid #dee2e6;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding-top: 0;
  padding-bottom: 0;
}

.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:first-child {
  padding-left: 0;
}

.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
  padding-right: 0;
  border-left: 0 none;
}

.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover {
  background: #e9ecef;
}

.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover {
  background: #e9ecef;
}

.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover {
  background: #e9ecef;
}

.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

@media screen and (max-width: 769px) {
  .p-datepicker table th,
  .p-datepicker table td {
    padding: 0;
  }
}
.p-cascadeselect {
  background: #ffffff;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
}

.p-cascadeselect:not(.p-disabled):hover {
  border-color: #6366f1;
}

.p-cascadeselect:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-cascadeselect .p-cascadeselect-label {
  background: transparent;
  border: 0 none;
  padding: 0.75rem 0.75rem;
}

.p-cascadeselect .p-cascadeselect-label.p-placeholder {
  color: #6c757d;
}

.p-cascadeselect .p-cascadeselect-label:enabled:focus {
  outline: 0 none;
  box-shadow: none;
}

.p-cascadeselect .p-cascadeselect-trigger {
  background: transparent;
  color: #6c757d;
  width: 3rem;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-cascadeselect.p-invalid.p-component {
  border-color: #e24c4c;
}

.p-cascadeselect-panel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-cascadeselect-panel .p-cascadeselect-items {
  padding: 0.75rem 0;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item {
  margin: 0;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content {
  padding: 0.75rem 1.25rem;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item:not(.p-highlight):not(.p-disabled):hover {
  color: #495057;
  background: #e9ecef;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon {
  font-size: 0.875rem;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon.p-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.p-input-filled .p-cascadeselect {
  background: #e9ecef;
}

.p-input-filled .p-cascadeselect:not(.p-disabled):hover {
  background-color: #e9ecef;
}

.p-input-filled .p-cascadeselect:not(.p-disabled).p-focus {
  background-color: #ffffff;
}

.p-checkbox {
  width: 22px;
  height: 22px;
}

.p-checkbox .p-checkbox-box {
  border: 2px solid #ced4da;
  background: #ffffff;
  width: 22px;
  height: 22px;
  color: #495057;
  border-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-checkbox .p-checkbox-box .p-checkbox-icon {
  transition-duration: 0.2s;
  color: #ffffff;
  font-size: 14px;
}

.p-checkbox .p-checkbox-box .p-checkbox-icon.p-icon {
  width: 14px;
  height: 14px;
}

.p-checkbox .p-checkbox-box.p-highlight {
  border-color: #6366f1;
  background: #6366f1;
}

.p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {
  border-color: #4338ca;
  background: #4338ca;
  color: #ffffff;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
  border-color: #6366f1;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
  border-color: #4338ca;
  background: #4338ca;
  color: #ffffff;
}

.p-checkbox.p-invalid > .p-checkbox-box {
  border-color: #e24c4c;
}

.p-input-filled .p-checkbox .p-checkbox-box {
  background-color: #e9ecef;
}

.p-input-filled .p-checkbox .p-checkbox-box.p-highlight {
  background: #6366f1;
}

.p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
  background-color: #e9ecef;
}

.p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
  background: #4338ca;
}

.p-chips .p-chips-multiple-container {
  padding: 0.375rem 0.75rem;
}

.p-chips .p-chips-multiple-container:not(.p-disabled):hover {
  border-color: #6366f1;
}

.p-chips .p-chips-multiple-container:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-chips .p-chips-multiple-container .p-chips-token {
  padding: 0.375rem 0.75rem;
  margin-right: 0.5rem;
  background: #dee2e6;
  color: #495057;
  border-radius: 16px;
}

.p-chips .p-chips-multiple-container .p-chips-token .p-chips-token-icon {
  margin-left: 0.5rem;
}

.p-chips .p-chips-multiple-container .p-chips-input-token {
  padding: 0.375rem 0;
}

.p-chips .p-chips-multiple-container .p-chips-input-token input {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  color: #495057;
  padding: 0;
  margin: 0;
}

.p-chips.p-invalid.p-component > .p-inputtext {
  border-color: #e24c4c;
}

.p-colorpicker-preview {
  width: 2rem;
  height: 2rem;
}

.p-colorpicker-panel {
  background: #323232;
  border: 1px solid #191919;
}

.p-colorpicker-panel .p-colorpicker-color-handle,
.p-colorpicker-panel .p-colorpicker-hue-handle {
  border-color: #ffffff;
}

.p-colorpicker-overlay-panel {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-dropdown {
  background: #ffffff;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
}

.p-dropdown:not(.p-disabled):hover {
  border-color: #6366f1;
}

.p-dropdown:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-dropdown.p-dropdown-clearable .p-dropdown-label {
  padding-right: 1.75rem;
}

.p-dropdown .p-dropdown-label {
  background: transparent;
  border: 0 none;
}

.p-dropdown .p-dropdown-label.p-placeholder {
  color: #6c757d;
}

.p-dropdown .p-dropdown-label:enabled:focus {
  outline: 0 none;
  box-shadow: none;
}

.p-dropdown .p-dropdown-trigger {
  background: transparent;
  color: #6c757d;
  width: 3rem;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-dropdown .p-dropdown-clear-icon {
  color: #6c757d;
  right: 3rem;
}

.p-dropdown.p-invalid.p-component {
  border-color: #e24c4c;
}

.p-dropdown-panel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-dropdown-panel .p-dropdown-header {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #dee2e6;
  color: #343a40;
  background: #f8f9fa;
  margin: 0;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
  padding-right: 1.75rem;
  margin-right: -1.75rem;
}

.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon {
  right: 0.75rem;
  color: #6c757d;
}

.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter {
  padding-right: 3.5rem;
  margin-right: -3.5rem;
}

.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon {
  right: 2.5rem;
}

.p-dropdown-panel .p-dropdown-items {
  padding: 0.75rem 0;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  margin: 0;
  padding: 0.75rem 1.25rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  color: #495057;
  background: #e9ecef;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item-group {
  margin: 0;
  padding: 0.75rem 1.25rem;
  color: #343a40;
  background: #ffffff;
  font-weight: 700;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-empty-message {
  padding: 0.75rem 1.25rem;
  color: #495057;
  background: transparent;
}

.p-input-filled .p-dropdown {
  background: #e9ecef;
}

.p-input-filled .p-dropdown:not(.p-disabled):hover {
  background-color: #e9ecef;
}

.p-input-filled .p-dropdown:not(.p-disabled).p-focus {
  background-color: #ffffff;
}

.p-input-filled .p-dropdown:not(.p-disabled).p-focus .p-inputtext {
  background-color: transparent;
}

.p-editor-container .p-editor-toolbar {
  background: #f8f9fa;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-editor-container .p-editor-toolbar.ql-snow {
  border: 1px solid #dee2e6;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-stroke {
  stroke: #6c757d;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-fill {
  fill: #6c757d;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label {
  border: 0 none;
  color: #6c757d;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover {
  color: #495057;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-stroke {
  stroke: #495057;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-fill {
  fill: #495057;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #495057;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #495057;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #495057;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 0.75rem 0;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item {
  color: #495057;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item:hover {
  color: #495057;
  background: #e9ecef;
}

.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded:not(.ql-icon-picker) .ql-picker-item {
  padding: 0.75rem 1.25rem;
}

.p-editor-container .p-editor-content {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-editor-container .p-editor-content.ql-snow {
  border: 1px solid #dee2e6;
}

.p-editor-container .p-editor-content .ql-editor {
  background: #ffffff;
  color: #495057;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-editor-container .ql-snow.ql-toolbar button:hover,
.p-editor-container .ql-snow.ql-toolbar button:focus {
  color: #495057;
}

.p-editor-container .ql-snow.ql-toolbar button:hover .ql-stroke,
.p-editor-container .ql-snow.ql-toolbar button:focus .ql-stroke {
  stroke: #495057;
}

.p-editor-container .ql-snow.ql-toolbar button:hover .ql-fill,
.p-editor-container .ql-snow.ql-toolbar button:focus .ql-fill {
  fill: #495057;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected {
  color: #6366f1;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-stroke,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke {
  stroke: #6366f1;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-fill,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill {
  fill: #6366f1;
}

.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-picker-label,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-picker-label,
.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-picker-label {
  color: #6366f1;
}

.p-inputgroup-addon {
  background: #e9ecef;
  color: #6c757d;
  border-top: 1px solid #ced4da;
  border-left: 1px solid #ced4da;
  border-bottom: 1px solid #ced4da;
  padding: 0.75rem 0.75rem;
  min-width: 3rem;
}

.p-inputgroup-addon:last-child {
  border-right: 1px solid #ced4da;
}

.p-inputgroup > .p-component,
.p-inputgroup > .p-inputwrapper > .p-inputtext,
.p-inputgroup > .p-float-label > .p-component {
  border-radius: 0;
  margin: 0;
}

.p-inputgroup > .p-component + .p-inputgroup-addon,
.p-inputgroup > .p-inputwrapper > .p-inputtext + .p-inputgroup-addon,
.p-inputgroup > .p-float-label > .p-component + .p-inputgroup-addon {
  border-left: 0 none;
}

.p-inputgroup > .p-component:focus,
.p-inputgroup > .p-inputwrapper > .p-inputtext:focus,
.p-inputgroup > .p-float-label > .p-component:focus {
  z-index: 1;
}

.p-inputgroup > .p-component:focus ~ label,
.p-inputgroup > .p-inputwrapper > .p-inputtext:focus ~ label,
.p-inputgroup > .p-float-label > .p-component:focus ~ label {
  z-index: 1;
}

.p-inputgroup-addon:first-child,
.p-inputgroup button:first-child,
.p-inputgroup input:first-child,
.p-inputgroup > .p-inputwrapper:first-child,
.p-inputgroup > .p-inputwrapper:first-child > .p-inputtext {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-inputgroup .p-float-label:first-child input {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-inputgroup-addon:last-child,
.p-inputgroup button:last-child,
.p-inputgroup input:last-child,
.p-inputgroup > .p-inputwrapper:last-child,
.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-inputgroup .p-float-label:last-child input {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-fluid .p-inputgroup .p-button {
  width: auto;
}

.p-fluid .p-inputgroup .p-button.p-button-icon-only {
  width: 3rem;
}

.p-inputnumber.p-invalid.p-component > .p-inputtext {
  border-color: #e24c4c;
}

.p-inputswitch {
  width: 3rem;
  height: 1.75rem;
}

.p-inputswitch .p-inputswitch-slider {
  background: #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 30px;
}

.p-inputswitch .p-inputswitch-slider:before {
  background: #ffffff;
  width: 1.25rem;
  height: 1.25rem;
  left: 0.25rem;
  margin-top: -0.625rem;
  border-radius: 50%;
  transition-duration: 0.2s;
}

.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
  transform: translateX(1.25rem);
}

.p-inputswitch.p-focus .p-inputswitch-slider {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider {
  background: #b6bfc8;
}

.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background: #6366f1;
}

.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
  background: #ffffff;
}

.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {
  background: #4f46e5;
}

.p-inputswitch.p-invalid .p-inputswitch-slider {
  border-color: #e24c4c;
}

.p-inputtext {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  color: #495057 !important;
  background: #ffffff;
  padding: 0.75rem 0.75rem;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  appearance: none;
  border-radius: 6px;
}

.p-inputtext:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border: 1px solid #ced4da !important;
}

.p-inputtext.p-invalid.p-component {
  border-color: #e24c4c;
}

.p-inputtext.p-inputtext-sm {
  font-size: 0.875rem;
  padding: 0.65625rem 0.65625rem;
}

.p-inputtext.p-inputtext-lg {
  font-size: 1.25rem;
  padding: 0.9375rem 0.9375rem;
}

.p-float-label > label {
  left: 0.75rem;
  color: #6c757d;
  transition-duration: 0.2s;
}

.p-float-label > label.p-error {
  color: #e24c4c;
}

.p-input-icon-left > i:first-of-type,
.p-input-icon-left > svg:first-of-type,
.p-input-icon-left > .p-input-prefix {
  left: 0.75rem;
  color: #6c757d;
}

.p-input-icon-left > .p-inputtext {
  padding-left: 2.5rem;
}

.p-input-icon-left.p-float-label > label {
  left: 2.5rem;
}

.p-input-icon-right > i:last-of-type,
.p-input-icon-right > svg:last-of-type,
.p-input-icon-right > .p-input-suffix {
  right: 0.75rem;
  color: #6c757d;
}

.p-input-icon-right > .p-inputtext {
  padding-right: 2.5rem;
}

::-webkit-input-placeholder {
  color: #6c757d;
}

:-moz-placeholder {
  color: #6c757d;
}

::-moz-placeholder {
  color: #6c757d;
}

:-ms-input-placeholder {
  color: #6c757d;
}

.p-input-filled .p-inputtext {
  background-color: #e9ecef;
}

.p-input-filled .p-inputtext:enabled:hover {
  background-color: #e9ecef;
}

.p-input-filled .p-inputtext:enabled:focus {
  background-color: #ffffff;
}

.p-inputtext-sm .p-inputtext {
  font-size: 0.875rem;
  padding: 0.65625rem 0.65625rem;
}

.p-inputtext-lg .p-inputtext {
  font-size: 1.25rem;
  padding: 0.9375rem 0.9375rem;
}

.p-listbox {
  background: #ffffff;
  color: #495057;
  border: 1px solid #ced4da;
  border-radius: 6px;
}

.p-listbox .p-listbox-header {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #dee2e6;
  color: #343a40;
  background: #f8f9fa;
  margin: 0;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-listbox .p-listbox-header .p-listbox-filter {
  padding-right: 1.75rem;
}

.p-listbox .p-listbox-header .p-listbox-filter-icon {
  right: 0.75rem;
  color: #6c757d;
}

.p-listbox .p-listbox-list {
  padding: 0.75rem 0;
}

.p-listbox .p-listbox-list .p-listbox-item {
  margin: 0;
  padding: 0.75rem 1.25rem;
  border: 0 none;
  color: #495057;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-listbox .p-listbox-list .p-listbox-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-listbox .p-listbox-list .p-listbox-item:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-listbox .p-listbox-list .p-listbox-item-group {
  margin: 0;
  padding: 0.75rem 1.25rem;
  color: #343a40;
  background: #ffffff;
  font-weight: 700;
}

.p-listbox .p-listbox-list .p-listbox-empty-message {
  padding: 0.75rem 1.25rem;
  color: #495057;
  background: transparent;
}

.p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover {
  color: #495057;
  background: #e9ecef;
}

.p-listbox.p-invalid {
  border-color: #e24c4c;
}

.p-mention-panel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-mention-panel .p-mention-items {
  padding: 0.75rem 0;
}

.p-mention-panel .p-mention-items .p-mention-item {
  margin: 0;
  padding: 0.75rem 1.25rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-mention-panel .p-mention-items .p-mention-item:hover {
  color: #495057;
  background: #e9ecef;
}

.p-mention-panel .p-mention-items .p-mention-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-multiselect {
  background: #ffffff;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
}

.p-multiselect:not(.p-disabled):hover {
  border-color: #6366f1;
}

.p-multiselect:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-multiselect.p-multiselect-clearable .p-multiselect-label {
  padding-right: 1.75rem;
}

.p-multiselect .p-multiselect-label {
  padding: 0.75rem 0.75rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-multiselect .p-multiselect-label.p-placeholder {
  color: #6c757d;
}

.p-multiselect.p-multiselect-chip .p-multiselect-token {
  padding: 0.375rem 0.75rem;
  margin-right: 0.5rem;
  background: #dee2e6;
  color: #495057;
  border-radius: 16px;
}

.p-multiselect.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {
  margin-left: 0.5rem;
}

.p-multiselect .p-multiselect-trigger {
  background: transparent;
  color: #6c757d;
  width: 3rem;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-multiselect .p-multiselect-clear-icon {
  color: #6c757d;
  right: 3rem;
}

.p-multiselect.p-invalid.p-component {
  border-color: #e24c4c;
}

.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label {
  padding: 0.375rem 0.75rem;
}

.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label.p-multiselect-items-label {
  padding: 0.75rem 0.75rem;
}

.p-inputwrapper-filled.p-multiselect.p-multiselect-clearable .p-multiselect-label {
  padding-right: 1.75rem;
}

.p-multiselect-panel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-multiselect-panel .p-multiselect-header {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #dee2e6;
  color: #343a40;
  background: #f8f9fa;
  margin: 0;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container {
  margin: 0 0.5rem;
}

.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
  padding-right: 1.75rem;
}

.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {
  right: 0.75rem;
  color: #6c757d;
}

.p-multiselect-panel .p-multiselect-header .p-multiselect-close {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-multiselect-panel .p-multiselect-items {
  padding: 0.75rem 0;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item {
  margin: 0;
  padding: 0.75rem 1.25rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover {
  color: #495057;
  background: #e9ecef;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {
  margin-right: 0.5rem;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item-group {
  margin: 0;
  padding: 0.75rem 1.25rem;
  color: #343a40;
  background: #ffffff;
  font-weight: 700;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-empty-message {
  padding: 0.75rem 1.25rem;
  color: #495057;
  background: transparent;
}

.p-input-filled .p-multiselect {
  background: #e9ecef;
}

.p-input-filled .p-multiselect:not(.p-disabled):hover {
  background-color: #e9ecef;
}

.p-input-filled .p-multiselect:not(.p-disabled).p-focus {
  background-color: #ffffff;
}

.p-password.p-invalid.p-component > .p-inputtext {
  border-color: #e24c4c;
}

.p-password-panel {
  padding: 1.25rem;
  background: #ffffff;
  color: #495057;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.p-password-panel .p-password-meter {
  margin-bottom: 0.5rem;
  background: #dee2e6;
}

.p-password-panel .p-password-meter .p-password-strength.weak {
  background: #ea5455;
}

.p-password-panel .p-password-meter .p-password-strength.medium {
  background: #ff9f42;
}

.p-password-panel .p-password-meter .p-password-strength.strong {
  background: #29c76f;
}

.p-radiobutton {
  width: 22px;
  height: 22px;
}

.p-radiobutton .p-radiobutton-box {
  border: 2px solid #ced4da;
  background: #ffffff;
  width: 22px;
  height: 22px;
  color: #495057;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
  border-color: #6366f1;
}

.p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
  width: 12px;
  height: 12px;
  transition-duration: 0.2s;
  background-color: #ffffff;
}

.p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: #6366f1;
  background: #6366f1;
}

.p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
  border-color: #4338ca;
  background: #4338ca;
  color: #ffffff;
}

.p-radiobutton.p-invalid > .p-radiobutton-box {
  border-color: #e24c4c;
}

.p-radiobutton:focus {
  outline: 0 none;
}

.p-input-filled .p-radiobutton .p-radiobutton-box {
  background-color: #e9ecef;
}

.p-input-filled .p-radiobutton .p-radiobutton-box:not(.p-disabled):hover {
  background-color: #e9ecef;
}

.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight {
  background: #6366f1;
}

.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
  background: #4338ca;
}

.p-rating {
  gap: 0.5rem;
}

.p-rating .p-rating-item .p-rating-icon {
  color: #495057;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  font-size: 1.143rem;
}

.p-rating .p-rating-item .p-rating-icon.p-icon {
  width: 1.143rem;
  height: 1.143rem;
}

.p-rating .p-rating-item .p-rating-icon.p-rating-cancel {
  color: #ea5455;
}

.p-rating .p-rating-item:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
  color: #6366f1;
}

.p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon {
  color: #6366f1;
}

.p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon.p-rating-cancel {
  color: #e73d3e;
}

.p-selectbutton .p-button {
  background: #ffffff;
  border: 1px solid #ced4da;
  color: #495057;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-selectbutton .p-button .p-button-icon-left,
.p-selectbutton .p-button .p-button-icon-right {
  color: #6c757d;
}

.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {
  background: #e9ecef;
  border-color: #ced4da;
  color: #495057;
}

.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,
.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {
  color: #343a40;
}

.p-selectbutton .p-button.p-highlight {
  background: #6366f1;
  border-color: #6366f1;
  color: #ffffff;
}

.p-selectbutton .p-button.p-highlight .p-button-icon-left,
.p-selectbutton .p-button.p-highlight .p-button-icon-right {
  color: #ffffff;
}

.p-selectbutton .p-button.p-highlight:hover {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #ffffff;
}

.p-selectbutton .p-button.p-highlight:hover .p-button-icon-left,
.p-selectbutton .p-button.p-highlight:hover .p-button-icon-right {
  color: #ffffff;
}

.p-selectbutton.p-invalid > .p-button {
  border-color: #e24c4c;
}

.p-slider {
  background: #dee2e6;
  border: 0 none;
  border-radius: 6px;
}

.p-slider.p-slider-horizontal {
  height: 0.286rem;
}

.p-slider.p-slider-horizontal .p-slider-handle {
  margin-top: -0.5715rem;
  margin-left: -0.5715rem;
}

.p-slider.p-slider-vertical {
  width: 0.286rem;
}

.p-slider.p-slider-vertical .p-slider-handle {
  margin-left: -0.5715rem;
  margin-bottom: -0.5715rem;
}

.p-slider .p-slider-handle {
  height: 1.143rem;
  width: 1.143rem;
  background: #ffffff;
  border: 2px solid #6366f1;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-slider .p-slider-handle:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-slider .p-slider-range {
  background: #6366f1;
}

.p-slider:not(.p-disabled) .p-slider-handle:hover {
  background: #6366f1;
  border-color: #6366f1;
}

.p-treeselect {
  background: #ffffff;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
}

.p-treeselect:not(.p-disabled):hover {
  border-color: #6366f1;
}

.p-treeselect:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-treeselect .p-treeselect-label {
  padding: 0.75rem 0.75rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-treeselect .p-treeselect-label.p-placeholder {
  color: #6c757d;
}

.p-treeselect.p-treeselect-chip .p-treeselect-token {
  padding: 0.375rem 0.75rem;
  margin-right: 0.5rem;
  background: #dee2e6;
  color: #495057;
  border-radius: 16px;
}

.p-treeselect .p-treeselect-trigger {
  background: transparent;
  color: #6c757d;
  width: 3rem;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-treeselect.p-invalid.p-component {
  border-color: #e24c4c;
}

.p-inputwrapper-filled.p-treeselect.p-treeselect-chip .p-treeselect-label {
  padding: 0.375rem 0.75rem;
}

.p-treeselect-panel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-treeselect-panel .p-treeselect-header {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #dee2e6;
  color: #343a40;
  background: #f8f9fa;
  margin: 0;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container {
  margin-right: 0.5rem;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter {
  padding-right: 1.75rem;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter-icon {
  right: 0.75rem;
  color: #6c757d;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter {
  padding-right: 3.5rem;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter-clear-icon {
  right: 2.5rem;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-close {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-close:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-treeselect-panel .p-treeselect-header .p-treeselect-close:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-treeselect-panel .p-treeselect-items-wrapper .p-tree {
  border: 0 none;
}

.p-treeselect-panel .p-treeselect-items-wrapper .p-treeselect-empty-message {
  padding: 0.75rem 1.25rem;
  color: #495057;
  background: transparent;
}

.p-input-filled .p-treeselect {
  background: #e9ecef;
}

.p-input-filled .p-treeselect:not(.p-disabled):hover {
  background-color: #e9ecef;
}

.p-input-filled .p-treeselect:not(.p-disabled).p-focus {
  background-color: #ffffff;
}

.p-togglebutton.p-button {
  background: #ffffff;
  border: 1px solid #ced4da;
  color: #495057;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-togglebutton.p-button .p-button-icon-left,
.p-togglebutton.p-button .p-button-icon-right {
  color: #6c757d;
}

.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover {
  background: #e9ecef;
  border-color: #ced4da;
  color: #495057;
}

.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,
.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {
  color: #343a40;
}

.p-togglebutton.p-button.p-highlight {
  background: #6366f1;
  border-color: #6366f1;
  color: #ffffff;
}

.p-togglebutton.p-button.p-highlight .p-button-icon-left,
.p-togglebutton.p-button.p-highlight .p-button-icon-right {
  color: #ffffff;
}

.p-togglebutton.p-button.p-highlight:hover {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #ffffff;
}

.p-togglebutton.p-button.p-highlight:hover .p-button-icon-left,
.p-togglebutton.p-button.p-highlight:hover .p-button-icon-right {
  color: #ffffff;
}

.p-togglebutton.p-button.p-invalid > .p-button {
  border-color: #e24c4c;
}

.p-button {
  color: #ffffff;
  background: #6366f1;
  border: 1px solid #6366f1;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
}

.p-button:enabled:hover,
.p-button:not(button):not(a):not(.p-disabled):hover {
  background: #4f46e5;
  color: #ffffff;
  border-color: #4f46e5;
}

.p-button:enabled:active,
.p-button:not(button):not(a):not(.p-disabled):active {
  background: #4338ca;
  color: #ffffff;
  border-color: #4338ca;
}

.p-button.p-button-outlined {
  background-color: transparent;
  color: #6366f1;
  border: 1px solid;
}

.p-button.p-button-outlined:enabled:hover,
.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background: rgba(99, 102, 241, 0.04);
  color: #6366f1;
  border: 1px solid;
}

.p-button.p-button-outlined:enabled:active,
.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: rgba(99, 102, 241, 0.16);
  color: #6366f1;
  border: 1px solid;
}

.p-button.p-button-outlined.p-button-plain {
  color: #6c757d;
  border-color: #6c757d;
}

.p-button.p-button-outlined.p-button-plain:enabled:hover,
.p-button.p-button-outlined.p-button-plain:not(button):not(a):not(.p-disabled):hover {
  background: #e9ecef;
  color: #6c757d;
}

.p-button.p-button-outlined.p-button-plain:enabled:active,
.p-button.p-button-outlined.p-button-plain:not(button):not(a):not(.p-disabled):active {
  background: #dee2e6;
  color: #6c757d;
}

.p-button.p-button-text {
  background-color: transparent;
  color: #6366f1;
  border-color: transparent;
}

.p-button.p-button-text:enabled:hover,
.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background: rgba(99, 102, 241, 0.04);
  color: #6366f1;
  border-color: transparent;
}

.p-button.p-button-text:enabled:active,
.p-button.p-button-text:not(button):not(a):not(.p-disabled):active {
  background: rgba(99, 102, 241, 0.16);
  color: #6366f1;
  border-color: transparent;
}

.p-button.p-button-text.p-button-plain {
  color: #6c757d;
}

.p-button.p-button-text.p-button-plain:enabled:hover,
.p-button.p-button-text.p-button-plain:not(button):not(a):not(.p-disabled):hover {
  background: #e9ecef;
  color: #6c757d;
}

.p-button.p-button-text.p-button-plain:enabled:active,
.p-button.p-button-text.p-button-plain:not(button):not(a):not(.p-disabled):active {
  background: #dee2e6;
  color: #6c757d;
}

.p-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-button .p-button-label {
  transition-duration: 0.2s;
}

.p-button .p-button-icon-left {
  margin-right: 0.5rem;
}

.p-button .p-button-icon-right {
  margin-left: 0.5rem;
}

.p-button .p-button-icon-bottom {
  margin-top: 0.5rem;
}

.p-button .p-button-icon-top {
  margin-bottom: 0.5rem;
}

.p-button .p-badge {
  margin-left: 0.5rem;
  min-width: 1rem;
  height: 1rem;
  line-height: 1rem;
  color: #6366f1;
  background-color: #ffffff;
}

.p-button.p-button-raised {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.p-button.p-button-rounded {
  border-radius: 2rem;
}

.p-button.p-button-icon-only {
  width: 3rem;
  padding: 0.75rem 0;
}

.p-button.p-button-icon-only .p-button-icon-left,
.p-button.p-button-icon-only .p-button-icon-right {
  margin: 0;
}

.p-button.p-button-icon-only.p-button-rounded {
  border-radius: 50%;
  height: 3rem;
}

.p-button.p-button-sm {
  font-size: 0.875rem;
  padding: 0.65625rem 1.09375rem;
}

.p-button.p-button-sm .p-button-icon {
  font-size: 0.875rem;
}

.p-button.p-button-lg {
  font-size: 1.25rem;
  padding: 0.9375rem 1.5625rem;
}

.p-button.p-button-lg .p-button-icon {
  font-size: 1.25rem;
}

.p-button.p-button-loading-label-only.p-button-loading-left .p-button-label {
  margin-left: 0.5rem;
}

.p-button.p-button-loading-label-only.p-button-loading-right .p-button-label {
  margin-right: 0.5rem;
}

.p-button.p-button-loading-label-only.p-button-loading-top .p-button-label {
  margin-top: 0.5rem;
}

.p-button.p-button-loading-label-only.p-button-loading-bottom .p-button-label {
  margin-bottom: 0.5rem;
}

.p-button.p-button-loading-label-only .p-button-loading-icon {
  margin: 0;
}

.p-fluid .p-button {
  width: 100%;
}

.p-fluid .p-button-icon-only {
  width: 3rem;
}

.p-fluid .p-buttonset {
  display: flex;
}

.p-fluid .p-buttonset .p-button {
  flex: 1 1;
}

.p-button.p-button-secondary,
.p-buttonset.p-button-secondary > .p-button,
.p-splitbutton.p-button-secondary > .p-button,
.p-fileupload-choose.p-button-secondary {
  color: #ffffff;
  background: #64748b;
  border: 1px solid #64748b;
}

.p-button.p-button-secondary:enabled:hover,
.p-button.p-button-secondary:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-secondary > .p-button:enabled:hover,
.p-buttonset.p-button-secondary > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-secondary > .p-button:enabled:hover,
.p-splitbutton.p-button-secondary > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-secondary:enabled:hover,
.p-fileupload-choose.p-button-secondary:not(button):not(a):not(.p-disabled):hover {
  background: #475569;
  color: #ffffff;
  border-color: #475569;
}

.p-button.p-button-secondary:enabled:focus,
.p-button.p-button-secondary:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-secondary > .p-button:enabled:focus,
.p-buttonset.p-button-secondary > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-secondary > .p-button:enabled:focus,
.p-splitbutton.p-button-secondary > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-secondary:enabled:focus,
.p-fileupload-choose.p-button-secondary:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0 0 0 0.2rem #e2e8f0;
}

.p-button.p-button-secondary:enabled:active,
.p-button.p-button-secondary:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-secondary > .p-button:enabled:active,
.p-buttonset.p-button-secondary > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-secondary > .p-button:enabled:active,
.p-splitbutton.p-button-secondary > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-secondary:enabled:active,
.p-fileupload-choose.p-button-secondary:not(button):not(a):not(.p-disabled):active {
  background: #334155;
  color: #ffffff;
  border-color: #334155;
}

.p-button.p-button-secondary.p-button-outlined,
.p-buttonset.p-button-secondary > .p-button.p-button-outlined,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-secondary.p-button-outlined {
  background-color: transparent;
  color: #64748b;
  border: 1px solid;
}

.p-button.p-button-secondary.p-button-outlined:enabled:hover,
.p-button.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-secondary > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-secondary > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-secondary.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background: rgba(100, 116, 139, 0.04);
  color: #64748b;
  border: 1px solid;
}

.p-button.p-button-secondary.p-button-outlined:enabled:active,
.p-button.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-secondary > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-secondary > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-secondary > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-secondary.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: rgba(100, 116, 139, 0.16);
  color: #64748b;
  border: 1px solid;
}

.p-button.p-button-secondary.p-button-text,
.p-buttonset.p-button-secondary > .p-button.p-button-text,
.p-splitbutton.p-button-secondary > .p-button.p-button-text,
.p-fileupload-choose.p-button-secondary.p-button-text {
  background-color: transparent;
  color: #64748b;
  border-color: transparent;
}

.p-button.p-button-secondary.p-button-text:enabled:hover,
.p-button.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-secondary > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-secondary > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-secondary > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-secondary > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-secondary.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background: rgba(100, 116, 139, 0.04);
  border-color: transparent;
  color: #64748b;
}

.p-button.p-button-secondary.p-button-text:enabled:active,
.p-button.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-secondary > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-secondary > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-secondary > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-secondary > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-secondary.p-button-text:enabled:active,
.p-fileupload-choose.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):active {
  background: rgba(100, 116, 139, 0.16);
  border-color: transparent;
  color: #64748b;
}

.p-button.p-button-info,
.p-buttonset.p-button-info > .p-button,
.p-splitbutton.p-button-info > .p-button,
.p-fileupload-choose.p-button-info {
  color: #ffffff;
  background: #3b82f6;
  border: 1px solid #3b82f6;
}

.p-button.p-button-info:enabled:hover,
.p-button.p-button-info:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-info > .p-button:enabled:hover,
.p-buttonset.p-button-info > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-info > .p-button:enabled:hover,
.p-splitbutton.p-button-info > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-info:enabled:hover,
.p-fileupload-choose.p-button-info:not(button):not(a):not(.p-disabled):hover {
  background: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
}

.p-button.p-button-info:enabled:focus,
.p-button.p-button-info:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-info > .p-button:enabled:focus,
.p-buttonset.p-button-info > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-info > .p-button:enabled:focus,
.p-splitbutton.p-button-info > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-info:enabled:focus,
.p-fileupload-choose.p-button-info:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0 0 0 0.2rem #bfdbfe;
}

.p-button.p-button-info:enabled:active,
.p-button.p-button-info:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-info > .p-button:enabled:active,
.p-buttonset.p-button-info > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-info > .p-button:enabled:active,
.p-splitbutton.p-button-info > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-info:enabled:active,
.p-fileupload-choose.p-button-info:not(button):not(a):not(.p-disabled):active {
  background: #1d4ed8;
  color: #ffffff;
  border-color: #1d4ed8;
}

.p-button.p-button-info.p-button-outlined,
.p-buttonset.p-button-info > .p-button.p-button-outlined,
.p-splitbutton.p-button-info > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-info.p-button-outlined {
  background-color: transparent;
  color: #3b82f6;
  border: 1px solid;
}

.p-button.p-button-info.p-button-outlined:enabled:hover,
.p-button.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-info > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-info > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-info > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-info > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-info.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background: rgba(59, 130, 246, 0.04);
  color: #3b82f6;
  border: 1px solid;
}

.p-button.p-button-info.p-button-outlined:enabled:active,
.p-button.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-info > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-info > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-info > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-info > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-info.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: rgba(59, 130, 246, 0.16);
  color: #3b82f6;
  border: 1px solid;
}

.p-button.p-button-info.p-button-text,
.p-buttonset.p-button-info > .p-button.p-button-text,
.p-splitbutton.p-button-info > .p-button.p-button-text,
.p-fileupload-choose.p-button-info.p-button-text {
  background-color: transparent;
  color: #3b82f6;
  border-color: transparent;
}

.p-button.p-button-info.p-button-text:enabled:hover,
.p-button.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-info > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-info > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-info > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-info > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-info.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background: rgba(59, 130, 246, 0.04);
  border-color: transparent;
  color: #3b82f6;
}

.p-button.p-button-info.p-button-text:enabled:active,
.p-button.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-info > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-info > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-info > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-info > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-info.p-button-text:enabled:active,
.p-fileupload-choose.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):active {
  background: rgba(59, 130, 246, 0.16);
  border-color: transparent;
  color: #3b82f6;
}

.p-button.p-button-success,
.p-buttonset.p-button-success > .p-button,
.p-splitbutton.p-button-success > .p-button,
.p-fileupload-choose.p-button-success {
  color: #ffffff;
  background: #22c55e;
  border: 1px solid #22c55e;
}

.p-button.p-button-success:enabled:hover,
.p-button.p-button-success:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-success > .p-button:enabled:hover,
.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-success > .p-button:enabled:hover,
.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-success:enabled:hover,
.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):hover {
  background: #16a34a;
  color: #ffffff;
  border-color: #16a34a;
}

.p-button.p-button-success:enabled:focus,
.p-button.p-button-success:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-success > .p-button:enabled:focus,
.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-success > .p-button:enabled:focus,
.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-success:enabled:focus,
.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0 0 0 0.2rem #bbf7d0;
}

.p-button.p-button-success:enabled:active,
.p-button.p-button-success:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-success > .p-button:enabled:active,
.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-success > .p-button:enabled:active,
.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-success:enabled:active,
.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):active {
  background: #15803d;
  color: #ffffff;
  border-color: #15803d;
}

.p-button.p-button-success.p-button-outlined,
.p-buttonset.p-button-success > .p-button.p-button-outlined,
.p-splitbutton.p-button-success > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-success.p-button-outlined {
  background-color: transparent;
  color: #22c55e;
  border: 1px solid;
}

.p-button.p-button-success.p-button-outlined:enabled:hover,
.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-success > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-success.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background: rgba(34, 197, 94, 0.04);
  color: #22c55e;
  border: 1px solid;
}

.p-button.p-button-success.p-button-outlined:enabled:active,
.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-success > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-success.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: rgba(34, 197, 94, 0.16);
  color: #22c55e;
  border: 1px solid;
}

.p-button.p-button-success.p-button-text,
.p-buttonset.p-button-success > .p-button.p-button-text,
.p-splitbutton.p-button-success > .p-button.p-button-text,
.p-fileupload-choose.p-button-success.p-button-text {
  background-color: transparent;
  color: #22c55e;
  border-color: transparent;
}

.p-button.p-button-success.p-button-text:enabled:hover,
.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-success > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-success > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-success.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background: rgba(34, 197, 94, 0.04);
  border-color: transparent;
  color: #22c55e;
}

.p-button.p-button-success.p-button-text:enabled:active,
.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-success > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-success > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-success.p-button-text:enabled:active,
.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active {
  background: rgba(34, 197, 94, 0.16);
  border-color: transparent;
  color: #22c55e;
}

.p-button.p-button-warning,
.p-buttonset.p-button-warning > .p-button,
.p-splitbutton.p-button-warning > .p-button,
.p-fileupload-choose.p-button-warning {
  color: #ffffff;
  background: #f59e0b;
  border: 1px solid #f59e0b;
}

.p-button.p-button-warning:enabled:hover,
.p-button.p-button-warning:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-warning > .p-button:enabled:hover,
.p-buttonset.p-button-warning > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-warning > .p-button:enabled:hover,
.p-splitbutton.p-button-warning > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-warning:enabled:hover,
.p-fileupload-choose.p-button-warning:not(button):not(a):not(.p-disabled):hover {
  background: #d97706;
  color: #ffffff;
  border-color: #d97706;
}

.p-button.p-button-warning:enabled:focus,
.p-button.p-button-warning:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-warning > .p-button:enabled:focus,
.p-buttonset.p-button-warning > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-warning > .p-button:enabled:focus,
.p-splitbutton.p-button-warning > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-warning:enabled:focus,
.p-fileupload-choose.p-button-warning:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0 0 0 0.2rem #fde68a;
}

.p-button.p-button-warning:enabled:active,
.p-button.p-button-warning:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-warning > .p-button:enabled:active,
.p-buttonset.p-button-warning > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-warning > .p-button:enabled:active,
.p-splitbutton.p-button-warning > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-warning:enabled:active,
.p-fileupload-choose.p-button-warning:not(button):not(a):not(.p-disabled):active {
  background: #b45309;
  color: #ffffff;
  border-color: #b45309;
}

.p-button.p-button-warning.p-button-outlined,
.p-buttonset.p-button-warning > .p-button.p-button-outlined,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-warning.p-button-outlined {
  background-color: transparent;
  color: #f59e0b;
  border: 1px solid;
}

.p-button.p-button-warning.p-button-outlined:enabled:hover,
.p-button.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-warning > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-warning > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-warning.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background: rgba(245, 158, 11, 0.04);
  color: #f59e0b;
  border: 1px solid;
}

.p-button.p-button-warning.p-button-outlined:enabled:active,
.p-button.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-warning > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-warning > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-warning > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-warning.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: rgba(245, 158, 11, 0.16);
  color: #f59e0b;
  border: 1px solid;
}

.p-button.p-button-warning.p-button-text,
.p-buttonset.p-button-warning > .p-button.p-button-text,
.p-splitbutton.p-button-warning > .p-button.p-button-text,
.p-fileupload-choose.p-button-warning.p-button-text {
  background-color: transparent;
  color: #f59e0b;
  border-color: transparent;
}

.p-button.p-button-warning.p-button-text:enabled:hover,
.p-button.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-warning > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-warning > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-warning > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-warning > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-warning.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background: rgba(245, 158, 11, 0.04);
  border-color: transparent;
  color: #f59e0b;
}

.p-button.p-button-warning.p-button-text:enabled:active,
.p-button.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-warning > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-warning > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-warning > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-warning > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-warning.p-button-text:enabled:active,
.p-fileupload-choose.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):active {
  background: rgba(245, 158, 11, 0.16);
  border-color: transparent;
  color: #f59e0b;
}

.p-button.p-button-help,
.p-buttonset.p-button-help > .p-button,
.p-splitbutton.p-button-help > .p-button,
.p-fileupload-choose.p-button-help {
  color: #ffffff;
  background: #a855f7;
  border: 1px solid #a855f7;
}

.p-button.p-button-help:enabled:hover,
.p-button.p-button-help:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-help > .p-button:enabled:hover,
.p-buttonset.p-button-help > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-help > .p-button:enabled:hover,
.p-splitbutton.p-button-help > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-help:enabled:hover,
.p-fileupload-choose.p-button-help:not(button):not(a):not(.p-disabled):hover {
  background: #9333ea;
  color: #ffffff;
  border-color: #9333ea;
}

.p-button.p-button-help:enabled:focus,
.p-button.p-button-help:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-help > .p-button:enabled:focus,
.p-buttonset.p-button-help > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-help > .p-button:enabled:focus,
.p-splitbutton.p-button-help > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-help:enabled:focus,
.p-fileupload-choose.p-button-help:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0 0 0 0.2rem #e9d5ff;
}

.p-button.p-button-help:enabled:active,
.p-button.p-button-help:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-help > .p-button:enabled:active,
.p-buttonset.p-button-help > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-help > .p-button:enabled:active,
.p-splitbutton.p-button-help > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-help:enabled:active,
.p-fileupload-choose.p-button-help:not(button):not(a):not(.p-disabled):active {
  background: #7e22ce;
  color: #ffffff;
  border-color: #7e22ce;
}

.p-button.p-button-help.p-button-outlined,
.p-buttonset.p-button-help > .p-button.p-button-outlined,
.p-splitbutton.p-button-help > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-help.p-button-outlined {
  background-color: transparent;
  color: #a855f7;
  border: 1px solid;
}

.p-button.p-button-help.p-button-outlined:enabled:hover,
.p-button.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-help > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-help > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-help > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-help > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-help.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background: rgba(168, 85, 247, 0.04);
  color: #a855f7;
  border: 1px solid;
}

.p-button.p-button-help.p-button-outlined:enabled:active,
.p-button.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-help > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-help > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-help > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-help > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-help.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: rgba(168, 85, 247, 0.16);
  color: #a855f7;
  border: 1px solid;
}

.p-button.p-button-help.p-button-text,
.p-buttonset.p-button-help > .p-button.p-button-text,
.p-splitbutton.p-button-help > .p-button.p-button-text,
.p-fileupload-choose.p-button-help.p-button-text {
  background-color: transparent;
  color: #a855f7;
  border-color: transparent;
}

.p-button.p-button-help.p-button-text:enabled:hover,
.p-button.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-help > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-help > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-help > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-help > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-help.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background: rgba(168, 85, 247, 0.04);
  border-color: transparent;
  color: #a855f7;
}

.p-button.p-button-help.p-button-text:enabled:active,
.p-button.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-help > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-help > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-help > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-help > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-help.p-button-text:enabled:active,
.p-fileupload-choose.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):active {
  background: rgba(168, 85, 247, 0.16);
  border-color: transparent;
  color: #a855f7;
}

.p-button.p-button-danger,
.p-buttonset.p-button-danger > .p-button,
.p-splitbutton.p-button-danger > .p-button,
.p-fileupload-choose.p-button-danger {
  color: #ffffff;
  background: #ef4444;
  border: 1px solid #ef4444;
}

.p-button.p-button-danger:enabled:hover,
.p-button.p-button-danger:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-danger > .p-button:enabled:hover,
.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-danger > .p-button:enabled:hover,
.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-danger:enabled:hover,
.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):hover {
  background: #dc2626;
  color: #ffffff;
  border-color: #dc2626;
}

.p-button.p-button-danger:enabled:focus,
.p-button.p-button-danger:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-danger > .p-button:enabled:focus,
.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-danger > .p-button:enabled:focus,
.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-danger:enabled:focus,
.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0 0 0 0.2rem #fecaca;
}

.p-button.p-button-danger:enabled:active,
.p-button.p-button-danger:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-danger > .p-button:enabled:active,
.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-danger > .p-button:enabled:active,
.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-danger:enabled:active,
.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):active {
  background: #b91c1c;
  color: #ffffff;
  border-color: #b91c1c;
}

.p-button.p-button-danger.p-button-outlined,
.p-buttonset.p-button-danger > .p-button.p-button-outlined,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-danger.p-button-outlined {
  background-color: transparent;
  color: #ef4444;
  border: 1px solid;
}

.p-button.p-button-danger.p-button-outlined:enabled:hover,
.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background: rgba(239, 68, 68, 0.04);
  color: #ef4444;
  border: 1px solid;
}

.p-button.p-button-danger.p-button-outlined:enabled:active,
.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: rgba(239, 68, 68, 0.16);
  color: #ef4444;
  border: 1px solid;
}

.p-button.p-button-danger.p-button-text,
.p-buttonset.p-button-danger > .p-button.p-button-text,
.p-splitbutton.p-button-danger > .p-button.p-button-text,
.p-fileupload-choose.p-button-danger.p-button-text {
  background-color: transparent;
  color: #ef4444;
  border-color: transparent;
}

.p-button.p-button-danger.p-button-text:enabled:hover,
.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-danger > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-danger > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-danger.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background: rgba(239, 68, 68, 0.04);
  border-color: transparent;
  color: #ef4444;
}

.p-button.p-button-danger.p-button-text:enabled:active,
.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-danger > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-danger > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-danger.p-button-text:enabled:active,
.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active {
  background: rgba(239, 68, 68, 0.16);
  border-color: transparent;
  color: #ef4444;
}

.p-button.p-button-link {
  color: #4338ca;
  background: transparent;
  border: transparent;
}

.p-button.p-button-link:enabled:hover,
.p-button.p-button-link:not(button):not(a):not(.p-disabled):hover {
  background: transparent;
  color: #4338ca;
  border-color: transparent;
}

.p-button.p-button-link:enabled:hover .p-button-label,
.p-button.p-button-link:not(button):not(a):not(.p-disabled):hover .p-button-label {
  text-decoration: underline;
}

.p-button.p-button-link:enabled:focus,
.p-button.p-button-link:not(button):not(a):not(.p-disabled):focus {
  background: transparent;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: transparent;
}

.p-button.p-button-link:enabled:active,
.p-button.p-button-link:not(button):not(a):not(.p-disabled):active {
  background: transparent;
  color: #4338ca;
  border-color: transparent;
}

.p-splitbutton {
  border-radius: 6px;
}

.p-splitbutton.p-button-outlined > .p-button {
  background-color: transparent;
  color: #6366f1;
  border: 1px solid;
}

.p-splitbutton.p-button-outlined > .p-button:enabled:hover,
.p-splitbutton.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(99, 102, 241, 0.04);
  color: #6366f1;
}

.p-splitbutton.p-button-outlined > .p-button:enabled:active,
.p-splitbutton.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(99, 102, 241, 0.16);
  color: #6366f1;
}

.p-splitbutton.p-button-outlined.p-button-plain > .p-button {
  color: #6c757d;
  border-color: #6c757d;
}

.p-splitbutton.p-button-outlined.p-button-plain > .p-button:enabled:hover,
.p-splitbutton.p-button-outlined.p-button-plain > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: #e9ecef;
  color: #6c757d;
}

.p-splitbutton.p-button-outlined.p-button-plain > .p-button:enabled:active,
.p-splitbutton.p-button-outlined.p-button-plain > .p-button:not(button):not(a):not(.p-disabled):active {
  background: #dee2e6;
  color: #6c757d;
}

.p-splitbutton.p-button-text > .p-button {
  background-color: transparent;
  color: #6366f1;
  border-color: transparent;
}

.p-splitbutton.p-button-text > .p-button:enabled:hover,
.p-splitbutton.p-button-text > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(99, 102, 241, 0.04);
  color: #6366f1;
  border-color: transparent;
}

.p-splitbutton.p-button-text > .p-button:enabled:active,
.p-splitbutton.p-button-text > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(99, 102, 241, 0.16);
  color: #6366f1;
  border-color: transparent;
}

.p-splitbutton.p-button-text.p-button-plain > .p-button {
  color: #6c757d;
}

.p-splitbutton.p-button-text.p-button-plain > .p-button:enabled:hover,
.p-splitbutton.p-button-text.p-button-plain > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: #e9ecef;
  color: #6c757d;
}

.p-splitbutton.p-button-text.p-button-plain > .p-button:enabled:active,
.p-splitbutton.p-button-text.p-button-plain > .p-button:not(button):not(a):not(.p-disabled):active {
  background: #dee2e6;
  color: #6c757d;
}

.p-splitbutton.p-button-raised {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.p-splitbutton.p-button-rounded {
  border-radius: 2rem;
}

.p-splitbutton.p-button-rounded > .p-button {
  border-radius: 2rem;
}

.p-splitbutton.p-button-sm > .p-button {
  font-size: 0.875rem;
  padding: 0.65625rem 1.09375rem;
}

.p-splitbutton.p-button-sm > .p-button .p-button-icon {
  font-size: 0.875rem;
}

.p-splitbutton.p-button-lg > .p-button {
  font-size: 1.25rem;
  padding: 0.9375rem 1.5625rem;
}

.p-splitbutton.p-button-lg > .p-button.p-button-icon-only {
  width: auto;
}

.p-splitbutton.p-button-lg > .p-button .p-button-icon {
  font-size: 1.25rem;
}

.p-splitbutton.p-button-secondary.p-button-outlined > .p-button {
  background-color: transparent;
  color: #64748b;
  border: 1px solid;
}

.p-splitbutton.p-button-secondary.p-button-outlined > .p-button:enabled:hover,
.p-splitbutton.p-button-secondary.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(100, 116, 139, 0.04);
  color: #64748b;
}

.p-splitbutton.p-button-secondary.p-button-outlined > .p-button:enabled:active,
.p-splitbutton.p-button-secondary.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(100, 116, 139, 0.16);
  color: #64748b;
}

.p-splitbutton.p-button-secondary.p-button-text > .p-button {
  background-color: transparent;
  color: #64748b;
  border-color: transparent;
}

.p-splitbutton.p-button-secondary.p-button-text > .p-button:enabled:hover,
.p-splitbutton.p-button-secondary.p-button-text > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(100, 116, 139, 0.04);
  border-color: transparent;
  color: #64748b;
}

.p-splitbutton.p-button-secondary.p-button-text > .p-button:enabled:active,
.p-splitbutton.p-button-secondary.p-button-text > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(100, 116, 139, 0.16);
  border-color: transparent;
  color: #64748b;
}

.p-splitbutton.p-button-info.p-button-outlined > .p-button {
  background-color: transparent;
  color: #3b82f6;
  border: 1px solid;
}

.p-splitbutton.p-button-info.p-button-outlined > .p-button:enabled:hover,
.p-splitbutton.p-button-info.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(59, 130, 246, 0.04);
  color: #3b82f6;
}

.p-splitbutton.p-button-info.p-button-outlined > .p-button:enabled:active,
.p-splitbutton.p-button-info.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(59, 130, 246, 0.16);
  color: #3b82f6;
}

.p-splitbutton.p-button-info.p-button-text > .p-button {
  background-color: transparent;
  color: #3b82f6;
  border-color: transparent;
}

.p-splitbutton.p-button-info.p-button-text > .p-button:enabled:hover,
.p-splitbutton.p-button-info.p-button-text > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(59, 130, 246, 0.04);
  border-color: transparent;
  color: #3b82f6;
}

.p-splitbutton.p-button-info.p-button-text > .p-button:enabled:active,
.p-splitbutton.p-button-info.p-button-text > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(59, 130, 246, 0.16);
  border-color: transparent;
  color: #3b82f6;
}

.p-splitbutton.p-button-success.p-button-outlined > .p-button {
  background-color: transparent;
  color: #22c55e;
  border: 1px solid;
}

.p-splitbutton.p-button-success.p-button-outlined > .p-button:enabled:hover,
.p-splitbutton.p-button-success.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(34, 197, 94, 0.04);
  color: #22c55e;
}

.p-splitbutton.p-button-success.p-button-outlined > .p-button:enabled:active,
.p-splitbutton.p-button-success.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(34, 197, 94, 0.16);
  color: #22c55e;
}

.p-splitbutton.p-button-success.p-button-text > .p-button {
  background-color: transparent;
  color: #22c55e;
  border-color: transparent;
}

.p-splitbutton.p-button-success.p-button-text > .p-button:enabled:hover,
.p-splitbutton.p-button-success.p-button-text > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(34, 197, 94, 0.04);
  border-color: transparent;
  color: #22c55e;
}

.p-splitbutton.p-button-success.p-button-text > .p-button:enabled:active,
.p-splitbutton.p-button-success.p-button-text > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(34, 197, 94, 0.16);
  border-color: transparent;
  color: #22c55e;
}

.p-splitbutton.p-button-warning.p-button-outlined > .p-button {
  background-color: transparent;
  color: #f59e0b;
  border: 1px solid;
}

.p-splitbutton.p-button-warning.p-button-outlined > .p-button:enabled:hover,
.p-splitbutton.p-button-warning.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(245, 158, 11, 0.04);
  color: #f59e0b;
}

.p-splitbutton.p-button-warning.p-button-outlined > .p-button:enabled:active,
.p-splitbutton.p-button-warning.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(245, 158, 11, 0.16);
  color: #f59e0b;
}

.p-splitbutton.p-button-warning.p-button-text > .p-button {
  background-color: transparent;
  color: #f59e0b;
  border-color: transparent;
}

.p-splitbutton.p-button-warning.p-button-text > .p-button:enabled:hover,
.p-splitbutton.p-button-warning.p-button-text > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(245, 158, 11, 0.04);
  border-color: transparent;
  color: #f59e0b;
}

.p-splitbutton.p-button-warning.p-button-text > .p-button:enabled:active,
.p-splitbutton.p-button-warning.p-button-text > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(245, 158, 11, 0.16);
  border-color: transparent;
  color: #f59e0b;
}

.p-splitbutton.p-button-help.p-button-outlined > .p-button {
  background-color: transparent;
  color: #a855f7;
  border: 1px solid;
}

.p-splitbutton.p-button-help.p-button-outlined > .p-button:enabled:hover,
.p-splitbutton.p-button-help.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(168, 85, 247, 0.04);
  color: #a855f7;
}

.p-splitbutton.p-button-help.p-button-outlined > .p-button:enabled:active,
.p-splitbutton.p-button-help.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(168, 85, 247, 0.16);
  color: #a855f7;
}

.p-splitbutton.p-button-help.p-button-text > .p-button {
  background-color: transparent;
  color: #a855f7;
  border-color: transparent;
}

.p-splitbutton.p-button-help.p-button-text > .p-button:enabled:hover,
.p-splitbutton.p-button-help.p-button-text > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(168, 85, 247, 0.04);
  border-color: transparent;
  color: #a855f7;
}

.p-splitbutton.p-button-help.p-button-text > .p-button:enabled:active,
.p-splitbutton.p-button-help.p-button-text > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(168, 85, 247, 0.16);
  border-color: transparent;
  color: #a855f7;
}

.p-splitbutton.p-button-danger.p-button-outlined > .p-button {
  background-color: transparent;
  color: #ef4444;
  border: 1px solid;
}

.p-splitbutton.p-button-danger.p-button-outlined > .p-button:enabled:hover,
.p-splitbutton.p-button-danger.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(239, 68, 68, 0.04);
  color: #ef4444;
}

.p-splitbutton.p-button-danger.p-button-outlined > .p-button:enabled:active,
.p-splitbutton.p-button-danger.p-button-outlined > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(239, 68, 68, 0.16);
  color: #ef4444;
}

.p-splitbutton.p-button-danger.p-button-text > .p-button {
  background-color: transparent;
  color: #ef4444;
  border-color: transparent;
}

.p-splitbutton.p-button-danger.p-button-text > .p-button:enabled:hover,
.p-splitbutton.p-button-danger.p-button-text > .p-button:not(button):not(a):not(.p-disabled):hover {
  background: rgba(239, 68, 68, 0.04);
  border-color: transparent;
  color: #ef4444;
}

.p-splitbutton.p-button-danger.p-button-text > .p-button:enabled:active,
.p-splitbutton.p-button-danger.p-button-text > .p-button:not(button):not(a):not(.p-disabled):active {
  background: rgba(239, 68, 68, 0.16);
  border-color: transparent;
  color: #ef4444;
}

.p-speeddial-button.p-button.p-button-icon-only {
  width: 4rem;
  height: 4rem;
}

.p-speeddial-button.p-button.p-button-icon-only .p-button-icon {
  font-size: 1.3rem;
}

.p-speeddial-button.p-button.p-button-icon-only .p-button-icon.p-icon {
  width: 1.3rem;
  height: 1.3rem;
}

.p-speeddial-action {
  width: 3rem;
  height: 3rem;
  background: #495057;
  color: #fff;
}

.p-speeddial-action:hover {
  background: #022354;
  color: #fff;
}

.p-speeddial-direction-up .p-speeddial-item {
  margin: 0.25rem;
}

.p-speeddial-direction-up .p-speeddial-item:first-child {
  margin-bottom: 0.5rem;
}

.p-speeddial-direction-down .p-speeddial-item {
  margin: 0.25rem;
}

.p-speeddial-direction-down .p-speeddial-item:first-child {
  margin-top: 0.5rem;
}

.p-speeddial-direction-left .p-speeddial-item {
  margin: 0 0.25rem;
}

.p-speeddial-direction-left .p-speeddial-item:first-child {
  margin-right: 0.5rem;
}

.p-speeddial-direction-right .p-speeddial-item {
  margin: 0 0.25rem;
}

.p-speeddial-direction-right .p-speeddial-item:first-child {
  margin-left: 0.5rem;
}

.p-speeddial-circle .p-speeddial-item,
.p-speeddial-semi-circle .p-speeddial-item,
.p-speeddial-quarter-circle .p-speeddial-item {
  margin: 0;
}

.p-speeddial-circle .p-speeddial-item:first-child,
.p-speeddial-circle .p-speeddial-item:last-child,
.p-speeddial-semi-circle .p-speeddial-item:first-child,
.p-speeddial-semi-circle .p-speeddial-item:last-child,
.p-speeddial-quarter-circle .p-speeddial-item:first-child,
.p-speeddial-quarter-circle .p-speeddial-item:last-child {
  margin: 0;
}

.p-speeddial-mask {
  background-color: rgba(0, 0, 0, 0.4);
}

.p-carousel .p-carousel-content .p-carousel-prev,
.p-carousel .p-carousel-content .p-carousel-next {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  margin: 0.5rem;
}

.p-carousel .p-carousel-content .p-carousel-prev:enabled:hover,
.p-carousel .p-carousel-content .p-carousel-next:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-carousel .p-carousel-content .p-carousel-prev:focus,
.p-carousel .p-carousel-content .p-carousel-next:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-carousel .p-carousel-indicators {
  padding: 1rem;
}

.p-carousel .p-carousel-indicators .p-carousel-indicator {
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}

.p-carousel .p-carousel-indicators .p-carousel-indicator button {
  background-color: #ced4da;
  width: 2rem;
  height: 0.5rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 0;
}

.p-carousel .p-carousel-indicators .p-carousel-indicator button:hover {
  background: #adb5bd;
}

.p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {
  background: #eef2ff;
  color: #4338ca;
}

.p-datatable .p-paginator-top {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-datatable .p-paginator-bottom {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-datatable .p-datatable-header {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 1px 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
}

.p-datatable .p-datatable-footer {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
}

.p-datatable .p-datatable-thead > tr > th {
  text-align: left;
  padding: 1rem 1rem;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  font-weight: 700;
  color: #343a40;
  background: #f8f9fa;
  transition: box-shadow 0.2s;
}

.p-datatable .p-datatable-tfoot > tr > td {
  text-align: left;
  padding: 1rem 1rem;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  font-weight: 700;
  color: #343a40;
  background: #f8f9fa;
}

.p-datatable .p-sortable-column .p-sortable-column-icon {
  color: #343a40;
  margin-left: 0.5rem;
}

.p-datatable .p-sortable-column .p-sortable-column-badge {
  border-radius: 50%;
  height: 1.143rem;
  min-width: 1.143rem;
  line-height: 1.143rem;
  color: #4338ca;
  background: #eef2ff;
  margin-left: 0.5rem;
}

.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover {
  background: #e9ecef;
  color: #343a40;
}

.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover .p-sortable-column-icon {
  color: #343a40;
}

.p-datatable .p-sortable-column.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
  color: #4338ca;
}

.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover {
  background: #eef2ff;
  color: #4338ca;
}

.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon {
  color: #4338ca;
}

.p-datatable .p-sortable-column:focus {
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
  outline: 0 none;
}

.p-datatable .p-datatable-tbody > tr {
  background: #ffffff;
  color: #495057;
  transition: box-shadow 0.2s;
}

.p-datatable .p-datatable-tbody > tr > td {
  text-align: left;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  padding: 1rem 1rem;
}

.p-datatable .p-datatable-tbody > tr > td .p-row-toggler,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:enabled:hover,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:enabled:hover,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:enabled:hover,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:focus,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:focus,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:focus,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save {
  margin-right: 0.5rem;
}

.p-datatable .p-datatable-tbody > tr > td > .p-column-title {
  font-weight: 700;
}

.p-datatable .p-datatable-tbody > tr > td.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-datatable .p-datatable-tbody > tr.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-top > td {
  box-shadow: inset 0 2px 0 0 #eef2ff;
}

.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-bottom > td {
  box-shadow: inset 0 -2px 0 0 #eef2ff;
}

.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {
  background: #e9ecef;
  color: #495057;
}

.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:focus {
  outline: 0.15rem solid #c7d2fe;
  outline-offset: -0.15rem;
}

.p-datatable.p-datatable-selectable-cell .p-datatable-tbody > tr.p-selectable-row > td.p-selectable-cell:not(.p-highlight):hover {
  background: #e9ecef;
  color: #495057;
}

.p-datatable.p-datatable-selectable-cell .p-datatable-tbody > tr.p-selectable-row > td.p-selectable-cell:focus {
  outline: 0.15rem solid #c7d2fe;
  outline-offset: -0.15rem;
}

.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody > tr:not(.p-highlight):not(.p-datatable-emptymessage):hover {
  background: #e9ecef;
  color: #495057;
}

.p-datatable .p-column-resizer-helper {
  background: #6366f1;
}

.p-datatable .p-datatable-scrollable-header,
.p-datatable .p-datatable-scrollable-footer {
  background: #f8f9fa;
}

.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-datatable-table > .p-datatable-thead,
.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-datatable-table > .p-datatable-tfoot,
.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-virtualscroller > .p-datatable-table > .p-datatable-thead,
.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-virtualscroller > .p-datatable-table > .p-datatable-tfoot {
  background-color: #f8f9fa;
}

.p-datatable .p-datatable-loading-icon {
  font-size: 2rem;
}

.p-datatable .p-datatable-loading-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-datatable.p-datatable-gridlines .p-datatable-header {
  border-width: 1px 1px 0 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-footer {
  border-width: 0 1px 1px 1px;
}

.p-datatable.p-datatable-gridlines .p-paginator-top {
  border-width: 0 1px 0 1px;
}

.p-datatable.p-datatable-gridlines .p-paginator-bottom {
  border-width: 0 1px 1px 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th {
  border-width: 1px 0 1px 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th:last-child {
  border-width: 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td {
  border-width: 1px 0 0 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td:last-child {
  border-width: 1px 1px 0 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr:last-child > td {
  border-width: 1px 0 1px 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr:last-child > td:last-child {
  border-width: 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-tfoot > tr > td {
  border-width: 1px 0 1px 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-tfoot > tr > td:last-child {
  border-width: 1px 1px 1px 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-thead + .p-datatable-tfoot > tr > td {
  border-width: 0 0 1px 1px;
}

.p-datatable.p-datatable-gridlines .p-datatable-thead + .p-datatable-tfoot > tr > td:last-child {
  border-width: 0 1px 1px 1px;
}

.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody > tr > td {
  border-width: 0 0 1px 1px;
}

.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody > tr > td:last-child {
  border-width: 0 1px 1px 1px;
}

.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody > tr:last-child > td {
  border-width: 0 0 0 1px;
}

.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody > tr:last-child > td:last-child {
  border-width: 0 1px 0 1px;
}

.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd {
  background: #fcfcfc;
}

.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight .p-row-toggler {
  color: #4338ca;
}

.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight .p-row-toggler:hover {
  color: #4338ca;
}

.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd + .p-row-expanded {
  background: #fcfcfc;
}

.p-datatable.p-datatable-sm .p-datatable-header {
  padding: 0.5rem 0.5rem;
}

.p-datatable.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 0.5rem 0.5rem;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 0.5rem 0.5rem;
}

.p-datatable.p-datatable-sm .p-datatable-tfoot > tr > td {
  padding: 0.5rem 0.5rem;
}

.p-datatable.p-datatable-sm .p-datatable-footer {
  padding: 0.5rem 0.5rem;
}

.p-datatable.p-datatable-lg .p-datatable-header {
  padding: 1.25rem 1.25rem;
}

.p-datatable.p-datatable-lg .p-datatable-thead > tr > th {
  padding: 1.25rem 1.25rem;
}

.p-datatable.p-datatable-lg .p-datatable-tbody > tr > td {
  padding: 1.25rem 1.25rem;
}

.p-datatable.p-datatable-lg .p-datatable-tfoot > tr > td {
  padding: 1.25rem 1.25rem;
}

.p-datatable.p-datatable-lg .p-datatable-footer {
  padding: 1.25rem 1.25rem;
}

.p-datatable-drag-selection-helper {
  background: rgba(99, 102, 241, 0.16);
}

.p-dataview .p-paginator-top {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-dataview .p-paginator-bottom {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-dataview .p-dataview-header {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 1px 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
}

.p-dataview .p-dataview-content {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  padding: 0;
}

.p-dataview.p-dataview-list .p-dataview-content > .p-grid > div {
  border: solid #dee2e6;
  border-width: 0 0 1px 0;
}

.p-dataview .p-dataview-footer {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-dataview .p-dataview-loading-icon {
  font-size: 2rem;
}

.p-dataview .p-dataview-loading-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-datascroller .p-paginator-top {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-datascroller .p-paginator-bottom {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-datascroller .p-datascroller-header {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 1px 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
}

.p-datascroller .p-datascroller-content {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  padding: 0;
}

.p-datascroller.p-datascroller-inline .p-datascroller-list > li {
  border: solid #dee2e6;
  border-width: 0 0 1px 0;
}

.p-datascroller .p-datascroller-footer {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-column-filter-row .p-column-filter-menu-button,
.p-column-filter-row .p-column-filter-clear-button {
  margin-left: 0.5rem;
}

.p-column-filter-menu-button {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-column-filter-menu-button:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-column-filter-menu-button.p-column-filter-menu-button-open,
.p-column-filter-menu-button.p-column-filter-menu-button-open:hover {
  background: #e9ecef;
  color: #343a40;
}

.p-column-filter-menu-button.p-column-filter-menu-button-active,
.p-column-filter-menu-button.p-column-filter-menu-button-active:hover {
  background: #eef2ff;
  color: #4338ca;
}

.p-column-filter-menu-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-column-filter-clear-button {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-column-filter-clear-button:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-column-filter-clear-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-column-filter-overlay {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 12.5rem;
}

.p-column-filter-overlay .p-column-filter-row-items {
  padding: 0.75rem 0;
}

.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item {
  margin: 0;
  padding: 0.75rem 1.25rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:not(.p-highlight):not(.p-disabled):hover {
  color: #495057;
  background: #e9ecef;
}

.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-column-filter-overlay-menu .p-column-filter-operator {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #dee2e6;
  color: #343a40;
  background: #f8f9fa;
  margin: 0;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-column-filter-overlay-menu .p-column-filter-constraint {
  padding: 1.25rem;
  border-bottom: 1px solid #dee2e6;
}

.p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-matchmode-dropdown {
  margin-bottom: 0.5rem;
}

.p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-remove-button {
  margin-top: 0.5rem;
}

.p-column-filter-overlay-menu .p-column-filter-constraint:last-child {
  border-bottom: 0 none;
}

.p-column-filter-overlay-menu .p-column-filter-add-rule {
  padding: 0.75rem 1.25rem;
}

.p-column-filter-overlay-menu .p-column-filter-buttonbar {
  padding: 1.25rem;
}

.fc {
  /* FullCalendar 4 */
  /* FullCalendar 5 */
}

.fc.fc-unthemed .fc-view-container th {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #343a40;
}

.fc.fc-unthemed .fc-view-container td.fc-widget-content {
  border: 1px solid #dee2e6;
  color: #495057;
}

.fc.fc-unthemed .fc-view-container td.fc-head-container {
  border: 1px solid #dee2e6;
}

.fc.fc-unthemed .fc-view-container .fc-view {
  background: #ffffff;
}

.fc.fc-unthemed .fc-view-container .fc-row {
  border-right: 1px solid #dee2e6;
}

.fc.fc-unthemed .fc-view-container .fc-event {
  background: #4f46e5;
  border: 1px solid #4f46e5;
  color: #ffffff;
}

.fc.fc-unthemed .fc-view-container .fc-divider {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.fc.fc-unthemed .fc-toolbar .fc-button {
  color: #ffffff;
  background: #6366f1;
  border: 1px solid #6366f1;
  font-size: 1rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.fc.fc-unthemed .fc-toolbar .fc-button:enabled:hover {
  background: #4f46e5;
  color: #ffffff;
  border-color: #4f46e5;
}

.fc.fc-unthemed .fc-toolbar .fc-button:enabled:active {
  background: #4338ca;
  color: #ffffff;
  border-color: #4338ca;
}

.fc.fc-unthemed .fc-toolbar .fc-button:enabled:active:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-left {
  font-family: "PrimeIcons" !important;
  text-indent: 0;
  font-size: 1rem;
}

.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-left:before {
  content: "\\e900";
}

.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-right {
  font-family: "PrimeIcons" !important;
  text-indent: 0;
  font-size: 1rem;
}

.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-right:before {
  content: "\\e901";
}

.fc.fc-unthemed .fc-toolbar .fc-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button {
  background: #ffffff;
  border: 1px solid #ced4da;
  color: #495057;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button:hover,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button:hover,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button:hover {
  background: #e9ecef;
  border-color: #ced4da;
  color: #495057;
}

.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active {
  background: #6366f1;
  border-color: #6366f1;
  color: #ffffff;
}

.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active:hover,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active:hover,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active:hover {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #ffffff;
}

.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button:focus,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button:focus,
.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  z-index: 1;
}

.fc.fc-unthemed .fc-toolbar .fc-button-group .fc-button {
  border-radius: 0;
}

.fc.fc-unthemed .fc-toolbar .fc-button-group .fc-button:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.fc.fc-unthemed .fc-toolbar .fc-button-group .fc-button:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.fc.fc-theme-standard .fc-view-harness .fc-scrollgrid {
  border-color: #dee2e6;
}

.fc.fc-theme-standard .fc-view-harness th {
  background: #f8f9fa;
  border-color: #dee2e6;
  color: #343a40;
}

.fc.fc-theme-standard .fc-view-harness td {
  color: #495057;
  border-color: #dee2e6;
}

.fc.fc-theme-standard .fc-view-harness .fc-view {
  background: #ffffff;
}

.fc.fc-theme-standard .fc-view-harness .fc-popover {
  background: none;
  border: 0 none;
}

.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header {
  border: 1px solid #dee2e6;
  padding: 1.25rem;
  background: #f8f9fa;
  color: #343a40;
}

.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close {
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-family: "PrimeIcons" !important;
  font-size: 1rem;
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close:before {
  content: "\\e90b";
}

.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-body {
  padding: 1.25rem;
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  border-top: 0 none;
}

.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-block-event {
  color: #ffffff;
  background: #4f46e5;
  border-color: #4f46e5;
}

.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-block-event .fc-event-main {
  color: #ffffff;
}

.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-dot-event .fc-daygrid-event-dot {
  background: #4f46e5;
  border-color: #4f46e5;
}

.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-dot-event:hover {
  background: #e9ecef;
  color: #495057;
}

.fc.fc-theme-standard .fc-view-harness .fc-cell-shaded {
  background: #f8f9fa;
}

.fc.fc-theme-standard .fc-toolbar .fc-button {
  color: #ffffff;
  background: #6366f1;
  border: 1px solid #6366f1;
  font-size: 1rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
}

.fc.fc-theme-standard .fc-toolbar .fc-button:enabled:hover {
  background: #4f46e5;
  color: #ffffff;
  border-color: #4f46e5;
}

.fc.fc-theme-standard .fc-toolbar .fc-button:enabled:active {
  background: #4338ca;
  color: #ffffff;
  border-color: #4338ca;
}

.fc.fc-theme-standard .fc-toolbar .fc-button:enabled:active:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.fc.fc-theme-standard .fc-toolbar .fc-button:disabled {
  opacity: 0.6;
  color: #ffffff;
  background: #6366f1;
  border: 1px solid #6366f1;
}

.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-left {
  font-family: "PrimeIcons" !important;
  text-indent: 0;
  font-size: 1rem;
}

.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-left:before {
  content: "\\e900";
}

.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-right {
  font-family: "PrimeIcons" !important;
  text-indent: 0;
  font-size: 1rem;
}

.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-right:before {
  content: "\\e901";
}

.fc.fc-theme-standard .fc-toolbar .fc-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button {
  background: #ffffff;
  border: 1px solid #ced4da;
  color: #495057;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button:hover,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button:hover,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button:hover {
  background: #e9ecef;
  border-color: #ced4da;
  color: #495057;
}

.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active {
  background: #6366f1;
  border-color: #6366f1;
  color: #ffffff;
}

.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active:hover,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active:hover,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active:hover {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #ffffff;
}

.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button:not(:disabled):focus,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button:not(:disabled):focus,
.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button:not(:disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  z-index: 1;
}

.fc.fc-theme-standard .fc-toolbar .fc-button-group .fc-button {
  border-radius: 0;
}

.fc.fc-theme-standard .fc-toolbar .fc-button-group .fc-button:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.fc.fc-theme-standard .fc-toolbar .fc-button-group .fc-button:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.fc.fc-theme-standard .fc-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-orderlist .p-orderlist-controls {
  padding: 1.25rem;
}

.p-orderlist .p-orderlist-controls .p-button {
  margin-bottom: 0.5rem;
}

.p-orderlist .p-orderlist-header {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  padding: 1.25rem;
  font-weight: 700;
  border-bottom: 0 none;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-orderlist .p-orderlist-filter-container {
  padding: 1.25rem;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-bottom: 0 none;
}

.p-orderlist .p-orderlist-filter-container .p-orderlist-filter-input {
  padding-right: 1.75rem;
}

.p-orderlist .p-orderlist-filter-container .p-orderlist-filter-icon {
  right: 0.75rem;
  color: #6c757d;
}

.p-orderlist .p-orderlist-list {
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  padding: 0.75rem 0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-orderlist .p-orderlist-list .p-orderlist-item {
  padding: 0.75rem 1.25rem;
  margin: 0;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: transform 0.2s, box-shadow 0.2s;
}

.p-orderlist .p-orderlist-list .p-orderlist-item:not(.p-highlight):hover {
  background: #e9ecef;
  color: #495057;
}

.p-orderlist .p-orderlist-list .p-orderlist-item:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-orderlist .p-orderlist-list .p-orderlist-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even) {
  background: #fcfcfc;
}

.p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even):hover {
  background: #e9ecef;
}

.p-organizationchart .p-organizationchart-node-content.p-organizationchart-selectable-node:not(.p-highlight):hover {
  background: #e9ecef;
  color: #495057;
}

.p-organizationchart .p-organizationchart-node-content.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-organizationchart .p-organizationchart-node-content.p-highlight .p-node-toggler i {
  color: #6f91ff;
}

.p-organizationchart .p-organizationchart-line-down {
  background: #dee2e6;
}

.p-organizationchart .p-organizationchart-line-left {
  border-right: 1px solid #dee2e6;
  border-color: #dee2e6;
}

.p-organizationchart .p-organizationchart-line-top {
  border-top: 1px solid #dee2e6;
  border-color: #dee2e6;
}

.p-organizationchart .p-organizationchart-node-content {
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  padding: 1.25rem;
}

.p-organizationchart .p-organizationchart-node-content .p-node-toggler {
  background: inherit;
  color: inherit;
  border-radius: 50%;
}

.p-organizationchart .p-organizationchart-node-content .p-node-toggler:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-paginator {
  background: #ffffff;
  color: #6c757d;
  border: solid #e9ecef;
  border-width: 0;
  padding: 0.5rem 1rem;
  border-radius: 6px;
}

.p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last {
  background-color: transparent;
  border: 0 none;
  color: #6c757d;
  min-width: 3rem;
  height: 3rem;
  margin: 0.143rem;
  transition: box-shadow 0.2s;
  border-radius: 50%;
}

.p-paginator .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
  background: #e9ecef;
  border-color: transparent;
  color: #343a40;
}

.p-paginator .p-paginator-first {
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
}

.p-paginator .p-paginator-last {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
}

.p-paginator .p-dropdown {
  margin-left: 0.5rem;
  height: 3rem;
}

.p-paginator .p-dropdown .p-dropdown-label {
  padding-right: 0;
}

.p-paginator .p-paginator-page-input {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.p-paginator .p-paginator-page-input .p-inputtext {
  max-width: 3rem;
}

.p-paginator .p-paginator-current {
  background-color: transparent;
  border: 0 none;
  color: #6c757d;
  min-width: 3rem;
  height: 3rem;
  margin: 0.143rem;
  padding: 0 0.5rem;
}

.p-paginator .p-paginator-pages .p-paginator-page {
  background-color: transparent;
  border: 0 none;
  color: #6c757d;
  min-width: 3rem;
  height: 3rem;
  margin: 0.143rem;
  transition: box-shadow 0.2s;
  border-radius: 50%;
}

.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
  background: #eef2ff;
  border-color: #eef2ff;
  color: #4338ca;
}

.p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {
  background: #e9ecef;
  border-color: transparent;
  color: #343a40;
}

.p-picklist .p-picklist-buttons {
  padding: 1.25rem;
}

.p-picklist .p-picklist-buttons .p-button {
  margin-bottom: 0.5rem;
}

.p-picklist .p-picklist-header {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  padding: 1.25rem;
  font-weight: 700;
  border-bottom: 0 none;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-picklist .p-picklist-filter-container {
  padding: 1.25rem;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-bottom: 0 none;
}

.p-picklist .p-picklist-filter-container .p-picklist-filter-input {
  padding-right: 1.75rem;
}

.p-picklist .p-picklist-filter-container .p-picklist-filter-icon {
  right: 0.75rem;
  color: #6c757d;
}

.p-picklist .p-picklist-list {
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  padding: 0.75rem 0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-picklist .p-picklist-list .p-picklist-item {
  padding: 0.75rem 1.25rem;
  margin: 0;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: transform 0.2s, box-shadow 0.2s;
}

.p-picklist .p-picklist-list .p-picklist-item:not(.p-highlight):hover {
  background: #e9ecef;
  color: #495057;
}

.p-picklist .p-picklist-list .p-picklist-item:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-picklist .p-picklist-list .p-picklist-item.p-highlight {
  color: #4338ca;
  background: #eef2ff;
}

.p-tree {
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  padding: 1.25rem;
  border-radius: 6px;
}

.p-tree .p-tree-container .p-treenode {
  padding: 0.143rem;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content {
  border-radius: 6px;
  transition: box-shadow 0.2s;
  padding: 0.5rem;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
  margin-right: 0.5rem;
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon {
  margin-right: 0.5rem;
  color: #6c757d;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox {
  margin-right: 0.5rem;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox .p-indeterminate .p-checkbox-icon {
  color: #495057;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler,
.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon {
  color: #4338ca;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler:hover,
.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon:hover {
  color: #4338ca;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover {
  background: #e9ecef;
  color: #495057;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-dragover {
  background: #e9ecef;
  color: #495057;
}

.p-tree .p-tree-filter-container {
  margin-bottom: 0.5rem;
}

.p-tree .p-tree-filter-container .p-tree-filter {
  width: 100%;
  padding-right: 1.75rem;
}

.p-tree .p-tree-filter-container .p-tree-filter-icon {
  right: 0.75rem;
  color: #6c757d;
}

.p-tree .p-treenode-children {
  padding: 0 0 0 1rem;
}

.p-tree .p-tree-loading-icon {
  font-size: 2rem;
}

.p-tree .p-tree-loading-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-tree .p-treenode-droppoint {
  height: 0.5rem;
}

.p-tree .p-treenode-droppoint.p-treenode-droppoint-active {
  background: #8ba7ff;
}

.p-treetable .p-paginator-top {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-treetable .p-paginator-bottom {
  border-width: 0 0 1px 0;
  border-radius: 0;
}

.p-treetable .p-treetable-header {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 1px 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
}

.p-treetable .p-treetable-footer {
  background: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 700;
}

.p-treetable .p-treetable-thead > tr > th {
  text-align: left;
  padding: 1rem 1rem;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  font-weight: 700;
  color: #343a40;
  background: #f8f9fa;
  transition: box-shadow 0.2s;
}

.p-treetable .p-treetable-tfoot > tr > td {
  text-align: left;
  padding: 1rem 1rem;
  border: 1px solid #dee2e6;
  border-width: 0 0 1px 0;
  font-weight: 700;
  color: #343a40;
  background: #f8f9fa;
}

.p-treetable .p-sortable-column {
  outline-color: #c7d2fe;
}

.p-treetable .p-sortable-column .p-sortable-column-icon {
  color: #343a40;
  margin-left: 0.5rem;
}

.p-treetable .p-sortable-column .p-sortable-column-badge {
  border-radius: 50%;
  height: 1.143rem;
  min-width: 1.143rem;
  line-height: 1.143rem;
  color: #4338ca;
  background: #eef2ff;
  margin-left: 0.5rem;
}

.p-treetable .p-sortable-column:not(.p-highlight):hover {
  background: #e9ecef;
  color: #343a40;
}

.p-treetable .p-sortable-column:not(.p-highlight):hover .p-sortable-column-icon {
  color: #343a40;
}

.p-treetable .p-sortable-column.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-treetable .p-sortable-column.p-highlight .p-sortable-column-icon {
  color: #4338ca;
}

.p-treetable .p-treetable-tbody > tr {
  background: #ffffff;
  color: #495057;
  transition: box-shadow 0.2s;
}

.p-treetable .p-treetable-tbody > tr > td {
  text-align: left;
  border: 1px solid #acacac;
  border-width: 0 0 1px 0;
  padding: 1rem 1rem;
}

.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  margin-right: 0.5rem;
}

.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler + .p-checkbox {
  margin-right: 0.5rem;
}

.p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler + .p-checkbox .p-indeterminate .p-checkbox-icon {
  color: #495057;
}

.p-treetable .p-treetable-tbody > tr:focus {
  outline: 0.15rem solid #c7d2fe;
  outline-offset: -0.15rem;
}

.p-treetable .p-treetable-tbody > tr.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-treetable .p-treetable-tbody > tr.p-highlight .p-treetable-toggler {
  color: #4338ca;
}

.p-treetable .p-treetable-tbody > tr.p-highlight .p-treetable-toggler:hover {
  color: #4338ca;
}

.p-treetable.p-treetable-selectable .p-treetable-tbody > tr:not(.p-highlight):hover,
.p-treetable.p-treetable-hoverable-rows .p-treetable-tbody > tr:not(.p-highlight):hover {
  background: #e9ecef;
  color: #495057;
}

.p-treetable.p-treetable-selectable .p-treetable-tbody > tr:not(.p-highlight):hover .p-treetable-toggler,
.p-treetable.p-treetable-hoverable-rows .p-treetable-tbody > tr:not(.p-highlight):hover .p-treetable-toggler {
  color: #495057;
}

.p-treetable .p-column-resizer-helper {
  background: #6366f1;
}

.p-treetable .p-treetable-scrollable-header,
.p-treetable .p-treetable-scrollable-footer {
  background: #f8f9fa;
}

.p-treetable .p-treetable-loading-icon {
  font-size: 2rem;
}

.p-treetable .p-treetable-loading-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-treetable.p-treetable-gridlines .p-treetable-header {
  border-width: 1px 1px 0 1px;
}

.p-treetable.p-treetable-gridlines .p-treetable-footer {
  border-width: 0 1px 1px 1px;
}

.p-treetable.p-treetable-gridlines .p-treetable-top {
  border-width: 0 1px 0 1px;
}

.p-treetable.p-treetable-gridlines .p-treetable-bottom {
  border-width: 0 1px 1px 1px;
}

.p-treetable.p-treetable-gridlines .p-treetable-thead > tr > th {
  border-width: 1px;
}

.p-treetable.p-treetable-gridlines .p-treetable-tbody > tr > td {
  border-width: 1px;
}

.p-treetable.p-treetable-gridlines .p-treetable-tfoot > tr > td {
  border-width: 1px;
}

.p-treetable.p-treetable-striped .p-treetable-tbody > tr.p-row-odd {
  background: #fcfcfc;
}

.p-treetable.p-treetable-striped .p-treetable-tbody > tr.p-row-odd.p-highlight {
  background: #eef2ff;
  color: #4338ca;
}

.p-treetable.p-treetable-striped .p-treetable-tbody > tr.p-row-odd.p-highlight .p-row-toggler {
  color: #4338ca;
}

.p-treetable.p-treetable-striped .p-treetable-tbody > tr.p-row-odd.p-highlight .p-row-toggler:hover {
  color: #4338ca;
}

.p-treetable.p-treetable-striped .p-treetable-tbody > tr.p-row-odd + .p-row-expanded {
  background: #fcfcfc;
}

.p-treetable.p-treetable-sm .p-treetable-header {
  padding: 0.875rem 0.875rem;
}

.p-treetable.p-treetable-sm .p-treetable-thead > tr > th {
  padding: 0.5rem 0.5rem;
}

.p-treetable.p-treetable-sm .p-treetable-tbody > tr > td {
  padding: 0.5rem 0.5rem;
}

.p-treetable.p-treetable-sm .p-treetable-tfoot > tr > td {
  padding: 0.5rem 0.5rem;
}

.p-treetable.p-treetable-sm .p-treetable-footer {
  padding: 0.5rem 0.5rem;
}

.p-treetable.p-treetable-lg .p-treetable-header {
  padding: 1.25rem 1.25rem;
}

.p-treetable.p-treetable-lg .p-treetable-thead > tr > th {
  padding: 1.25rem 1.25rem;
}

.p-treetable.p-treetable-lg .p-treetable-tbody > tr > td {
  padding: 1.25rem 1.25rem;
}

.p-treetable.p-treetable-lg .p-treetable-tfoot > tr > td {
  padding: 1.25rem 1.25rem;
}

.p-treetable.p-treetable-lg .p-treetable-footer {
  padding: 1.25rem 1.25rem;
}

.p-timeline .p-timeline-event-marker {
  border: 2px solid #6366f1;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  background-color: #ffffff;
}

.p-timeline .p-timeline-event-connector {
  background-color: #dee2e6;
}

.p-timeline.p-timeline-vertical .p-timeline-event-opposite,
.p-timeline.p-timeline-vertical .p-timeline-event-content {
  padding: 0 1rem;
}

.p-timeline.p-timeline-vertical .p-timeline-event-connector {
  width: 2px;
}

.p-timeline.p-timeline-horizontal .p-timeline-event-opposite,
.p-timeline.p-timeline-horizontal .p-timeline-event-content {
  padding: 1rem 0;
}

.p-timeline.p-timeline-horizontal .p-timeline-event-connector {
  height: 2px;
}

.p-accordion .p-accordion-header .p-accordion-header-link {
  padding: 1.25rem;
  border: 1px solid #dee2e6;
  color: #6c757d;
  background: #f8f9fa;
  font-weight: 700;
  border-radius: 6px;
  transition: box-shadow 0.2s;
}

.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
  margin-right: 0.5rem;
}

.p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
  background: #e9ecef;
  border-color: #dee2e6;
  color: #343a40;
}

.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
  background: #f8f9fa;
  border-color: #dee2e6;
  color: #343a40;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.p-accordion .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {
  border-color: #dee2e6;
  background: #e9ecef;
  color: #343a40;
}

.p-accordion .p-accordion-content {
  padding: 1.25rem;
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  border-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-accordion .p-accordion-tab {
  margin-bottom: 4px;
}

.p-card {
  background: #ffffff;
  color: #495057;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  border-radius: 6px;
}

.p-card .p-card-body {
  padding: 1.25rem;
}

.p-card .p-card-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.p-card .p-card-subtitle {
  font-weight: 400;
  margin-bottom: 0.5rem;
  color: #6c757d;
}

.p-card .p-card-content {
  padding: 1.25rem 0;
}

.p-card .p-card-footer {
  padding: 1.25rem 0 0 0;
}

.p-fieldset {
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  border-radius: 6px;
}

.p-fieldset .p-fieldset-legend {
  padding: 1.25rem;
  border: 1px solid #dee2e6;
  color: #343a40;
  background: #f8f9fa;
  font-weight: 700;
  border-radius: 6px;
}

.p-fieldset.p-fieldset-toggleable .p-fieldset-legend {
  padding: 0;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-fieldset.p-fieldset-toggleable .p-fieldset-legend a {
  padding: 1.25rem;
  color: #343a40;
  border-radius: 6px;
  transition: box-shadow 0.2s;
}

.p-fieldset.p-fieldset-toggleable .p-fieldset-legend a .p-fieldset-toggler {
  margin-right: 0.5rem;
}

.p-fieldset.p-fieldset-toggleable .p-fieldset-legend a:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-fieldset.p-fieldset-toggleable .p-fieldset-legend:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  color: #343a40;
}

.p-fieldset .p-fieldset-content {
  padding: 1.25rem;
}

.p-divider .p-divider-content {
  background-color: #ffffff;
}

.p-divider.p-divider-horizontal {
  margin: 1.25rem 0;
  padding: 0 1.25rem;
}

.p-divider.p-divider-horizontal:before {
  border-top: 1px #dee2e6;
}

.p-divider.p-divider-horizontal .p-divider-content {
  padding: 0 0.5rem;
}

.p-divider.p-divider-vertical {
  margin: 0 1.25rem;
  padding: 1.25rem 0;
}

.p-divider.p-divider-vertical:before {
  border-left: 1px #dee2e6;
}

.p-divider.p-divider-vertical .p-divider-content {
  padding: 0.5rem 0;
}

.p-panel .p-panel-header {
  border: 1px solid #dee2e6;
  padding: 1.25rem;
  background: #f8f9fa;
  color: #343a40;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-panel .p-panel-header .p-panel-title {
  font-weight: 700;
}

.p-panel .p-panel-header .p-panel-header-icon {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-panel .p-panel-header .p-panel-header-icon:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-panel .p-panel-header .p-panel-header-icon:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-panel.p-panel-toggleable .p-panel-header {
  padding: 0.75rem 1.25rem;
}

.p-panel .p-panel-content {
  padding: 1.25rem;
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-top: 0 none;
}

.p-panel .p-panel-footer {
  padding: 0.75rem 1.25rem;
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  border-top: 0 none;
}

.p-splitter {
  border: 1px solid #dee2e6;
  background: #ffffff;
  border-radius: 6px;
  color: #495057;
}

.p-splitter .p-splitter-gutter {
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  background: #f8f9fa;
}

.p-splitter .p-splitter-gutter .p-splitter-gutter-handle {
  background: #dee2e6;
}

.p-splitter .p-splitter-gutter-resizing {
  background: #dee2e6;
}

.p-scrollpanel .p-scrollpanel-bar {
  background: #f8f9fa;
  border: 0 none;
}

.p-tabview .p-tabview-nav {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-width: 0 0 2px 0;
}

.p-tabview .p-tabview-nav li {
  margin-right: 0;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: solid #dee2e6;
  border-width: 0 0 2px 0;
  border-color: transparent transparent #dee2e6 transparent;
  background: #ffffff;
  color: #6c757d;
  padding: 1.25rem;
  font-weight: 700;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: box-shadow 0.2s;
  margin: 0 0 -2px 0;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.2rem #c7d2fe;
}

.p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {
  background: #ffffff;
  border-color: #adb5bd;
  color: #6c757d;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #ffffff;
  border-color: #6366f1;
  color: #6366f1;
}

.p-tabview .p-tabview-close {
  margin-left: 0.5rem;
}

.p-tabview .p-tabview-nav-btn.p-link {
  background: #ffffff;
  color: #6366f1;
  width: 3rem;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-radius: 0;
}

.p-tabview .p-tabview-nav-btn.p-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.2rem #c7d2fe;
}

.p-tabview .p-tabview-panels {
  background: #ffffff;
  padding: 1.25rem;
  border: 0 none;
  color: #495057;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-toolbar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 1.25rem;
  border-radius: 6px;
  gap: 0.5rem;
}

.p-toolbar .p-toolbar-separator {
  margin: 0 0.5rem;
}

.p-confirm-popup {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.p-confirm-popup .p-confirm-popup-content {
  padding: 1.25rem;
}

.p-confirm-popup .p-confirm-popup-footer {
  text-align: right;
  padding: 0 1.25rem 1.25rem 1.25rem;
}

.p-confirm-popup .p-confirm-popup-footer button {
  margin: 0 0.5rem 0 0;
  width: auto;
}

.p-confirm-popup .p-confirm-popup-footer button:last-child {
  margin: 0;
}

.p-confirm-popup:after {
  border: solid transparent;
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #ffffff;
}

.p-confirm-popup:before {
  border: solid transparent;
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #ffffff;
}

.p-confirm-popup.p-confirm-popup-flipped:after {
  border-top-color: #ffffff;
}

.p-confirm-popup.p-confirm-popup-flipped:before {
  border-top-color: #ffffff;
}

.p-confirm-popup .p-confirm-popup-icon {
  font-size: 1.5rem;
}

.p-confirm-popup .p-confirm-popup-icon.p-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.p-confirm-popup .p-confirm-popup-message {
  margin-left: 1rem;
}

.p-dialog {
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border: 0 none;
}

.p-dialog .p-dialog-header {
  border-bottom: 0 none;
  background: #ffffff;
  color: #343a40;
  padding: 1.5rem;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-dialog .p-dialog-header .p-dialog-title {
  font-weight: 700;
  font-size: 1.25rem;
}

.p-dialog .p-dialog-header .p-dialog-header-icon {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  margin-right: 0.5rem;
}

.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-dialog .p-dialog-header .p-dialog-header-icon:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-dialog .p-dialog-header .p-dialog-header-icon:last-child {
  margin-right: 0;
}

.p-dialog .p-dialog-content {
  background: #ffffff;
  color: #495057;
  padding: 0 1.5rem 2rem 1.5rem;
}

.p-dialog .p-dialog-content:last-of-type {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-dialog .p-dialog-footer {
  border-top: 0 none;
  background: #ffffff;
  color: #495057;
  padding: 0 1.5rem 1.5rem 1.5rem;
  text-align: right;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-dialog .p-dialog-footer button {
  margin: 0 0.5rem 0 0;
  width: auto;
}

.p-dialog.p-dialog-maximized .p-dialog-header,
.p-dialog.p-dialog-maximized .p-dialog-content:last-of-type {
  border-radius: 0;
}

.p-dialog.p-confirm-dialog .p-confirm-dialog-icon {
  font-size: 2rem;
}

.p-dialog.p-confirm-dialog .p-confirm-dialog-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-dialog.p-confirm-dialog .p-confirm-dialog-message {
  margin-left: 1rem;
}

.p-overlaypanel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.p-overlaypanel .p-overlaypanel-content {
  padding: 1.25rem;
}

.p-overlaypanel .p-overlaypanel-close {
  background: #6366f1;
  color: #ffffff;
  width: 2rem;
  height: 2rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  position: absolute;
  top: -1rem;
  right: -1rem;
}

.p-overlaypanel .p-overlaypanel-close:enabled:hover {
  background: #4f46e5;
  color: #ffffff;
}

.p-overlaypanel:after {
  border: solid transparent;
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #ffffff;
  border-width: 8px;
  margin-left: -8px;
}

.p-overlaypanel:before {
  border: solid transparent;
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #f2f2f2;
  border-width: 10px;
  margin-left: -10px;
}

.p-overlaypanel.p-overlaypanel-flipped:after {
  border-top-color: #ffffff;
}

.p-overlaypanel.p-overlaypanel-flipped:before {
  border-top-color: #ffffff;
}

.p-sidebar {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.p-sidebar .p-sidebar-header {
  padding: 1.25rem;
}

.p-sidebar .p-sidebar-header .p-sidebar-close,
.p-sidebar .p-sidebar-header .p-sidebar-icon {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-sidebar .p-sidebar-header .p-sidebar-close:enabled:hover,
.p-sidebar .p-sidebar-header .p-sidebar-icon:enabled:hover {
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}

.p-sidebar .p-sidebar-header .p-sidebar-close:focus,
.p-sidebar .p-sidebar-header .p-sidebar-icon:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-sidebar .p-sidebar-header + .p-sidebar-content {
  padding-top: 0;
}

.p-sidebar .p-sidebar-content {
  padding: 1.25rem;
}

.p-tooltip .p-tooltip-text {
  background: #495057;
  color: #ffffff;
  padding: 0.75rem 0.75rem;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.p-tooltip.p-tooltip-right .p-tooltip-arrow {
  border-right-color: #495057;
}

.p-tooltip.p-tooltip-left .p-tooltip-arrow {
  border-left-color: #495057;
}

.p-tooltip.p-tooltip-top .p-tooltip-arrow {
  border-top-color: #495057;
}

.p-tooltip.p-tooltip-bottom .p-tooltip-arrow {
  border-bottom-color: #495057;
}

.p-fileupload .p-fileupload-buttonbar {
  background: #f8f9fa;
  padding: 1.25rem;
  border: 1px solid #dee2e6;
  color: #343a40;
  border-bottom: 0 none;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  gap: 0.5rem;
}

.p-fileupload .p-fileupload-buttonbar .p-button {
  margin-right: 0.5rem;
}

.p-fileupload .p-fileupload-content {
  background: #ffffff;
  padding: 2rem 1rem;
  border: 1px solid #dee2e6;
  color: #495057;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-fileupload .p-progressbar {
  height: 0.25rem;
}

.p-fileupload .p-fileupload-row > div {
  padding: 1rem 1rem;
}

.p-fileupload.p-fileupload-advanced .p-message {
  margin-top: 0;
}

.p-breadcrumb {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 1rem;
}

.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link {
  transition: box-shadow 0.2s;
  border-radius: 6px;
}

.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
}

.p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {
  margin: 0 0.5rem 0 0.5rem;
  color: #495057;
}

.p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {
  color: #495057;
}

.p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-icon {
  color: #6c757d;
}

.p-contextmenu {
  padding: 0.25rem 0;
  background: #ffffff;
  color: #495057;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  width: 12.5rem;
}

.p-contextmenu .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-contextmenu .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-contextmenu .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-contextmenu .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-contextmenu .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-contextmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-contextmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-contextmenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-contextmenu .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-contextmenu .p-submenu-list {
  padding: 0.25rem 0;
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.p-contextmenu .p-menuitem.p-menuitem-active > .p-menuitem-link {
  background: #eef2ff;
}

.p-contextmenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text {
  color: #4338ca;
}

.p-contextmenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon,
.p-contextmenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon {
  color: #4338ca;
}

.p-contextmenu .p-menu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-contextmenu .p-submenu-icon {
  font-size: 0.875rem;
  transition: transform 0.2s;
}

.p-contextmenu .p-submenu-icon.p-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.p-dock .p-dock-list {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0.5rem 0.5rem;
  border-radius: 0.5rem;
}

.p-dock .p-dock-item {
  padding: 0.5rem;
}

.p-dock .p-dock-action {
  width: 4rem;
  height: 4rem;
}

.p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-prev,
.p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-next,
.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-prev,
.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-next {
  margin: 0 0.9rem;
}

.p-dock.p-dock-magnification.p-dock-top .p-dock-item-prev,
.p-dock.p-dock-magnification.p-dock-top .p-dock-item-next,
.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-prev,
.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-next {
  margin: 0 1.3rem;
}

.p-dock.p-dock-magnification.p-dock-top .p-dock-item-current,
.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-current {
  margin: 0 1.5rem;
}

.p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-prev,
.p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-next,
.p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-prev,
.p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-next {
  margin: 0.9rem 0;
}

.p-dock.p-dock-magnification.p-dock-left .p-dock-item-prev,
.p-dock.p-dock-magnification.p-dock-left .p-dock-item-next,
.p-dock.p-dock-magnification.p-dock-right .p-dock-item-prev,
.p-dock.p-dock-magnification.p-dock-right .p-dock-item-next {
  margin: 1.3rem 0;
}

.p-dock.p-dock-magnification.p-dock-left .p-dock-item-current,
.p-dock.p-dock-magnification.p-dock-right .p-dock-item-current {
  margin: 1.5rem 0;
}

@media screen and (max-width: 960px) {
  .p-dock.p-dock-top .p-dock-container,
  .p-dock.p-dock-bottom .p-dock-container {
    overflow-x: auto;
    width: 100%;
  }
  .p-dock.p-dock-top .p-dock-container .p-dock-list,
  .p-dock.p-dock-bottom .p-dock-container .p-dock-list {
    margin: 0 auto;
  }
  .p-dock.p-dock-left .p-dock-container,
  .p-dock.p-dock-right .p-dock-container {
    overflow-y: auto;
    height: 100%;
  }
  .p-dock.p-dock-left .p-dock-container .p-dock-list,
  .p-dock.p-dock-right .p-dock-container .p-dock-list {
    margin: auto 0;
  }
  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-prev,
  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-next,
  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-prev,
  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-next,
  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-current,
  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-prev,
  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-next,
  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-prev,
  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-next,
  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-current,
  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-prev,
  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-next,
  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-prev,
  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-next,
  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-current,
  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-prev,
  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-next,
  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-prev,
  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-next,
  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-current {
    transform: none;
    margin: 0;
  }
}
.p-megamenu {
  padding: 0.5rem;
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 6px;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 6px;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
  margin-left: 0.5rem;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover {
  background: #eef2ff;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #4338ca;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #4338ca;
}

.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon,
.p-megamenu .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #4338ca;
}

.p-megamenu .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-megamenu .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-megamenu .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-megamenu .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-megamenu .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-megamenu .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-megamenu .p-megamenu-panel {
  background: #ffffff;
  color: #495057;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-megamenu .p-megamenu-submenu-header {
  margin: 0;
  padding: 0.75rem 1.25rem;
  color: #343a40;
  background: #ffffff;
  font-weight: 700;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.p-megamenu .p-megamenu-submenu {
  padding: 0.25rem 0;
  width: 12.5rem;
}

.p-megamenu .p-megamenu-submenu .p-menu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link {
  background: #eef2ff;
}

.p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text {
  color: #4338ca;
}

.p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon,
.p-megamenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon {
  color: #4338ca;
}

.p-megamenu.p-megamenu-vertical {
  width: 12.5rem;
  padding: 0.25rem 0;
}

.p-megamenu .p-megamenu-button {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-megamenu .p-megamenu-button:hover {
  color: #6c757d;
  background: #e9ecef;
}

.p-megamenu .p-megamenu-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-megamenu .p-submenu-icon {
  transition: transform 0.2s;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list {
  padding: 0.25rem 0;
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon {
  font-size: 0.875rem;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon.p-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem {
  width: 100%;
  position: static;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem > .p-menuitem-link > .p-submenu-icon {
  margin-left: auto;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link > .p-submenu-icon {
  transform: rotate(-180deg);
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list {
  width: 100%;
  position: static;
  box-shadow: none;
  border: 0 none;
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-submenu-icon {
  transition: transform 0.2s;
  transform: rotate(90deg);
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-menuitem-active > .p-menuitem-link > .p-submenu-icon {
  transform: rotate(-90deg);
}

.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menuitem {
  width: 100%;
  position: static;
}

.p-menu {
  padding: 0.25rem 0;
  background: #ffffff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  width: 12.5rem;
}

.p-menu .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-menu .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-menu .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-menu .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-menu .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-menu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-menu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-menu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-menu .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-menu.p-menu-overlay {
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-menu .p-submenu-header {
  margin: 0;
  padding: 0.75rem 1.25rem;
  color: #343a40;
  background: #ffffff;
  font-weight: 700;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

.p-menu .p-menu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-menubar {
  padding: 0.5rem;
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 6px;
}

.p-menubar .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-menubar .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-menubar .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-menubar .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-menubar .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-menubar .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-menubar .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-menubar .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-menubar .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 6px;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
  margin-left: 0.5rem;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link,
.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover {
  background: #eef2ff;
}

.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text,
.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #4338ca;
}

.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon,
.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #4338ca;
}

.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon,
.p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #4338ca;
}

.p-menubar .p-submenu-list {
  padding: 0.25rem 0;
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 12.5rem;
}

.p-menubar .p-submenu-list .p-menu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-menubar .p-submenu-list .p-submenu-icon {
  font-size: 0.875rem;
}

.p-menubar .p-submenu-list .p-submenu-icon.p-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.p-menubar .p-menuitem.p-menuitem-active > .p-menuitem-link {
  background: #eef2ff;
}

.p-menubar .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text {
  color: #4338ca;
}

.p-menubar .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon,
.p-menubar .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon {
  color: #4338ca;
}

@media screen and (max-width: 960px) {
  .p-menubar {
    position: relative;
  }
  .p-menubar .p-menubar-button {
    display: flex;
    width: 2rem;
    height: 2rem;
    color: #6c757d;
    border-radius: 50%;
    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  }
  .p-menubar .p-menubar-button:hover {
    color: #6c757d;
    background: #e9ecef;
  }
  .p-menubar .p-menubar-button:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem #c7d2fe;
  }
  .p-menubar .p-menubar-root-list {
    position: absolute;
    display: none;
    padding: 0.25rem 0;
    background: #ffffff;
    border: 0 none;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    width: 100%;
  }
  .p-menubar .p-menubar-root-list .p-menu-separator {
    border-top: 1px solid #dee2e6;
    margin: 0.25rem 0;
  }
  .p-menubar .p-menubar-root-list .p-submenu-icon {
    font-size: 0.875rem;
  }
  .p-menubar .p-menubar-root-list .p-submenu-icon.p-icon {
    width: 0.875rem;
    height: 0.875rem;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem {
    width: 100%;
    position: static;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link {
    padding: 0.75rem 1.25rem;
    color: #495057;
    border-radius: 0;
    transition: box-shadow 0.2s;
    -webkit-user-select: none;
            user-select: none;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-text {
    color: #495057;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link .p-menuitem-icon {
    color: #6c757d;
    margin-right: 0.5rem;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link .p-submenu-icon {
    color: #6c757d;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover {
    background: #e9ecef;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
    color: #495057;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
    color: #6c757d;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
    color: #6c757d;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: inset 0 0 0 0.15rem #c7d2fe;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link > .p-submenu-icon {
    margin-left: auto;
    transition: transform 0.2s;
  }
  .p-menubar .p-menubar-root-list > .p-menuitem.p-menuitem-active > .p-menuitem-link > .p-submenu-icon {
    transform: rotate(-180deg);
  }
  .p-menubar .p-menubar-root-list .p-submenu-list {
    width: 100%;
    position: static;
    box-shadow: none;
    border: 0 none;
  }
  .p-menubar .p-menubar-root-list .p-submenu-list .p-submenu-icon {
    transition: transform 0.2s;
    transform: rotate(90deg);
  }
  .p-menubar .p-menubar-root-list .p-submenu-list .p-menuitem-active > .p-menuitem-link > .p-submenu-icon {
    transform: rotate(-90deg);
  }
  .p-menubar .p-menubar-root-list .p-menuitem {
    width: 100%;
    position: static;
  }
  .p-menubar .p-menubar-root-list ul li a {
    padding-left: 2.25rem;
  }
  .p-menubar .p-menubar-root-list ul li ul li a {
    padding-left: 3.75rem;
  }
  .p-menubar .p-menubar-root-list ul li ul li ul li a {
    padding-left: 5.25rem;
  }
  .p-menubar .p-menubar-root-list ul li ul li ul li ul li a {
    padding-left: 6.75rem;
  }
  .p-menubar .p-menubar-root-list ul li ul li ul li ul li ul li a {
    padding-left: 8.25rem;
  }
  .p-menubar.p-menubar-mobile-active .p-menubar-root-list {
    display: flex;
    flex-direction: column;
    top: 100%;
    left: 0;
    z-index: 1;
  }
}
.p-panelmenu .p-panelmenu-header > a {
  padding: 1.25rem;
  border: 1px solid #dee2e6;
  color: #6c757d;
  background: #f8f9fa;
  font-weight: 700;
  border-radius: 6px;
  transition: box-shadow 0.2s;
}

.p-panelmenu .p-panelmenu-header > a .p-panelmenu-icon {
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-header > a .p-menuitem-icon {
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-header > a:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-panelmenu .p-panelmenu-header:not(.p-highlight):not(.p-disabled) > a:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  color: #343a40;
}

.p-panelmenu .p-panelmenu-header.p-highlight {
  margin-bottom: 0;
}

.p-panelmenu .p-panelmenu-header.p-highlight > a {
  background: #f8f9fa;
  border-color: #dee2e6;
  color: #343a40;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.p-panelmenu .p-panelmenu-header.p-highlight:not(.p-disabled) > a:hover {
  border-color: #dee2e6;
  background: #e9ecef;
  color: #343a40;
}

.p-panelmenu .p-panelmenu-content {
  padding: 0.25rem 0;
  border: 1px solid #dee2e6;
  background: #ffffff;
  color: #495057;
  border-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-panelmenu-icon {
  margin-right: 0.5rem;
}

.p-panelmenu .p-panelmenu-content .p-submenu-list:not(.p-panelmenu-root-submenu) {
  padding: 0 0 0 1rem;
}

.p-panelmenu .p-panelmenu-panel {
  margin-bottom: 4px;
}

.p-slidemenu {
  padding: 0.25rem 0;
  background: #ffffff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  width: 12.5rem;
}

.p-slidemenu .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-slidemenu .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-slidemenu .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-slidemenu .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-slidemenu .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-slidemenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-slidemenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-slidemenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-slidemenu .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-slidemenu.p-slidemenu-overlay {
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-slidemenu .p-slidemenu-list {
  padding: 0.25rem 0;
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-slidemenu .p-slidemenu.p-slidemenu-active > .p-slidemenu-link {
  background: #eef2ff;
}

.p-slidemenu .p-slidemenu.p-slidemenu-active > .p-slidemenu-link .p-slidemenu-text {
  color: #4338ca;
}

.p-slidemenu .p-slidemenu.p-slidemenu-active > .p-slidemenu-link .p-slidemenu-icon,
.p-slidemenu .p-slidemenu.p-slidemenu-active > .p-slidemenu-link .p-slidemenu-icon {
  color: #4338ca;
}

.p-slidemenu .p-slidemenu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-slidemenu .p-slidemenu-icon {
  font-size: 0.875rem;
}

.p-slidemenu .p-slidemenu-icon.p-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.p-slidemenu .p-slidemenu-backward {
  padding: 0.75rem 1.25rem;
  color: #495057;
}

.p-steps .p-steps-item .p-menuitem-link {
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 6px;
  background: #ffffff;
}

.p-steps .p-steps-item .p-menuitem-link .p-steps-number {
  color: #495057;
  border: 1px solid #e9ecef;
  background: #ffffff;
  min-width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.143rem;
  z-index: 1;
  border-radius: 50%;
}

.p-steps .p-steps-item .p-menuitem-link .p-steps-title {
  margin-top: 0.5rem;
  color: #6c757d;
}

.p-steps .p-steps-item .p-menuitem-link:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-steps .p-steps-item.p-highlight .p-steps-number {
  background: #eef2ff;
  color: #4338ca;
}

.p-steps .p-steps-item.p-highlight .p-steps-title {
  font-weight: 700;
  color: #495057;
}

.p-steps .p-steps-item:before {
  content: " ";
  border-top: 1px solid #dee2e6;
  width: 100%;
  top: 50%;
  left: 0;
  display: block;
  position: absolute;
  margin-top: -1rem;
}

.p-tabmenu .p-tabmenu-nav {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-width: 0 0 2px 0;
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem {
  margin-right: 0;
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {
  border: solid #dee2e6;
  border-width: 0 0 2px 0;
  border-color: transparent transparent #dee2e6 transparent;
  background: #ffffff;
  color: #6c757d;
  padding: 1.25rem;
  font-weight: 700;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: box-shadow 0.2s;
  margin: 0 0 -2px 0;
  height: calc(100% + 2px);
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link .p-menuitem-icon {
  margin-right: 0.5rem;
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.2rem #c7d2fe;
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):not(.p-disabled):hover .p-menuitem-link {
  background: #ffffff;
  border-color: #adb5bd;
  color: #6c757d;
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {
  background: #ffffff;
  border-color: #6366f1;
  color: #6366f1;
}

.p-tieredmenu {
  padding: 0.25rem 0;
  background: #ffffff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  width: 12.5rem;
}

.p-tieredmenu .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  color: #495057;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.p-tieredmenu .p-menuitem-link .p-menuitem-text {
  color: #495057;
}

.p-tieredmenu .p-menuitem-link .p-menuitem-icon {
  color: #6c757d;
  margin-right: 0.5rem;
}

.p-tieredmenu .p-menuitem-link .p-submenu-icon {
  color: #6c757d;
}

.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover {
  background: #e9ecef;
}

.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #495057;
}

.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {
  color: #6c757d;
}

.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
  color: #6c757d;
}

.p-tieredmenu .p-menuitem-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: inset 0 0 0 0.15rem #c7d2fe;
}

.p-tieredmenu.p-tieredmenu-overlay {
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-tieredmenu .p-submenu-list {
  padding: 0.25rem 0;
  background: #ffffff;
  border: 0 none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.p-tieredmenu .p-menuitem.p-menuitem-active > .p-menuitem-link {
  background: #eef2ff;
}

.p-tieredmenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-text {
  color: #4338ca;
}

.p-tieredmenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-menuitem-icon,
.p-tieredmenu .p-menuitem.p-menuitem-active > .p-menuitem-link .p-submenu-icon {
  color: #4338ca;
}

.p-tieredmenu .p-menu-separator {
  border-top: 1px solid #dee2e6;
  margin: 0.25rem 0;
}

.p-tieredmenu .p-submenu-icon {
  font-size: 0.875rem;
  transition: transform 0.2s;
}

.p-tieredmenu .p-submenu-icon.p-icon {
  width: 0.875rem;
  height: 0.875rem;
}

.p-inline-message {
  padding: 0.75rem 0.75rem;
  margin: 0;
  border-radius: 6px;
}

.p-inline-message.p-inline-message-info {
  background: #e9e9ff;
  border: solid #696cff;
  border-width: 0px;
  color: #696cff;
}

.p-inline-message.p-inline-message-info .p-inline-message-icon {
  color: #696cff;
}

.p-inline-message.p-inline-message-success {
  background: #e4f8f0;
  border: solid #1ea97c;
  border-width: 0px;
  color: #1ea97c;
}

.p-inline-message.p-inline-message-success .p-inline-message-icon {
  color: #1ea97c;
}

.p-inline-message.p-inline-message-warn {
  background: #fff2e2;
  border: solid #cc8925;
  border-width: 0px;
  color: #cc8925;
}

.p-inline-message.p-inline-message-warn .p-inline-message-icon {
  color: #cc8925;
}

.p-inline-message.p-inline-message-error {
  background: #ffe7e6;
  border: solid #ff5757;
  border-width: 0px;
  color: #ff5757;
}

.p-inline-message.p-inline-message-error .p-inline-message-icon {
  color: #ff5757;
}

.p-inline-message .p-inline-message-icon {
  font-size: 1rem;
  margin-right: 0.5rem;
}

.p-inline-message .p-inline-message-icon.p-icon {
  width: 1rem;
  height: 1rem;
}

.p-inline-message .p-inline-message-text {
  font-size: 1rem;
}

.p-inline-message.p-inline-message-icon-only .p-inline-message-icon {
  margin-right: 0;
}

.p-message {
  margin: 1rem 0;
  border-radius: 6px;
}

.p-message .p-message-wrapper {
  padding: 1.25rem 1.75rem;
}

.p-message .p-message-close {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: transparent;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-message .p-message-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.p-message .p-message-close:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-message.p-message-info {
  background: #e9e9ff;
  border: solid #696cff;
  border-width: 0 0 0 6px;
  color: #696cff;
}

.p-message.p-message-info .p-message-icon {
  color: #696cff;
}

.p-message.p-message-info .p-message-close {
  color: #696cff;
}

.p-message.p-message-success {
  background: #e4f8f0;
  border: solid #1ea97c;
  border-width: 0 0 0 6px;
  color: #1ea97c;
}

.p-message.p-message-success .p-message-icon {
  color: #1ea97c;
}

.p-message.p-message-success .p-message-close {
  color: #1ea97c;
}

.p-message.p-message-warn {
  background: #fff2e2;
  border: solid #cc8925;
  border-width: 0 0 0 6px;
  color: #cc8925;
}

.p-message.p-message-warn .p-message-icon {
  color: #cc8925;
}

.p-message.p-message-warn .p-message-close {
  color: #cc8925;
}

.p-message.p-message-error {
  background: #ffe7e6;
  border: solid #ff5757;
  border-width: 0 0 0 6px;
  color: #ff5757;
}

.p-message.p-message-error .p-message-icon {
  color: #ff5757;
}

.p-message.p-message-error .p-message-close {
  color: #ff5757;
}

.p-message .p-message-text {
  font-size: 1rem;
  font-weight: 400;
}

.p-message .p-message-icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.p-message .p-message-icon.p-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.p-message .p-message-summary {
  font-weight: 700;
}

.p-message .p-message-detail {
  margin-left: 0.5rem;
}

.p-toast {
  opacity: 0.9;
}

.p-toast .p-toast-message {
  margin: 0 0 1rem 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.p-toast .p-toast-message .p-toast-message-content {
  padding: 1rem;
  border-width: 0 0 0 6px;
}

.p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {
  margin: 0 0 0 1rem;
}

.p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon {
  font-size: 2rem;
}

.p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-toast .p-toast-message .p-toast-message-content .p-toast-summary {
  font-weight: 700;
}

.p-toast .p-toast-message .p-toast-message-content .p-toast-detail {
  margin: 0.5rem 0 0 0;
}

.p-toast .p-toast-message .p-toast-icon-close {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: transparent;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-toast .p-toast-message .p-toast-icon-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.p-toast .p-toast-message .p-toast-icon-close:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-toast .p-toast-message.p-toast-message-info {
  background: #e9e9ff;
  border: solid #696cff;
  border-width: 0 0 0 6px;
  color: #696cff;
}

.p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close {
  color: #696cff;
}

.p-toast .p-toast-message.p-toast-message-success {
  background: #e4f8f0;
  border: solid #1ea97c;
  border-width: 0 0 0 6px;
  color: #1ea97c;
}

.p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close {
  color: #1ea97c;
}

.p-toast .p-toast-message.p-toast-message-warn {
  background: #fff2e2;
  border: solid #cc8925;
  border-width: 0 0 0 6px;
  color: #cc8925;
}

.p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close {
  color: #cc8925;
}

.p-toast .p-toast-message.p-toast-message-error {
  background: #ffe7e6;
  border: solid #ff5757;
  border-width: 0 0 0 6px;
  color: #ff5757;
}

.p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {
  color: #ff5757;
}

.p-galleria .p-galleria-close {
  margin: 0.5rem;
  background: transparent;
  color: #f8f9fa;
  width: 4rem;
  height: 4rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
}

.p-galleria .p-galleria-close .p-galleria-close-icon {
  font-size: 2rem;
}

.p-galleria .p-galleria-close .p-galleria-close-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-galleria .p-galleria-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f8f9fa;
}

.p-galleria .p-galleria-item-nav {
  background: transparent;
  color: #f8f9fa;
  width: 4rem;
  height: 4rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 6px;
  margin: 0 0.5rem;
}

.p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon,
.p-galleria .p-galleria-item-nav .p-galleria-item-next-icon {
  font-size: 2rem;
}

.p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon.p-icon,
.p-galleria .p-galleria-item-nav .p-galleria-item-next-icon.p-icon {
  width: 2rem;
  height: 2rem;
}

.p-galleria .p-galleria-item-nav:not(.p-disabled):hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f8f9fa;
}

.p-galleria .p-galleria-caption {
  background: rgba(0, 0, 0, 0.5);
  color: #f8f9fa;
  padding: 1rem;
}

.p-galleria .p-galleria-indicators {
  padding: 1rem;
}

.p-galleria .p-galleria-indicators .p-galleria-indicator button {
  background-color: #ced4da;
  width: 1rem;
  height: 1rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
}

.p-galleria .p-galleria-indicators .p-galleria-indicator button:hover {
  background: #adb5bd;
}

.p-galleria .p-galleria-indicators .p-galleria-indicator.p-highlight button {
  background: #eef2ff;
  color: #4338ca;
}

.p-galleria.p-galleria-indicators-bottom .p-galleria-indicator,
.p-galleria.p-galleria-indicators-top .p-galleria-indicator {
  margin-right: 0.5rem;
}

.p-galleria.p-galleria-indicators-left .p-galleria-indicator,
.p-galleria.p-galleria-indicators-right .p-galleria-indicator {
  margin-bottom: 0.5rem;
}

.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators {
  background: rgba(0, 0, 0, 0.5);
}

.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button {
  background: rgba(255, 255, 255, 0.4);
}

.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button:hover {
  background: rgba(255, 255, 255, 0.6);
}

.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator.p-highlight button {
  background: #eef2ff;
  color: #4338ca;
}

.p-galleria .p-galleria-thumbnail-container {
  background: rgba(0, 0, 0, 0.9);
  padding: 1rem 0.25rem;
}

.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev,
.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next {
  margin: 0.5rem;
  background-color: transparent;
  color: #f8f9fa;
  width: 2rem;
  height: 2rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
}

.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev:hover,
.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f8f9fa;
}

.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content {
  transition: box-shadow 0.2s;
}

.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-galleria-mask {
  --maskbg: rgba(0, 0, 0, 0.9);
}

.p-image-mask {
  --maskbg: rgba(0, 0, 0, 0.9);
}

.p-image-preview-indicator {
  background-color: transparent;
  color: #f8f9fa;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-image-preview-indicator .p-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.p-image-preview-container:hover > .p-image-preview-indicator {
  background-color: rgba(0, 0, 0, 0.5);
}

.p-image-toolbar {
  padding: 1rem;
}

.p-image-action.p-link {
  color: #f8f9fa;
  background-color: transparent;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  margin-right: 0.5rem;
}

.p-image-action.p-link:last-child {
  margin-right: 0;
}

.p-image-action.p-link:hover {
  color: #f8f9fa;
  background-color: rgba(255, 255, 255, 0.1);
}

.p-image-action.p-link span {
  font-size: 1.5rem;
}

.p-image-action.p-link .p-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.p-avatar {
  background-color: #dee2e6;
  border-radius: 6px;
}

.p-avatar.p-avatar-lg {
  width: 3rem;
  height: 3rem;
  font-size: 1.5rem;
}

.p-avatar.p-avatar-lg .p-avatar-icon {
  font-size: 1.5rem;
}

.p-avatar.p-avatar-xl {
  width: 4rem;
  height: 4rem;
  font-size: 2rem;
}

.p-avatar.p-avatar-xl .p-avatar-icon {
  font-size: 2rem;
}

.p-avatar-group .p-avatar {
  border: 2px solid #ffffff;
}

.p-chip {
  background-color: #dee2e6;
  color: #495057;
  border-radius: 16px;
  padding: 0 0.75rem;
}

.p-chip .p-chip-text {
  line-height: 1.5;
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}

.p-chip .p-chip-icon {
  margin-right: 0.5rem;
}

.p-chip img {
  width: 2.25rem;
  height: 2.25rem;
  margin-left: -0.75rem;
  margin-right: 0.5rem;
}

.p-chip .p-chip-remove-icon {
  border-radius: 6px;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  margin-left: 0.5rem;
}

.p-chip .p-chip-remove-icon:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-scrolltop {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
}

.p-scrolltop.p-link {
  background: rgba(0, 0, 0, 0.7);
}

.p-scrolltop.p-link:hover {
  background: rgba(0, 0, 0, 0.8);
}

.p-scrolltop .p-scrolltop-icon {
  font-size: 1.5rem;
  color: #f8f9fa;
}

.p-scrolltop .p-scrolltop-icon.p-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.p-skeleton {
  background-color: #dee2e6;
  border-radius: 6px;
}

.p-skeleton:after {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
}

.p-tag {
  background: #6366f1;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.25rem 0.4rem;
  border-radius: 6px;
}

.p-tag.p-tag-success {
  background-color: #22c55e;
  color: #ffffff;
}

.p-tag.p-tag-info {
  background-color: #3b82f6;
  color: #ffffff;
}

.p-tag.p-tag-warning {
  background-color: #f59e0b;
  color: #ffffff;
}

.p-tag.p-tag-danger {
  background-color: #ef4444;
  color: #ffffff;
}

.p-tag .p-tag-icon {
  margin-right: 0.25rem;
  font-size: 0.75rem;
}

.p-tag .p-tag-icon.p-icon {
  width: 0.75rem;
  height: 0.75rem;
}

.p-inplace .p-inplace-display {
  padding: 0.75rem 0.75rem;
  border-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-inplace .p-inplace-display:not(.p-disabled):hover {
  background: #e9ecef;
  color: #495057;
}

.p-inplace .p-inplace-display:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
}

.p-progressbar {
  border: 0 none;
  height: 1.5rem;
  background: #dee2e6;
  border-radius: 6px;
}

.p-progressbar .p-progressbar-value {
  border: 0 none;
  margin: 0;
  background: #6366f1;
}

.p-progressbar .p-progressbar-label {
  color: #ffffff;
  line-height: 1.5rem;
}

.p-terminal {
  background: #ffffff;
  color: #495057;
  border: 1px solid #dee2e6;
  padding: 1.25rem;
}

.p-terminal .p-terminal-input {
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.p-badge {
  background: #6366f1;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

.p-badge.p-badge-secondary {
  background-color: #64748b;
  color: #ffffff;
}

.p-badge.p-badge-success {
  background-color: #22c55e;
  color: #ffffff;
}

.p-badge.p-badge-info {
  background-color: #3b82f6;
  color: #ffffff;
}

.p-badge.p-badge-warning {
  background-color: #f59e0b;
  color: #ffffff;
}

.p-badge.p-badge-danger {
  background-color: #ef4444;
  color: #ffffff;
}

.p-badge.p-badge-lg {
  font-size: 1.125rem;
  min-width: 2.25rem;
  height: 2.25rem;
  line-height: 2.25rem;
}

.p-badge.p-badge-xl {
  font-size: 1.5rem;
  min-width: 3rem;
  height: 3rem;
  line-height: 3rem;
}

.p-tag {
  background: #6366f1;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.25rem 0.4rem;
  border-radius: 6px;
}

.p-tag.p-tag-success {
  background-color: #22c55e;
  color: #ffffff;
}

.p-tag.p-tag-info {
  background-color: #3b82f6;
  color: #ffffff;
}

.p-tag.p-tag-warning {
  background-color: #f59e0b;
  color: #ffffff;
}

.p-tag.p-tag-danger {
  background-color: #ef4444;
  color: #ffffff;
}

.p-button-label {
  font-weight: 700;
}

.p-accordion .p-accordion-header .p-accordion-header-link {
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.p-tabview .p-tabview-nav .p-tabview-ink-bar {
  z-index: 1;
  display: block;
  position: absolute;
  bottom: 0;
  height: 2px;
  background-color: #6366f1;
  transition: 500ms cubic-bezier(0.35, 0, 0.25, 1);
}

.p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {
  background-color: #6366f1;
}

.p-galleria .p-galleria-indicators .p-galleria-indicator.p-highlight button {
  background-color: #6366f1;
}

.p-button:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b1b3f8, 0 1px 2px 0 rgb(0, 0, 0);
}

.p-button.p-button-secondary:enabled:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b0b9c6, 0 1px 2px 0 rgb(0, 0, 0);
}

.p-button.p-button-success:enabled:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #88eaac, 0 1px 2px 0 rgb(0, 0, 0);
}

.p-button.p-button-info:enabled:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #9dc1fb, 0 1px 2px 0 rgb(0, 0, 0);
}

.p-button.p-button-warning:enabled:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #facf85, 0 1px 2px 0 rgb(0, 0, 0);
}

.p-button.p-button-help:enabled:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #d4aafb, 0 1px 2px 0 rgb(0, 0, 0);
}

.p-button.p-button-danger:enabled:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #f7a2a2, 0 1px 2px 0 rgb(0, 0, 0);
}

.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-top > td {
  box-shadow: inset 0 2px 0 0 #6366f1;
}

.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-bottom > td {
  box-shadow: inset 0 -2px 0 0 #6366f1;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom-lara-light-indigo-theme.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,+BAAA;EACA,wBAAA;EACA,6BAAA;EACA;sDAAA;EAEA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,kCAAA;EACA,4BAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,0JAAA;EAEA,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,yBAAA;AAAF;;AAGA;;EAEE,YAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,0JAAA;EAEA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AADF;;AAIA;EACE,6DAAA;AADF;;AAIA;EACE,6DAAA;AADF;;AAIA;EACE;IACE,6BAAA;EADF;EAIA;IACE,+BAAA;EAFF;AACF;AAKA;EACE;IACE,+BAAA;EAHF;EAMA;IACE,6BAAA;EAJF;AACF;AAOA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,0JAAA;EAEA,eAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;AANF;;AASA;EACE,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,qBAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AANF;;AASA;EACE,cAAA;EACA,mBAAA;AANF;;AASA;EACE,cAAA;EACA,mBAAA;AANF;;AASA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AASA;EACE,qBAAA;AANF;;AASA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;EACA,2CAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,gCAAA;EACA,4BAAA;EACA,2BAAA;AANF;;AASA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AANF;;AASA;;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AANF;;AASA;;EAEE,eAAA;EACA,iBAAA;EACA,gCAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;;EAEE,cAAA;EACA,8DAAA;EACA,gBAAA;EACA,eAAA;AANF;;AASA;;EAEE,cAAA;AANF;;AASA;EACE,oBAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,aAAA;EACA,cAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,6BAAA;AANF;;AASA;EACE,cAAA;EACA,mBAAA;AANF;;AASA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AANF;;AASA;EACE,cAAA;EACA,mBAAA;AANF;;AASA;EACE,eAAA;EACA,6BAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA;EACE,6BAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AANF;;AASA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AANF;;AASA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;AANF;;AASA;EACE,cAAA;EACA,mBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;AANF;;AASA;EACE,cAAA;EACA,mBAAA;AANF;;AASA;EACE,8BAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,gBAAA;EACA,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AANF;;AASA;EAEE;;IAEE,UAAA;EAPF;AACF;AAUA;EACE,mBAAA;EACA,yBAAA;EACA,iFAAA;EACA,kBAAA;AARF;;AAWA;EACE,qBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AARF;;AAWA;EACE,uBAAA;EACA,cAAA;EACA,wBAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;AARF;;AAWA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;AARF;;AAWA;EACE,qBAAA;AARF;;AAWA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,SAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AARF;;AAWA;EACE,wBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AARF;;AAWA;EACE,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;AARF;;AAWA;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iFAAA;AARF;;AAWA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;AARF;;AAWA;EACE,qBAAA;EACA,mBAAA;AARF;;AAWA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AARF;;AAWA;EACE,qBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AARF;;AAWA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AARF;;AAWA;EACE,qBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,qBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AARF;;AAWA;EACE,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,0JAAA;EAEA,eAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;AATF;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;AATF;;AAYA;EACE,mBAAA;EACA,yBAAA;AATF;;AAYA;;EAEE,qBAAA;AATF;;AAYA;EACE,2CAAA;AATF;;AAYA;EACE,mBAAA;EACA,yBAAA;EACA,iFAAA;EACA,kBAAA;AATF;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AATF;;AAYA;EACE,sBAAA;AATF;;AAYA;EACE,uBAAA;EACA,cAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;AATF;;AAYA;EACE,cAAA;EACA,WAAA;AATF;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;AATF;;AAYA;EACE,wBAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,2BAAA;AATF;;AAYA;EACE,sBAAA;EACA,sBAAA;AATF;;AAYA;EACE,cAAA;EACA,cAAA;AATF;;AAYA;EACE,qBAAA;EACA,qBAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,kBAAA;AATF;;AAYA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AATF;;AAYA;EACE,cAAA;EACA,mBAAA;AATF;;AAYA;EACE,cAAA;EACA,mBAAA;AATF;;AAYA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AATF;;AAYA;EACE,wBAAA;EACA,cAAA;EACA,uBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,6BAAA;AATF;;AAYA;EACE,mBAAA;EACA,4BAAA;EACA,2BAAA;AATF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,cAAA;EACA,cAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,cAAA;EACA,mBAAA;AATF;;AAYA;EACE,wBAAA;AATF;;AAYA;EACE,+BAAA;EACA,8BAAA;AATF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;EACA,+BAAA;EACA,8BAAA;AATF;;AAYA;;EAEE,cAAA;AATF;;AAYA;;EAEE,eAAA;AATF;;AAYA;;EAEE,aAAA;AATF;;AAYA;;;EAGE,cAAA;AATF;;AAYA;;;EAGE,eAAA;AATF;;AAYA;;;EAGE,aAAA;AATF;;AAYA;;;EAGE,cAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,8BAAA;EACA,gCAAA;EACA,wBAAA;EACA,eAAA;AATF;;AAYA;EACE,+BAAA;AATF;;AAYA;;;EAGE,gBAAA;EACA,SAAA;AATF;;AAYA;;;EAGE,mBAAA;AATF;;AAYA;;;EAGE,UAAA;AATF;;AAYA;;;EAGE,UAAA;AATF;;AAYA;;;;;EAKE,2BAAA;EACA,8BAAA;AATF;;AAYA;EACE,2BAAA;EACA,8BAAA;AATF;;AAYA;;;;;EAKE,4BAAA;EACA,+BAAA;AATF;;AAYA;EACE,4BAAA;EACA,+BAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE,WAAA;EACA,eAAA;AATF;;AAYA;EACE,mBAAA;EACA,iFAAA;EACA,mBAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;AATF;;AAYA;EACE,8BAAA;AATF;;AAYA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE,0JAAA;EAEA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iFAAA;EACA,gBAAA;EACA,kBAAA;AAVF;;AAiBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EAEA,oCAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,8BAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,4BAAA;AAfF;;AAkBA;EACE,aAAA;EACA,cAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;;;EAGE,aAAA;EACA,cAAA;AAfF;;AAkBA;EACE,oBAAA;AAfF;;AAkBA;EACE,YAAA;AAfF;;AAkBA;;;EAGE,cAAA;EACA,cAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,8BAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,4BAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,2BAAA;AAfF;;AAkBA;EACE,sBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,cAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,2BAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAfF;;AAkBA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,cAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,yBAAA;EACA,iFAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,sBAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,iFAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;AAfF;;AAkBA;EACE,cAAA;EACA,WAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,wBAAA;AAfF;;AAkBA;EACE,sBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,2BAAA;AAfF;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,sBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,cAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAfF;;AAkBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAfF;;AAkBA;EACE,oBAAA;AAfF;;AAkBA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,cAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,2CAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,qBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iFAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,qBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,eAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,WAAA;AAfF;;AAkBA;EACE,cAAA;EACA,iFAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iFAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,sBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,eAAA;AAfF;;AAkBA;EACE,uBAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iFAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,yBAAA;EACA,iFAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,iFAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,2BAAA;AAfF;;AAkBA;EACE,oBAAA;AAfF;;AAkBA;EACE,sBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,cAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,aAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAfF;;AAkBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,cAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iFAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,cAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,eAAA;EACA,iFAAA;EACA,kBAAA;AAfF;;AAkBA;;EAEE,mBAAA;EACA,cAAA;EACA,qBAAA;AAfF;;AAkBA;;EAEE,mBAAA;EACA,cAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAfF;;AAkBA;;EAEE,oCAAA;EACA,cAAA;EACA,iBAAA;AAfF;;AAkBA;;EAEE,oCAAA;EACA,cAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,qBAAA;AAfF;;AAkBA;;EAEE,mBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,mBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAfF;;AAkBA;;EAEE,oCAAA;EACA,cAAA;EACA,yBAAA;AAfF;;AAkBA;;EAEE,oCAAA;EACA,cAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;;EAEE,mBAAA;EACA,cAAA;AAfF;;AAkBA;;EAEE,mBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,oBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,+GAAA;AAfF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,kBAAA;AAhBF;;AAmBA;;EAEE,SAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,8BAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,4BAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,oBAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,qBAAA;AAhBF;;AAmBA;EACE,SAAA;AAhBF;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;EACE,aAAA;AAhBF;;AAmBA;EACE,SAAA;AAhBF;;AAmBA;;;;EAIE,cAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,gCAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,qCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,qCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,qCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;;;;;EAQE,qCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;EAIE,cAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,gCAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;EAIE,cAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,gCAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;EAIE,cAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,gCAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;EAIE,cAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,gCAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;;;;;EAQE,oCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;EAIE,cAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,gCAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;;;;;;;;EAQE,mCAAA;EACA,yBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;AAhBF;;AAmBA;;EAEE,uBAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;EAEE,0BAAA;AAhBF;;AAmBA;;EAEE,uBAAA;EACA,gCAAA;EACA,yBAAA;AAhBF;;AAmBA;;EAEE,uBAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;;EAEE,oCAAA;EACA,cAAA;AAhBF;;AAmBA;;EAEE,oCAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,qBAAA;AAhBF;;AAmBA;;EAEE,mBAAA;EACA,cAAA;AAhBF;;AAmBA;;EAEE,mBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;EAEE,oCAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;;EAEE,oCAAA;EACA,cAAA;EACA,yBAAA;AAhBF;;AAmBA;EACE,cAAA;AAhBF;;AAmBA;;EAEE,mBAAA;EACA,cAAA;AAhBF;;AAmBA;;EAEE,mBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,+GAAA;AAhBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,4BAAA;AAjBF;;AAoBA;EACE,WAAA;AAjBF;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAjBF;;AAoBA;;EAEE,qCAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,qCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAjBF;;AAoBA;;EAEE,qCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,qCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,oCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,iBAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,yBAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,mCAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,oBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;;;EAGE,SAAA;AAjBF;;AAoBA;;;;;;EAME,SAAA;AAjBF;;AAoBA;EACE,oCAAA;AAjBF;;AAoBA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AAjBF;;AAoBA;;EAEE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,aAAA;AAjBF;;AAoBA;EACE,oBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,WAAA;EACA,cAAA;EACA,8DAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,uCAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;AAjBF;;AAoBA;;;;EAIE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAjBF;;AAoBA;;;;EAIE,cAAA;EACA,yBAAA;EACA,mBAAA;AAjBF;;AAoBA;;;;EAIE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,oBAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mCAAA;AAjBF;;AAoBA;EACE,oCAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,8BAAA;EACA,wBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,8BAAA;EACA,wBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;;EAEE,mBAAA;AAjBF;;AAoBA;;;;EAIE,yBAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,6BAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,uBAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,oCAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;AAjBF;;AAoBA;;EAEE,mBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAjBF;;AAoBA;;EAEE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,wBAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,+BAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,iFAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iFAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;;;EAGE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,2BAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,4BAAA;EACA,+BAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,iFAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iFAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;;;EAGE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;;;EAGE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,2BAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,4BAAA;EACA,+BAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,wBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2CAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,+BAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AAjBF;;AAoBA;;;;EAIE,6BAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;AAjBF;;AAoBA;;;;EAIE,mBAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,2BAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,4BAAA;EACA,+BAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,oBAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,wBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2CAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,2BAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,oBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,oBAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,cAAA;AAjBF;;AAoBA;;EAEE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,qBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;EACA,oBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,oBAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,8BAAA;EACA,wBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;;EAEE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;;EAEE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;;EAEE,mBAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,0BAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,wBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;;EAEE,eAAA;AAjBF;;AAoBA;EACE,UAAA;AAjBF;;AAoBA;;EAEE,eAAA;AAjBF;;AAoBA;EACE,WAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,oBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,6BAAA;EACA,4BAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,cAAA;EACA,+GAAA;EAEA,kBAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,kBAAA;AAlBF;;AAqBA;EACE,sBAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,UAAA;EACA,8DAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,oBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,yBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,uBAAA;AAlBF;;AAqBA;EACE,iBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,wBAAA;AAlBF;;AAqBA;EACE,iBAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAlBF;;AAqBA;EACE,wBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;EACA,8BAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,wBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,8DAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,eAAA;AAlBF;;AAqBA;EACE,qBAAA;EACA,uBAAA;EACA,yDAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,cAAA;EACA,WAAA;EACA,+GAAA;EAEA,gBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,+BAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,iBAAA;EACA,kCAAA;AAnBF;;AAsBA;EACE,oBAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,SAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,oCAAA;EACA,4BAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,oCAAA;EACA,4BAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,iBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,iBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,wCAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,2BAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;EACA,oBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAnBF;;AAsBA;EACE,eAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,6BAAA;AAnBF;;AAsBA;EACE,+BAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;EACA,iBAAA;EACA,+BAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,oBAAA;EACA,WAAA;AAnBF;;AAsBA;;EAEE,gBAAA;AAnBF;;AAsBA;EACE,eAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,iBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,oCAAA;EACA,4BAAA;EACA,iBAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,oCAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,wCAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,8DAAA;AAnBF;;AAsBA;;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AAnBF;;AAsBA;;EAEE,eAAA;EACA,iBAAA;EACA,gCAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,2CAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,2BAAA;AAnBF;;AAsBA;EACE,0BAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,4BAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,oBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,+BAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,eAAA;AAnBF;;AAsBA;EACE,kBAAA;AAnBF;;AAsBA;EACE,aAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,2BAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,2CAAA;EACA,kBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,oBAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,mBAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,2CAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,mBAAA;AAnBF;;AAsBA;EACE,cAAA;AAnBF;;AAsBA;;EAEE,cAAA;AAnBF;;AAsBA;EACE,6BAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,0BAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,oCAAA;EACA,0CAAA;EACA,sBAAA;EACA,qBAAA;AAnBF;;AAsBA;EACE,eAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;AAnBF;;AAsBA;;;;EAIE,gBAAA;AAnBF;;AAsBA;;;;EAIE,gBAAA;AAnBF;;AAsBA;;EAEE,gBAAA;AAnBF;;AAsBA;;;;EAIE,gBAAA;AAnBF;;AAsBA;;;;EAIE,gBAAA;AAnBF;;AAsBA;;EAEE,gBAAA;AAnBF;;AAsBA;EAEE;;IAEE,gBAAA;IACA,WAAA;EApBF;EAuBA;;IAEE,cAAA;EArBF;EAwBA;;IAEE,gBAAA;IACA,YAAA;EAtBF;EAyBA;;IAEE,cAAA;EAvBF;EA0BA;;;;;;;;;;;;;;;;;;;;IAoBE,eAAA;IACA,SAAA;EAxBF;AACF;AA2BA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,oBAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAzBF;;AA4BA;;EAEE,mBAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,oBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAzBF;;AA4BA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,2CAAA;AAzBF;;AA4BA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,6BAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,8DAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAzBF;;AA4BA;EACE,0BAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,2CAAA;AAzBF;;AA4BA;EACE,6BAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,oBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAzBF;;AA4BA;EACE,iBAAA;AAzBF;;AA4BA;EACE,0BAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,0BAAA;EACA,wBAAA;AAzBF;;AA4BA;EACE,yBAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,oBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAzBF;;AA4BA;EACE,mBAAA;EACA,cAAA;EACA,2CAAA;AAzBF;;AA4BA;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;AAzBF;;AA4BA;EACE,6BAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,oBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAzBF;;AA4BA;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,oBAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAzBF;;AA4BA;;EAEE,mBAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,2CAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,6BAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;;EAEE,cAAA;AAzBF;;AA4BA;EACE;IACE,kBAAA;EAzBF;EA4BA;IACE,aAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IACA,8DAAA;EA1BF;EA6BA;IACE,cAAA;IACA,mBAAA;EA3BF;EA8BA;IACE,eAAA;IACA,iBAAA;IACA,gCAAA;EA5BF;EA+BA;IACE,kBAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,cAAA;IACA,2CAAA;IACA,WAAA;EA7BF;EAgCA;IACE,6BAAA;IACA,iBAAA;EA9BF;EAiCA;IACE,mBAAA;EA/BF;EAkCA;IACE,eAAA;IACA,gBAAA;EAhCF;EAmCA;IACE,WAAA;IACA,gBAAA;EAjCF;EAoCA;IACE,wBAAA;IACA,cAAA;IACA,gBAAA;IACA,2BAAA;IACA,yBAAA;YAAA,iBAAA;EAlCF;EAqCA;IACE,cAAA;EAnCF;EAsCA;IACE,cAAA;IACA,oBAAA;EApCF;EAuCA;IACE,cAAA;EArCF;EAwCA;IACE,mBAAA;EAtCF;EAyCA;IACE,cAAA;EAvCF;EA0CA;IACE,cAAA;EAxCF;EA2CA;IACE,cAAA;EAzCF;EA4CA;IACE,eAAA;IACA,iBAAA;IACA,uCAAA;EA1CF;EA6CA;IACE,iBAAA;IACA,0BAAA;EA3CF;EA8CA;IACE,0BAAA;EA5CF;EA+CA;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,cAAA;EA7CF;EAgDA;IACE,0BAAA;IACA,wBAAA;EA9CF;EAiDA;IACE,yBAAA;EA/CF;EAkDA;IACE,WAAA;IACA,gBAAA;EAhDF;EAmDA;IACE,qBAAA;EAjDF;EAoDA;IACE,qBAAA;EAlDF;EAqDA;IACE,qBAAA;EAnDF;EAsDA;IACE,qBAAA;EApDF;EAuDA;IACE,qBAAA;EArDF;EAwDA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;EAtDF;AACF;AAyDA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAvDF;;AA0DA;EACE,oBAAA;AAvDF;;AA0DA;EACE,oBAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,gBAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,6BAAA;EACA,4BAAA;AAvDF;;AA0DA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,8BAAA;AAvDF;;AA0DA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,oBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAvDF;;AA0DA;EACE,oBAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,kBAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,oBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,cAAA;EACA,2CAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,2CAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;;EAEE,cAAA;AAvDF;;AA0DA;EACE,6BAAA;EACA,iBAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,gBAAA;AAvDF;;AA0DA;EACE,wBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,gBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,YAAA;EACA,6BAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,qBAAA;EACA,uBAAA;EACA,yDAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,wBAAA;AAvDF;;AA0DA;EACE,oBAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,oBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,cAAA;EACA,2CAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,2CAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;;EAEE,cAAA;AAvDF;;AA0DA;EACE,6BAAA;EACA,iBAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,0BAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,gBAAA;AAvDF;;AA0DA;EACE,wBAAA;EACA,SAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,oBAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,wBAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,8DAAA;AAvDF;;AA0DA;EACE,oCAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,gBAAA;AAvDF;;AA0DA;EACE,iBAAA;EACA,oBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,gBAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,YAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,2CAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,uBAAA;AAvDF;;AA0DA;EACE,kBAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;AAvDF;;AA0DA;EACE,gBAAA;AAvDF;;AA0DA;EACE,oBAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,8DAAA;AAvDF;;AA0DA;EACE,oCAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;;EAEE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;;EAEE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;;EAEE,cAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AAvDF;;AA0DA;;EAEE,cAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;AAvDF;;AA0DA;EACE,oCAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kBAAA;EACA,gBAAA;AAvDF;;AA0DA;;EAEE,eAAA;AAvDF;;AA0DA;;EAEE,WAAA;EACA,YAAA;AAvDF;;AA0DA;EACE,oCAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,8BAAA;EACA,cAAA;EACA,aAAA;AAvDF;;AA0DA;EACE,aAAA;AAvDF;;AA0DA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,mBAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,cAAA;AAvDF;;AA0DA;;EAEE,oBAAA;AAvDF;;AA0DA;;EAEE,qBAAA;AAvDF;;AA0DA;EACE,8BAAA;AAvDF;;AA0DA;EACE,oCAAA;AAvDF;;AA0DA;EACE,oCAAA;AAvDF;;AA0DA;EACE,mBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,8BAAA;EACA,qBAAA;AAvDF;;AA0DA;;EAEE,cAAA;EACA,6BAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kBAAA;AAvDF;;AA0DA;;EAEE,oCAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,2BAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAvDF;;AA0DA;EACE,4BAAA;AAvDF;;AA0DA;EACE,4BAAA;AAvDF;;AA0DA;EACE,6BAAA;EACA,cAAA;EACA,8DAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,oCAAA;AAvDF;;AA0DA;EACE,aAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8DAAA;EACA,oBAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,0CAAA;AAvDF;;AA0DA;EACE,iBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,yBAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAvDF;;AA0DA;EACE,iBAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAvDF;;AA0DA;EACE,eAAA;AAvDF;;AA0DA;EACE,yBAAA;AAvDF;;AA0DA;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,gBAAA;EACA,oBAAA;EACA,uBAAA;AAvDF;;AA0DA;EACE,oBAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,8DAAA;EACA,mBAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AAvDF;;AA0DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,8DAAA;AAvDF;;AA0DA;EACE,8BAAA;AAvDF;;AA0DA;EACE,8BAAA;AAvDF;;AA0DA;EACE,iBAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,cAAA;AAvDF;;AA0DA;EACE,yBAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,4GAAA;AAvDF;;AA6DA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,yBAAA;EACA,cAAA;AA1DF;;AA6DA;EACE,yBAAA;EACA,cAAA;AA1DF;;AA6DA;EACE,yBAAA;EACA,cAAA;AA1DF;;AA6DA;EACE,yBAAA;EACA,cAAA;AA1DF;;AA6DA;EACE,qBAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,wBAAA;EACA,kBAAA;EACA,iFAAA;AA1DF;;AA6DA;EACE,mBAAA;EACA,cAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,SAAA;EACA,mBAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,mBAAA;AA1DF;;AA6DA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,0JAAA;AA1DF;;AA8DA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA3DF;;AA8DA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AA3DF;;AA8DA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,gBAAA;AA3DF;;AA8DA;EACE,qEAAA;AA3DF;;AA8DA;EACE,qEAAA;AA3DF;;AA8DA;EACE,UAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,gDAAA;AA3DF;;AA8DA;EACE,yBAAA;AA3DF;;AA8DA;EACE,yBAAA;AA3DF;;AA8DA;EACE,0EAAA;AA3DF;;AA8DA;EACE,0EAAA;AA3DF;;AA8DA;EACE,0EAAA;AA3DF;;AA8DA;EACE,0EAAA;AA3DF;;AA8DA;EACE,0EAAA;AA3DF;;AA8DA;EACE,0EAAA;AA3DF;;AA8DA;EACE,0EAAA;AA3DF;;AA8DA;EACE,mCAAA;AA3DF;;AA8DA;EACE,oCAAA;AA3DF","sourcesContent":[":root {\n  --surface-a: #ffffff;\n  --surface-b: #f8f9fa;\n  --surface-c: #e9ecef;\n  --surface-d: #dee2e6;\n  --surface-e: #ffffff;\n  --surface-f: #ffffff;\n  --text-color: #495057;\n  --text-color-secondary: #6c757d;\n  --primary-color: #6366f1;\n  --primary-color-text: #ffffff;\n  --font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif,\n    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;\n  --surface-0: #ffffff;\n  --surface-50: #fafafa;\n  --surface-100: #f5f5f5;\n  --surface-200: #eeeeee;\n  --surface-300: #e0e0e0;\n  --surface-400: #bdbdbd;\n  --surface-500: #9e9e9e;\n  --surface-600: #757575;\n  --surface-700: #616161;\n  --surface-800: #424242;\n  --surface-900: #212121;\n  --gray-50: #fafafa;\n  --gray-100: #f5f5f5;\n  --gray-200: #eeeeee;\n  --gray-300: #e0e0e0;\n  --gray-400: #bdbdbd;\n  --gray-500: #9e9e9e;\n  --gray-600: #757575;\n  --gray-700: #616161;\n  --gray-800: #424242;\n  --gray-900: #212121;\n  --content-padding: 1.25rem;\n  --inline-spacing: 0.5rem;\n  --border-radius: 6px;\n  --surface-ground: #eff3f8;\n  --surface-section: #ffffff;\n  --surface-card: #ffffff;\n  --surface-overlay: #ffffff;\n  --surface-border: #dfe7ef;\n  --surface-hover: #f6f9fc;\n  --focus-ring: 0 0 0 0.2rem #c7d2fe;\n  --maskbg: rgba(0, 0, 0, 0.4);\n  --highlight-bg: #eef2ff;\n  --highlight-text-color: #4338ca;\n  color-scheme: light;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.p-component {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  font-weight: normal;\n}\n\n.p-component-overlay {\n  background-color: rgba(0, 0, 0, 0.4);\n  transition-duration: 0.2s;\n}\n\n.p-disabled,\n.p-component:disabled {\n  opacity: 0.6;\n}\n\n.p-error {\n  color: #e24c4c;\n}\n\n.p-text-secondary {\n  color: #6c757d;\n}\n\n.pi {\n  font-size: 1rem;\n}\n\n.p-icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.p-link {\n  font-size: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  border-radius: 6px;\n}\n\n.p-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-component-overlay-enter {\n  animation: p-component-overlay-enter-animation 150ms forwards;\n}\n\n.p-component-overlay-leave {\n  animation: p-component-overlay-leave-animation 150ms forwards;\n}\n\n@keyframes p-component-overlay-enter-animation {\n  from {\n    background-color: transparent;\n  }\n\n  to {\n    background-color: var(--maskbg);\n  }\n}\n\n@keyframes p-component-overlay-leave-animation {\n  from {\n    background-color: var(--maskbg);\n  }\n\n  to {\n    background-color: transparent;\n  }\n}\n\n:root {\n  --blue-50: #f5f9ff;\n  --blue-100: #d0e1fd;\n  --blue-200: #abc9fb;\n  --blue-300: #85b2f9;\n  --blue-400: #609af8;\n  --blue-500: #3b82f6;\n  --blue-600: #326fd1;\n  --blue-700: #295bac;\n  --blue-800: #204887;\n  --blue-900: #183462;\n  --green-50: #f4fcf7;\n  --green-100: #caf1d8;\n  --green-200: #a0e6ba;\n  --green-300: #76db9b;\n  --green-400: #4cd07d;\n  --green-500: #22c55e;\n  --green-600: #1da750;\n  --green-700: #188a42;\n  --green-800: #136c34;\n  --green-900: #0e4f26;\n  --yellow-50: #fefbf3;\n  --yellow-100: #faedc4;\n  --yellow-200: #f6de95;\n  --yellow-300: #f2d066;\n  --yellow-400: #eec137;\n  --yellow-500: #eab308;\n  --yellow-600: #c79807;\n  --yellow-700: #a47d06;\n  --yellow-800: #816204;\n  --yellow-900: #5e4803;\n  --cyan-50: #f3fbfd;\n  --cyan-100: #c3edf5;\n  --cyan-200: #94e0ed;\n  --cyan-300: #65d2e4;\n  --cyan-400: #35c4dc;\n  --cyan-500: #06b6d4;\n  --cyan-600: #059bb4;\n  --cyan-700: #047f94;\n  --cyan-800: #036475;\n  --cyan-900: #024955;\n  --pink-50: #fef6fa;\n  --pink-100: #fad3e7;\n  --pink-200: #f7b0d3;\n  --pink-300: #f38ec0;\n  --pink-400: #f06bac;\n  --pink-500: #ec4899;\n  --pink-600: #c93d82;\n  --pink-700: #a5326b;\n  --pink-800: #822854;\n  --pink-900: #5e1d3d;\n  --indigo-50: #f7f7fe;\n  --indigo-100: #dadafc;\n  --indigo-200: #bcbdf9;\n  --indigo-300: #9ea0f6;\n  --indigo-400: #8183f4;\n  --indigo-500: #6366f1;\n  --indigo-600: #5457cd;\n  --indigo-700: #4547a9;\n  --indigo-800: #363885;\n  --indigo-900: #282960;\n  --teal-50: #f3fbfb;\n  --teal-100: #c7eeea;\n  --teal-200: #9ae0d9;\n  --teal-300: #6dd3c8;\n  --teal-400: #41c5b7;\n  --teal-500: #14b8a6;\n  --teal-600: #119c8d;\n  --teal-700: #0e8174;\n  --teal-800: #0b655b;\n  --teal-900: #084a42;\n  --orange-50: #fff8f3;\n  --orange-100: #feddc7;\n  --orange-200: #fcc39b;\n  --orange-300: #fba86f;\n  --orange-400: #fa8e42;\n  --orange-500: #f97316;\n  --orange-600: #d46213;\n  --orange-700: #ae510f;\n  --orange-800: #893f0c;\n  --orange-900: #642e09;\n  --bluegray-50: #f7f8f9;\n  --bluegray-100: #dadee3;\n  --bluegray-200: #bcc3cd;\n  --bluegray-300: #9fa9b7;\n  --bluegray-400: #818ea1;\n  --bluegray-500: #64748b;\n  --bluegray-600: #556376;\n  --bluegray-700: #465161;\n  --bluegray-800: #37404c;\n  --bluegray-900: #282e38;\n  --purple-50: #fbf7ff;\n  --purple-100: #ead6fd;\n  --purple-200: #dab6fc;\n  --purple-300: #c996fa;\n  --purple-400: #b975f9;\n  --purple-500: #a855f7;\n  --purple-600: #8f48d2;\n  --purple-700: #763cad;\n  --purple-800: #5c2f88;\n  --purple-900: #432263;\n  --red-50: #fff5f5;\n  --red-100: #ffd0ce;\n  --red-200: #ffaca7;\n  --red-300: #ff8780;\n  --red-400: #ff6259;\n  --red-500: #ff3d32;\n  --red-600: #d9342b;\n  --red-700: #b32b23;\n  --red-800: #8c221c;\n  --red-900: #661814;\n  --primary-50: #f7f7fe;\n  --primary-100: #dadafc;\n  --primary-200: #bcbdf9;\n  --primary-300: #9ea0f6;\n  --primary-400: #8183f4;\n  --primary-500: #6366f1;\n  --primary-600: #5457cd;\n  --primary-700: #4547a9;\n  --primary-800: #363885;\n  --primary-900: #282960;\n}\n\n.p-autocomplete .p-autocomplete-loader {\n  right: 0.75rem;\n}\n\n.p-autocomplete.p-autocomplete-dd .p-autocomplete-loader {\n  right: 3.75rem;\n}\n\n.p-autocomplete .p-autocomplete-multiple-container {\n  padding: 0.375rem 0.75rem;\n}\n\n.p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled):hover {\n  border-color: #6366f1;\n}\n\n.p-autocomplete .p-autocomplete-multiple-container:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token {\n  padding: 0.375rem 0;\n}\n\n.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-input-token input {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  color: #495057;\n  padding: 0;\n  margin: 0;\n}\n\n.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token {\n  padding: 0.375rem 0.75rem;\n  margin-right: 0.5rem;\n  background: #eef2ff;\n  color: #4338ca;\n  border-radius: 6px;\n}\n\n.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token .p-autocomplete-token-icon {\n  margin-left: 0.5rem;\n}\n\n.p-autocomplete.p-invalid.p-component>.p-inputtext {\n  border-color: #e24c4c;\n}\n\n.p-autocomplete-panel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-autocomplete-panel .p-autocomplete-items {\n  padding: 0.75rem 0;\n}\n\n.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item:hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item-group {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  color: #343a40;\n  background: #ffffff;\n  font-weight: 700;\n}\n\n.p-calendar.p-invalid.p-component>.p-inputtext {\n  border-color: #e24c4c;\n}\n\n.p-datepicker {\n  padding: 0.5rem;\n  background: #ffffff;\n  color: #495057;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n}\n\n.p-datepicker:not(.p-datepicker-inline) {\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {\n  background: #ffffff;\n}\n\n.p-datepicker .p-datepicker-header {\n  padding: 0.5rem;\n  color: #495057;\n  background: #ffffff;\n  font-weight: 600;\n  margin: 0;\n  border-bottom: 1px solid #dee2e6;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-prev,\n.p-datepicker .p-datepicker-header .p-datepicker-next {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,\n.p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-prev:focus,\n.p-datepicker .p-datepicker-header .p-datepicker-next:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-title {\n  line-height: 2rem;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {\n  color: #495057;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  font-weight: 600;\n  padding: 0.5rem;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {\n  color: #6366f1;\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {\n  margin-right: 0.5rem;\n}\n\n.p-datepicker table {\n  font-size: 1rem;\n  margin: 0.5rem 0;\n}\n\n.p-datepicker table th {\n  padding: 0.5rem;\n}\n\n.p-datepicker table th>span {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.p-datepicker table td {\n  padding: 0.5rem;\n}\n\n.p-datepicker table td>span {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  transition: box-shadow 0.2s;\n  border: 1px solid transparent;\n}\n\n.p-datepicker table td>span.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-datepicker table td>span:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-datepicker table td.p-datepicker-today>span {\n  background: #ced4da;\n  color: #495057;\n  border-color: transparent;\n}\n\n.p-datepicker table td.p-datepicker-today>span.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-datepicker .p-datepicker-buttonbar {\n  padding: 1rem 0;\n  border-top: 1px solid #dee2e6;\n}\n\n.p-datepicker .p-datepicker-buttonbar .p-button {\n  width: auto;\n}\n\n.p-datepicker .p-timepicker {\n  border-top: 1px solid #dee2e6;\n  padding: 0.5rem;\n}\n\n.p-datepicker .p-timepicker button {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-datepicker .p-timepicker button:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-datepicker .p-timepicker button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-datepicker .p-timepicker button:last-child {\n  margin-top: 0.2em;\n}\n\n.p-datepicker .p-timepicker span {\n  font-size: 1.25rem;\n}\n\n.p-datepicker .p-timepicker>div {\n  padding: 0 0.5rem;\n}\n\n.p-datepicker.p-datepicker-timeonly .p-timepicker {\n  border-top: 0 none;\n}\n\n.p-datepicker .p-monthpicker {\n  margin: 0.5rem 0;\n}\n\n.p-datepicker .p-monthpicker .p-monthpicker-month {\n  padding: 0.5rem;\n  transition: box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-datepicker .p-yearpicker {\n  margin: 0.5rem 0;\n}\n\n.p-datepicker .p-yearpicker .p-yearpicker-year {\n  padding: 0.5rem;\n  transition: box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {\n  border-left: 1px solid #dee2e6;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:first-child {\n  padding-left: 0;\n}\n\n.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {\n  padding-right: 0;\n  border-left: 0 none;\n}\n\n.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover {\n  background: #e9ecef;\n}\n\n.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover {\n  background: #e9ecef;\n}\n\n.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n@media screen and (max-width: 769px) {\n\n  .p-datepicker table th,\n  .p-datepicker table td {\n    padding: 0;\n  }\n}\n\n.p-cascadeselect {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-cascadeselect:not(.p-disabled):hover {\n  border-color: #6366f1;\n}\n\n.p-cascadeselect:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-cascadeselect .p-cascadeselect-label {\n  background: transparent;\n  border: 0 none;\n  padding: 0.75rem 0.75rem;\n}\n\n.p-cascadeselect .p-cascadeselect-label.p-placeholder {\n  color: #6c757d;\n}\n\n.p-cascadeselect .p-cascadeselect-label:enabled:focus {\n  outline: 0 none;\n  box-shadow: none;\n}\n\n.p-cascadeselect .p-cascadeselect-trigger {\n  background: transparent;\n  color: #6c757d;\n  width: 3rem;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-cascadeselect.p-invalid.p-component {\n  border-color: #e24c4c;\n}\n\n.p-cascadeselect-panel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items {\n  padding: 0.75rem 0;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item {\n  margin: 0;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content {\n  padding: 0.75rem 1.25rem;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item:not(.p-highlight):not(.p-disabled):hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon {\n  font-size: 0.875rem;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-group-icon.p-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.p-input-filled .p-cascadeselect {\n  background: #e9ecef;\n}\n\n.p-input-filled .p-cascadeselect:not(.p-disabled):hover {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-cascadeselect:not(.p-disabled).p-focus {\n  background-color: #ffffff;\n}\n\n.p-checkbox {\n  width: 22px;\n  height: 22px;\n}\n\n.p-checkbox .p-checkbox-box {\n  border: 2px solid #ced4da;\n  background: #ffffff;\n  width: 22px;\n  height: 22px;\n  color: #495057;\n  border-radius: 6px;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-checkbox .p-checkbox-box .p-checkbox-icon {\n  transition-duration: 0.2s;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.p-checkbox .p-checkbox-box .p-checkbox-icon.p-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.p-checkbox .p-checkbox-box.p-highlight {\n  border-color: #6366f1;\n  background: #6366f1;\n}\n\n.p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {\n  border-color: #4338ca;\n  background: #4338ca;\n  color: #ffffff;\n}\n\n.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {\n  border-color: #6366f1;\n}\n\n.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {\n  border-color: #4338ca;\n  background: #4338ca;\n  color: #ffffff;\n}\n\n.p-checkbox.p-invalid>.p-checkbox-box {\n  border-color: #e24c4c;\n}\n\n.p-input-filled .p-checkbox .p-checkbox-box {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-checkbox .p-checkbox-box.p-highlight {\n  background: #6366f1;\n}\n\n.p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {\n  background: #4338ca;\n}\n\n.p-chips .p-chips-multiple-container {\n  padding: 0.375rem 0.75rem;\n}\n\n.p-chips .p-chips-multiple-container:not(.p-disabled):hover {\n  border-color: #6366f1;\n}\n\n.p-chips .p-chips-multiple-container:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-chips .p-chips-multiple-container .p-chips-token {\n  padding: 0.375rem 0.75rem;\n  margin-right: 0.5rem;\n  background: #dee2e6;\n  color: #495057;\n  border-radius: 16px;\n}\n\n.p-chips .p-chips-multiple-container .p-chips-token .p-chips-token-icon {\n  margin-left: 0.5rem;\n}\n\n.p-chips .p-chips-multiple-container .p-chips-input-token {\n  padding: 0.375rem 0;\n}\n\n.p-chips .p-chips-multiple-container .p-chips-input-token input {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  color: #495057;\n  padding: 0;\n  margin: 0;\n}\n\n.p-chips.p-invalid.p-component>.p-inputtext {\n  border-color: #e24c4c;\n}\n\n.p-colorpicker-preview {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-colorpicker-panel {\n  background: #323232;\n  border: 1px solid #191919;\n}\n\n.p-colorpicker-panel .p-colorpicker-color-handle,\n.p-colorpicker-panel .p-colorpicker-hue-handle {\n  border-color: #ffffff;\n}\n\n.p-colorpicker-overlay-panel {\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-dropdown {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-dropdown:not(.p-disabled):hover {\n  border-color: #6366f1;\n}\n\n.p-dropdown:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-dropdown.p-dropdown-clearable .p-dropdown-label {\n  padding-right: 1.75rem;\n}\n\n.p-dropdown .p-dropdown-label {\n  background: transparent;\n  border: 0 none;\n}\n\n.p-dropdown .p-dropdown-label.p-placeholder {\n  color: #6c757d;\n}\n\n.p-dropdown .p-dropdown-label:enabled:focus {\n  outline: 0 none;\n  box-shadow: none;\n}\n\n.p-dropdown .p-dropdown-trigger {\n  background: transparent;\n  color: #6c757d;\n  width: 3rem;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-dropdown .p-dropdown-clear-icon {\n  color: #6c757d;\n  right: 3rem;\n}\n\n.p-dropdown.p-invalid.p-component {\n  border-color: #e24c4c;\n}\n\n.p-dropdown-panel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-dropdown-panel .p-dropdown-header {\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #dee2e6;\n  color: #343a40;\n  background: #f8f9fa;\n  margin: 0;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-dropdown-panel .p-dropdown-header .p-dropdown-filter {\n  padding-right: 1.75rem;\n  margin-right: -1.75rem;\n}\n\n.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter {\n  padding-right: 3.5rem;\n  margin-right: -3.5rem;\n}\n\n.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon {\n  right: 2.5rem;\n}\n\n.p-dropdown-panel .p-dropdown-items {\n  padding: 0.75rem 0;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item-group {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  color: #343a40;\n  background: #ffffff;\n  font-weight: 700;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-empty-message {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  background: transparent;\n}\n\n.p-input-filled .p-dropdown {\n  background: #e9ecef;\n}\n\n.p-input-filled .p-dropdown:not(.p-disabled):hover {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-dropdown:not(.p-disabled).p-focus {\n  background-color: #ffffff;\n}\n\n.p-input-filled .p-dropdown:not(.p-disabled).p-focus .p-inputtext {\n  background-color: transparent;\n}\n\n.p-editor-container .p-editor-toolbar {\n  background: #f8f9fa;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow {\n  border: 1px solid #dee2e6;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-stroke {\n  stroke: #6c757d;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-fill {\n  fill: #6c757d;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label {\n  border: 0 none;\n  color: #6c757d;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover {\n  color: #495057;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-stroke {\n  stroke: #495057;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker .ql-picker-label:hover .ql-fill {\n  fill: #495057;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #495057;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #495057;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #495057;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  padding: 0.75rem 0;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item {\n  color: #495057;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options .ql-picker-item:hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-editor-container .p-editor-toolbar.ql-snow .ql-picker.ql-expanded:not(.ql-icon-picker) .ql-picker-item {\n  padding: 0.75rem 1.25rem;\n}\n\n.p-editor-container .p-editor-content {\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-editor-container .p-editor-content.ql-snow {\n  border: 1px solid #dee2e6;\n}\n\n.p-editor-container .p-editor-content .ql-editor {\n  background: #ffffff;\n  color: #495057;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button:hover,\n.p-editor-container .ql-snow.ql-toolbar button:focus {\n  color: #495057;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button:hover .ql-stroke,\n.p-editor-container .ql-snow.ql-toolbar button:focus .ql-stroke {\n  stroke: #495057;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button:hover .ql-fill,\n.p-editor-container .ql-snow.ql-toolbar button:focus .ql-fill {\n  fill: #495057;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected {\n  color: #6366f1;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke {\n  stroke: #6366f1;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-fill,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill {\n  fill: #6366f1;\n}\n\n.p-editor-container .ql-snow.ql-toolbar button.ql-active .ql-picker-label,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-picker-label,\n.p-editor-container .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-picker-label {\n  color: #6366f1;\n}\n\n.p-inputgroup-addon {\n  background: #e9ecef;\n  color: #6c757d;\n  border-top: 1px solid #ced4da;\n  border-left: 1px solid #ced4da;\n  border-bottom: 1px solid #ced4da;\n  padding: 0.75rem 0.75rem;\n  min-width: 3rem;\n}\n\n.p-inputgroup-addon:last-child {\n  border-right: 1px solid #ced4da;\n}\n\n.p-inputgroup>.p-component,\n.p-inputgroup>.p-inputwrapper>.p-inputtext,\n.p-inputgroup>.p-float-label>.p-component {\n  border-radius: 0;\n  margin: 0;\n}\n\n.p-inputgroup>.p-component+.p-inputgroup-addon,\n.p-inputgroup>.p-inputwrapper>.p-inputtext+.p-inputgroup-addon,\n.p-inputgroup>.p-float-label>.p-component+.p-inputgroup-addon {\n  border-left: 0 none;\n}\n\n.p-inputgroup>.p-component:focus,\n.p-inputgroup>.p-inputwrapper>.p-inputtext:focus,\n.p-inputgroup>.p-float-label>.p-component:focus {\n  z-index: 1;\n}\n\n.p-inputgroup>.p-component:focus~label,\n.p-inputgroup>.p-inputwrapper>.p-inputtext:focus~label,\n.p-inputgroup>.p-float-label>.p-component:focus~label {\n  z-index: 1;\n}\n\n.p-inputgroup-addon:first-child,\n.p-inputgroup button:first-child,\n.p-inputgroup input:first-child,\n.p-inputgroup>.p-inputwrapper:first-child,\n.p-inputgroup>.p-inputwrapper:first-child>.p-inputtext {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-inputgroup .p-float-label:first-child input {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-inputgroup-addon:last-child,\n.p-inputgroup button:last-child,\n.p-inputgroup input:last-child,\n.p-inputgroup>.p-inputwrapper:last-child,\n.p-inputgroup>.p-inputwrapper:last-child>.p-inputtext {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-inputgroup .p-float-label:last-child input {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-fluid .p-inputgroup .p-button {\n  width: auto;\n}\n\n.p-fluid .p-inputgroup .p-button.p-button-icon-only {\n  width: 3rem;\n}\n\n.p-inputnumber.p-invalid.p-component>.p-inputtext {\n  border-color: #e24c4c;\n}\n\n.p-inputswitch {\n  width: 3rem;\n  height: 1.75rem;\n}\n\n.p-inputswitch .p-inputswitch-slider {\n  background: #ced4da;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 30px;\n}\n\n.p-inputswitch .p-inputswitch-slider:before {\n  background: #ffffff;\n  width: 1.25rem;\n  height: 1.25rem;\n  left: 0.25rem;\n  margin-top: -0.625rem;\n  border-radius: 50%;\n  transition-duration: 0.2s;\n}\n\n.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {\n  transform: translateX(1.25rem);\n}\n\n.p-inputswitch.p-focus .p-inputswitch-slider {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider {\n  background: #b6bfc8;\n}\n\n.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {\n  background: #6366f1;\n}\n\n.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {\n  background: #ffffff;\n}\n\n.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {\n  background: #4f46e5;\n}\n\n.p-inputswitch.p-invalid .p-inputswitch-slider {\n  border-color: #e24c4c;\n}\n\n.p-inputtext {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  color: #495057 !important;\n  background: #ffffff;\n  padding: 0.75rem 0.75rem;\n  border: 1px solid #ced4da;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  appearance: none;\n  border-radius: 6px;\n}\n\n// .p-inputtext:enabled:hover {\n//   border-color: #6366f1;\n// }\n\n.p-inputtext:enabled:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  // border-color: #6366f1;\n  border: 1px solid #ced4da !important;\n}\n\n.p-inputtext.p-invalid.p-component {\n  border-color: #e24c4c;\n}\n\n.p-inputtext.p-inputtext-sm {\n  font-size: 0.875rem;\n  padding: 0.65625rem 0.65625rem;\n}\n\n.p-inputtext.p-inputtext-lg {\n  font-size: 1.25rem;\n  padding: 0.9375rem 0.9375rem;\n}\n\n.p-float-label>label {\n  left: 0.75rem;\n  color: #6c757d;\n  transition-duration: 0.2s;\n}\n\n.p-float-label>label.p-error {\n  color: #e24c4c;\n}\n\n.p-input-icon-left>i:first-of-type,\n.p-input-icon-left>svg:first-of-type,\n.p-input-icon-left>.p-input-prefix {\n  left: 0.75rem;\n  color: #6c757d;\n}\n\n.p-input-icon-left>.p-inputtext {\n  padding-left: 2.5rem;\n}\n\n.p-input-icon-left.p-float-label>label {\n  left: 2.5rem;\n}\n\n.p-input-icon-right>i:last-of-type,\n.p-input-icon-right>svg:last-of-type,\n.p-input-icon-right>.p-input-suffix {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-input-icon-right>.p-inputtext {\n  padding-right: 2.5rem;\n}\n\n::-webkit-input-placeholder {\n  color: #6c757d;\n}\n\n:-moz-placeholder {\n  color: #6c757d;\n}\n\n::-moz-placeholder {\n  color: #6c757d;\n}\n\n:-ms-input-placeholder {\n  color: #6c757d;\n}\n\n.p-input-filled .p-inputtext {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-inputtext:enabled:hover {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-inputtext:enabled:focus {\n  background-color: #ffffff;\n}\n\n.p-inputtext-sm .p-inputtext {\n  font-size: 0.875rem;\n  padding: 0.65625rem 0.65625rem;\n}\n\n.p-inputtext-lg .p-inputtext {\n  font-size: 1.25rem;\n  padding: 0.9375rem 0.9375rem;\n}\n\n.p-listbox {\n  background: #ffffff;\n  color: #495057;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n}\n\n.p-listbox .p-listbox-header {\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #dee2e6;\n  color: #343a40;\n  background: #f8f9fa;\n  margin: 0;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-listbox .p-listbox-header .p-listbox-filter {\n  padding-right: 1.75rem;\n}\n\n.p-listbox .p-listbox-header .p-listbox-filter-icon {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-listbox .p-listbox-list {\n  padding: 0.75rem 0;\n}\n\n.p-listbox .p-listbox-list .p-listbox-item {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  border: 0 none;\n  color: #495057;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-listbox .p-listbox-list .p-listbox-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-listbox .p-listbox-list .p-listbox-item:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-listbox .p-listbox-list .p-listbox-item-group {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  color: #343a40;\n  background: #ffffff;\n  font-weight: 700;\n}\n\n.p-listbox .p-listbox-list .p-listbox-empty-message {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  background: transparent;\n}\n\n.p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-listbox.p-invalid {\n  border-color: #e24c4c;\n}\n\n.p-mention-panel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-mention-panel .p-mention-items {\n  padding: 0.75rem 0;\n}\n\n.p-mention-panel .p-mention-items .p-mention-item {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-mention-panel .p-mention-items .p-mention-item:hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-mention-panel .p-mention-items .p-mention-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-multiselect {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-multiselect:not(.p-disabled):hover {\n  border-color: #6366f1;\n}\n\n.p-multiselect:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-multiselect.p-multiselect-clearable .p-multiselect-label {\n  padding-right: 1.75rem;\n}\n\n.p-multiselect .p-multiselect-label {\n  padding: 0.75rem 0.75rem;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-multiselect .p-multiselect-label.p-placeholder {\n  color: #6c757d;\n}\n\n.p-multiselect.p-multiselect-chip .p-multiselect-token {\n  padding: 0.375rem 0.75rem;\n  margin-right: 0.5rem;\n  background: #dee2e6;\n  color: #495057;\n  border-radius: 16px;\n}\n\n.p-multiselect.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {\n  margin-left: 0.5rem;\n}\n\n.p-multiselect .p-multiselect-trigger {\n  background: transparent;\n  color: #6c757d;\n  width: 3rem;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-multiselect .p-multiselect-clear-icon {\n  color: #6c757d;\n  right: 3rem;\n}\n\n.p-multiselect.p-invalid.p-component {\n  border-color: #e24c4c;\n}\n\n.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label {\n  padding: 0.375rem 0.75rem;\n}\n\n.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label.p-multiselect-items-label {\n  padding: 0.75rem 0.75rem;\n}\n\n.p-inputwrapper-filled.p-multiselect.p-multiselect-clearable .p-multiselect-label {\n  padding-right: 1.75rem;\n}\n\n.p-multiselect-panel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-multiselect-panel .p-multiselect-header {\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #dee2e6;\n  color: #343a40;\n  background: #f8f9fa;\n  margin: 0;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container {\n  margin: 0 0.5rem;\n}\n\n.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-inputtext {\n  padding-right: 1.75rem;\n}\n\n.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-multiselect-panel .p-multiselect-header .p-multiselect-close {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-multiselect-panel .p-multiselect-items {\n  padding: 0.75rem 0;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {\n  margin-right: 0.5rem;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item-group {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  color: #343a40;\n  background: #ffffff;\n  font-weight: 700;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-empty-message {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  background: transparent;\n}\n\n.p-input-filled .p-multiselect {\n  background: #e9ecef;\n}\n\n.p-input-filled .p-multiselect:not(.p-disabled):hover {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-multiselect:not(.p-disabled).p-focus {\n  background-color: #ffffff;\n}\n\n.p-password.p-invalid.p-component>.p-inputtext {\n  border-color: #e24c4c;\n}\n\n.p-password-panel {\n  padding: 1.25rem;\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n}\n\n.p-password-panel .p-password-meter {\n  margin-bottom: 0.5rem;\n  background: #dee2e6;\n}\n\n.p-password-panel .p-password-meter .p-password-strength.weak {\n  background: #ea5455;\n}\n\n.p-password-panel .p-password-meter .p-password-strength.medium {\n  background: #ff9f42;\n}\n\n.p-password-panel .p-password-meter .p-password-strength.strong {\n  background: #29c76f;\n}\n\n.p-radiobutton {\n  width: 22px;\n  height: 22px;\n}\n\n.p-radiobutton .p-radiobutton-box {\n  border: 2px solid #ced4da;\n  background: #ffffff;\n  width: 22px;\n  height: 22px;\n  color: #495057;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {\n  border-color: #6366f1;\n}\n\n.p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {\n  width: 12px;\n  height: 12px;\n  transition-duration: 0.2s;\n  background-color: #ffffff;\n}\n\n.p-radiobutton .p-radiobutton-box.p-highlight {\n  border-color: #6366f1;\n  background: #6366f1;\n}\n\n.p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {\n  border-color: #4338ca;\n  background: #4338ca;\n  color: #ffffff;\n}\n\n.p-radiobutton.p-invalid>.p-radiobutton-box {\n  border-color: #e24c4c;\n}\n\n.p-radiobutton:focus {\n  outline: 0 none;\n}\n\n.p-input-filled .p-radiobutton .p-radiobutton-box {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-radiobutton .p-radiobutton-box:not(.p-disabled):hover {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight {\n  background: #6366f1;\n}\n\n.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {\n  background: #4338ca;\n}\n\n.p-rating {\n  gap: 0.5rem;\n}\n\n.p-rating .p-rating-item .p-rating-icon {\n  color: #495057;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  font-size: 1.143rem;\n}\n\n.p-rating .p-rating-item .p-rating-icon.p-icon {\n  width: 1.143rem;\n  height: 1.143rem;\n}\n\n.p-rating .p-rating-item .p-rating-icon.p-rating-cancel {\n  color: #ea5455;\n}\n\n.p-rating .p-rating-item:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-rating .p-rating-item.p-rating-item-active .p-rating-icon {\n  color: #6366f1;\n}\n\n.p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon {\n  color: #6366f1;\n}\n\n.p-rating:not(.p-disabled):not(.p-readonly) .p-rating-item:hover .p-rating-icon.p-rating-cancel {\n  color: #e73d3e;\n}\n\n.p-selectbutton .p-button {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  color: #495057;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-selectbutton .p-button .p-button-icon-left,\n.p-selectbutton .p-button .p-button-icon-right {\n  color: #6c757d;\n}\n\n.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {\n  background: #e9ecef;\n  border-color: #ced4da;\n  color: #495057;\n}\n\n.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,\n.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {\n  color: #343a40;\n}\n\n.p-selectbutton .p-button.p-highlight {\n  background: #6366f1;\n  border-color: #6366f1;\n  color: #ffffff;\n}\n\n.p-selectbutton .p-button.p-highlight .p-button-icon-left,\n.p-selectbutton .p-button.p-highlight .p-button-icon-right {\n  color: #ffffff;\n}\n\n.p-selectbutton .p-button.p-highlight:hover {\n  background: #4f46e5;\n  border-color: #4f46e5;\n  color: #ffffff;\n}\n\n.p-selectbutton .p-button.p-highlight:hover .p-button-icon-left,\n.p-selectbutton .p-button.p-highlight:hover .p-button-icon-right {\n  color: #ffffff;\n}\n\n.p-selectbutton.p-invalid>.p-button {\n  border-color: #e24c4c;\n}\n\n.p-slider {\n  background: #dee2e6;\n  border: 0 none;\n  border-radius: 6px;\n}\n\n.p-slider.p-slider-horizontal {\n  height: 0.286rem;\n}\n\n.p-slider.p-slider-horizontal .p-slider-handle {\n  margin-top: -0.5715rem;\n  margin-left: -0.5715rem;\n}\n\n.p-slider.p-slider-vertical {\n  width: 0.286rem;\n}\n\n.p-slider.p-slider-vertical .p-slider-handle {\n  margin-left: -0.5715rem;\n  margin-bottom: -0.5715rem;\n}\n\n.p-slider .p-slider-handle {\n  height: 1.143rem;\n  width: 1.143rem;\n  background: #ffffff;\n  border: 2px solid #6366f1;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-slider .p-slider-handle:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-slider .p-slider-range {\n  background: #6366f1;\n}\n\n.p-slider:not(.p-disabled) .p-slider-handle:hover {\n  background: #6366f1;\n  border-color: #6366f1;\n}\n\n.p-treeselect {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-treeselect:not(.p-disabled):hover {\n  border-color: #6366f1;\n}\n\n.p-treeselect:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-treeselect .p-treeselect-label {\n  padding: 0.75rem 0.75rem;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-treeselect .p-treeselect-label.p-placeholder {\n  color: #6c757d;\n}\n\n.p-treeselect.p-treeselect-chip .p-treeselect-token {\n  padding: 0.375rem 0.75rem;\n  margin-right: 0.5rem;\n  background: #dee2e6;\n  color: #495057;\n  border-radius: 16px;\n}\n\n.p-treeselect .p-treeselect-trigger {\n  background: transparent;\n  color: #6c757d;\n  width: 3rem;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-treeselect.p-invalid.p-component {\n  border-color: #e24c4c;\n}\n\n.p-inputwrapper-filled.p-treeselect.p-treeselect-chip .p-treeselect-label {\n  padding: 0.375rem 0.75rem;\n}\n\n.p-treeselect-panel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-treeselect-panel .p-treeselect-header {\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #dee2e6;\n  color: #343a40;\n  background: #f8f9fa;\n  margin: 0;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container {\n  margin-right: 0.5rem;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter {\n  padding-right: 1.75rem;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container .p-treeselect-filter-icon {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter {\n  padding-right: 3.5rem;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-filter-container.p-treeselect-clearable-filter .p-treeselect-filter-clear-icon {\n  right: 2.5rem;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-close {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-close:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-treeselect-panel .p-treeselect-header .p-treeselect-close:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-treeselect-panel .p-treeselect-items-wrapper .p-tree {\n  border: 0 none;\n}\n\n.p-treeselect-panel .p-treeselect-items-wrapper .p-treeselect-empty-message {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  background: transparent;\n}\n\n.p-input-filled .p-treeselect {\n  background: #e9ecef;\n}\n\n.p-input-filled .p-treeselect:not(.p-disabled):hover {\n  background-color: #e9ecef;\n}\n\n.p-input-filled .p-treeselect:not(.p-disabled).p-focus {\n  background-color: #ffffff;\n}\n\n.p-togglebutton.p-button {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  color: #495057;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-togglebutton.p-button .p-button-icon-left,\n.p-togglebutton.p-button .p-button-icon-right {\n  color: #6c757d;\n}\n\n.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover {\n  background: #e9ecef;\n  border-color: #ced4da;\n  color: #495057;\n}\n\n.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,\n.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {\n  color: #343a40;\n}\n\n.p-togglebutton.p-button.p-highlight {\n  background: #6366f1;\n  border-color: #6366f1;\n  color: #ffffff;\n}\n\n.p-togglebutton.p-button.p-highlight .p-button-icon-left,\n.p-togglebutton.p-button.p-highlight .p-button-icon-right {\n  color: #ffffff;\n}\n\n.p-togglebutton.p-button.p-highlight:hover {\n  background: #4f46e5;\n  border-color: #4f46e5;\n  color: #ffffff;\n}\n\n.p-togglebutton.p-button.p-highlight:hover .p-button-icon-left,\n.p-togglebutton.p-button.p-highlight:hover .p-button-icon-right {\n  color: #ffffff;\n}\n\n.p-togglebutton.p-button.p-invalid>.p-button {\n  border-color: #e24c4c;\n}\n\n.p-button {\n  color: #ffffff;\n  background: #6366f1;\n  border: 1px solid #6366f1;\n  padding: 0.75rem 1.25rem;\n  font-size: 1rem;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-button:enabled:hover,\n.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: #4f46e5;\n  color: #ffffff;\n  border-color: #4f46e5;\n}\n\n.p-button:enabled:active,\n.p-button:not(button):not(a):not(.p-disabled):active {\n  background: #4338ca;\n  color: #ffffff;\n  border-color: #4338ca;\n}\n\n.p-button.p-button-outlined {\n  background-color: transparent;\n  color: #6366f1;\n  border: 1px solid;\n}\n\n.p-button.p-button-outlined:enabled:hover,\n.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(99, 102, 241, 0.04);\n  color: #6366f1;\n  border: 1px solid;\n}\n\n.p-button.p-button-outlined:enabled:active,\n.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: rgba(99, 102, 241, 0.16);\n  color: #6366f1;\n  border: 1px solid;\n}\n\n.p-button.p-button-outlined.p-button-plain {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n\n.p-button.p-button-outlined.p-button-plain:enabled:hover,\n.p-button.p-button-outlined.p-button-plain:not(button):not(a):not(.p-disabled):hover {\n  background: #e9ecef;\n  color: #6c757d;\n}\n\n.p-button.p-button-outlined.p-button-plain:enabled:active,\n.p-button.p-button-outlined.p-button-plain:not(button):not(a):not(.p-disabled):active {\n  background: #dee2e6;\n  color: #6c757d;\n}\n\n.p-button.p-button-text {\n  background-color: transparent;\n  color: #6366f1;\n  border-color: transparent;\n}\n\n.p-button.p-button-text:enabled:hover,\n.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(99, 102, 241, 0.04);\n  color: #6366f1;\n  border-color: transparent;\n}\n\n.p-button.p-button-text:enabled:active,\n.p-button.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background: rgba(99, 102, 241, 0.16);\n  color: #6366f1;\n  border-color: transparent;\n}\n\n.p-button.p-button-text.p-button-plain {\n  color: #6c757d;\n}\n\n.p-button.p-button-text.p-button-plain:enabled:hover,\n.p-button.p-button-text.p-button-plain:not(button):not(a):not(.p-disabled):hover {\n  background: #e9ecef;\n  color: #6c757d;\n}\n\n.p-button.p-button-text.p-button-plain:enabled:active,\n.p-button.p-button-text.p-button-plain:not(button):not(a):not(.p-disabled):active {\n  background: #dee2e6;\n  color: #6c757d;\n}\n\n.p-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-button .p-button-label {\n  transition-duration: 0.2s;\n}\n\n.p-button .p-button-icon-left {\n  margin-right: 0.5rem;\n}\n\n.p-button .p-button-icon-right {\n  margin-left: 0.5rem;\n}\n\n.p-button .p-button-icon-bottom {\n  margin-top: 0.5rem;\n}\n\n.p-button .p-button-icon-top {\n  margin-bottom: 0.5rem;\n}\n\n.p-button .p-badge {\n  margin-left: 0.5rem;\n  min-width: 1rem;\n  height: 1rem;\n  line-height: 1rem;\n  color: #6366f1;\n  background-color: #ffffff;\n}\n\n.p-button.p-button-raised {\n  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.p-button.p-button-rounded {\n  border-radius: 2rem;\n}\n\n.p-button.p-button-icon-only {\n  width: 3rem;\n  padding: 0.75rem 0;\n}\n\n.p-button.p-button-icon-only .p-button-icon-left,\n.p-button.p-button-icon-only .p-button-icon-right {\n  margin: 0;\n}\n\n.p-button.p-button-icon-only.p-button-rounded {\n  border-radius: 50%;\n  height: 3rem;\n}\n\n.p-button.p-button-sm {\n  font-size: 0.875rem;\n  padding: 0.65625rem 1.09375rem;\n}\n\n.p-button.p-button-sm .p-button-icon {\n  font-size: 0.875rem;\n}\n\n.p-button.p-button-lg {\n  font-size: 1.25rem;\n  padding: 0.9375rem 1.5625rem;\n}\n\n.p-button.p-button-lg .p-button-icon {\n  font-size: 1.25rem;\n}\n\n.p-button.p-button-loading-label-only.p-button-loading-left .p-button-label {\n  margin-left: 0.5rem;\n}\n\n.p-button.p-button-loading-label-only.p-button-loading-right .p-button-label {\n  margin-right: 0.5rem;\n}\n\n.p-button.p-button-loading-label-only.p-button-loading-top .p-button-label {\n  margin-top: 0.5rem;\n}\n\n.p-button.p-button-loading-label-only.p-button-loading-bottom .p-button-label {\n  margin-bottom: 0.5rem;\n}\n\n.p-button.p-button-loading-label-only .p-button-loading-icon {\n  margin: 0;\n}\n\n.p-fluid .p-button {\n  width: 100%;\n}\n\n.p-fluid .p-button-icon-only {\n  width: 3rem;\n}\n\n.p-fluid .p-buttonset {\n  display: flex;\n}\n\n.p-fluid .p-buttonset .p-button {\n  flex: 1;\n}\n\n.p-button.p-button-secondary,\n.p-buttonset.p-button-secondary>.p-button,\n.p-splitbutton.p-button-secondary>.p-button,\n.p-fileupload-choose.p-button-secondary {\n  color: #ffffff;\n  background: #64748b;\n  border: 1px solid #64748b;\n}\n\n.p-button.p-button-secondary:enabled:hover,\n.p-button.p-button-secondary:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-secondary>.p-button:enabled:hover,\n.p-buttonset.p-button-secondary>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-secondary>.p-button:enabled:hover,\n.p-splitbutton.p-button-secondary>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-secondary:enabled:hover,\n.p-fileupload-choose.p-button-secondary:not(button):not(a):not(.p-disabled):hover {\n  background: #475569;\n  color: #ffffff;\n  border-color: #475569;\n}\n\n.p-button.p-button-secondary:enabled:focus,\n.p-button.p-button-secondary:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-secondary>.p-button:enabled:focus,\n.p-buttonset.p-button-secondary>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-secondary>.p-button:enabled:focus,\n.p-splitbutton.p-button-secondary>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-secondary:enabled:focus,\n.p-fileupload-choose.p-button-secondary:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0 0 0 0.2rem #e2e8f0;\n}\n\n.p-button.p-button-secondary:enabled:active,\n.p-button.p-button-secondary:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-secondary>.p-button:enabled:active,\n.p-buttonset.p-button-secondary>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-secondary>.p-button:enabled:active,\n.p-splitbutton.p-button-secondary>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-secondary:enabled:active,\n.p-fileupload-choose.p-button-secondary:not(button):not(a):not(.p-disabled):active {\n  background: #334155;\n  color: #ffffff;\n  border-color: #334155;\n}\n\n.p-button.p-button-secondary.p-button-outlined,\n.p-buttonset.p-button-secondary>.p-button.p-button-outlined,\n.p-splitbutton.p-button-secondary>.p-button.p-button-outlined,\n.p-fileupload-choose.p-button-secondary.p-button-outlined {\n  background-color: transparent;\n  color: #64748b;\n  border: 1px solid;\n}\n\n.p-button.p-button-secondary.p-button-outlined:enabled:hover,\n.p-button.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-secondary>.p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-secondary>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-secondary>.p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-secondary>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-secondary.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(100, 116, 139, 0.04);\n  color: #64748b;\n  border: 1px solid;\n}\n\n.p-button.p-button-secondary.p-button-outlined:enabled:active,\n.p-button.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-secondary>.p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-secondary>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-secondary>.p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-secondary>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-secondary.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-secondary.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: rgba(100, 116, 139, 0.16);\n  color: #64748b;\n  border: 1px solid;\n}\n\n.p-button.p-button-secondary.p-button-text,\n.p-buttonset.p-button-secondary>.p-button.p-button-text,\n.p-splitbutton.p-button-secondary>.p-button.p-button-text,\n.p-fileupload-choose.p-button-secondary.p-button-text {\n  background-color: transparent;\n  color: #64748b;\n  border-color: transparent;\n}\n\n.p-button.p-button-secondary.p-button-text:enabled:hover,\n.p-button.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-secondary>.p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-secondary>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-secondary>.p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-secondary>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-secondary.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(100, 116, 139, 0.04);\n  border-color: transparent;\n  color: #64748b;\n}\n\n.p-button.p-button-secondary.p-button-text:enabled:active,\n.p-button.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-secondary>.p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-secondary>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-secondary>.p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-secondary>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-secondary.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-secondary.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background: rgba(100, 116, 139, 0.16);\n  border-color: transparent;\n  color: #64748b;\n}\n\n.p-button.p-button-info,\n.p-buttonset.p-button-info>.p-button,\n.p-splitbutton.p-button-info>.p-button,\n.p-fileupload-choose.p-button-info {\n  color: #ffffff;\n  background: #3b82f6;\n  border: 1px solid #3b82f6;\n}\n\n.p-button.p-button-info:enabled:hover,\n.p-button.p-button-info:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-info>.p-button:enabled:hover,\n.p-buttonset.p-button-info>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-info>.p-button:enabled:hover,\n.p-splitbutton.p-button-info>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-info:enabled:hover,\n.p-fileupload-choose.p-button-info:not(button):not(a):not(.p-disabled):hover {\n  background: #2563eb;\n  color: #ffffff;\n  border-color: #2563eb;\n}\n\n.p-button.p-button-info:enabled:focus,\n.p-button.p-button-info:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-info>.p-button:enabled:focus,\n.p-buttonset.p-button-info>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-info>.p-button:enabled:focus,\n.p-splitbutton.p-button-info>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-info:enabled:focus,\n.p-fileupload-choose.p-button-info:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0 0 0 0.2rem #bfdbfe;\n}\n\n.p-button.p-button-info:enabled:active,\n.p-button.p-button-info:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-info>.p-button:enabled:active,\n.p-buttonset.p-button-info>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-info>.p-button:enabled:active,\n.p-splitbutton.p-button-info>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-info:enabled:active,\n.p-fileupload-choose.p-button-info:not(button):not(a):not(.p-disabled):active {\n  background: #1d4ed8;\n  color: #ffffff;\n  border-color: #1d4ed8;\n}\n\n.p-button.p-button-info.p-button-outlined,\n.p-buttonset.p-button-info>.p-button.p-button-outlined,\n.p-splitbutton.p-button-info>.p-button.p-button-outlined,\n.p-fileupload-choose.p-button-info.p-button-outlined {\n  background-color: transparent;\n  color: #3b82f6;\n  border: 1px solid;\n}\n\n.p-button.p-button-info.p-button-outlined:enabled:hover,\n.p-button.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-info>.p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-info>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-info>.p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-info>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-info.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(59, 130, 246, 0.04);\n  color: #3b82f6;\n  border: 1px solid;\n}\n\n.p-button.p-button-info.p-button-outlined:enabled:active,\n.p-button.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-info>.p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-info>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-info>.p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-info>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-info.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-info.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: rgba(59, 130, 246, 0.16);\n  color: #3b82f6;\n  border: 1px solid;\n}\n\n.p-button.p-button-info.p-button-text,\n.p-buttonset.p-button-info>.p-button.p-button-text,\n.p-splitbutton.p-button-info>.p-button.p-button-text,\n.p-fileupload-choose.p-button-info.p-button-text {\n  background-color: transparent;\n  color: #3b82f6;\n  border-color: transparent;\n}\n\n.p-button.p-button-info.p-button-text:enabled:hover,\n.p-button.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-info>.p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-info>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-info>.p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-info>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-info.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(59, 130, 246, 0.04);\n  border-color: transparent;\n  color: #3b82f6;\n}\n\n.p-button.p-button-info.p-button-text:enabled:active,\n.p-button.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-info>.p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-info>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-info>.p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-info>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-info.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-info.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background: rgba(59, 130, 246, 0.16);\n  border-color: transparent;\n  color: #3b82f6;\n}\n\n.p-button.p-button-success,\n.p-buttonset.p-button-success>.p-button,\n.p-splitbutton.p-button-success>.p-button,\n.p-fileupload-choose.p-button-success {\n  color: #ffffff;\n  background: #22c55e;\n  border: 1px solid #22c55e;\n}\n\n.p-button.p-button-success:enabled:hover,\n.p-button.p-button-success:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-success>.p-button:enabled:hover,\n.p-buttonset.p-button-success>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-success>.p-button:enabled:hover,\n.p-splitbutton.p-button-success>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-success:enabled:hover,\n.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):hover {\n  background: #16a34a;\n  color: #ffffff;\n  border-color: #16a34a;\n}\n\n.p-button.p-button-success:enabled:focus,\n.p-button.p-button-success:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-success>.p-button:enabled:focus,\n.p-buttonset.p-button-success>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-success>.p-button:enabled:focus,\n.p-splitbutton.p-button-success>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-success:enabled:focus,\n.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0 0 0 0.2rem #bbf7d0;\n}\n\n.p-button.p-button-success:enabled:active,\n.p-button.p-button-success:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-success>.p-button:enabled:active,\n.p-buttonset.p-button-success>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-success>.p-button:enabled:active,\n.p-splitbutton.p-button-success>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-success:enabled:active,\n.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):active {\n  background: #15803d;\n  color: #ffffff;\n  border-color: #15803d;\n}\n\n.p-button.p-button-success.p-button-outlined,\n.p-buttonset.p-button-success>.p-button.p-button-outlined,\n.p-splitbutton.p-button-success>.p-button.p-button-outlined,\n.p-fileupload-choose.p-button-success.p-button-outlined {\n  background-color: transparent;\n  color: #22c55e;\n  border: 1px solid;\n}\n\n.p-button.p-button-success.p-button-outlined:enabled:hover,\n.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-success>.p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-success>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-success>.p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-success>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-success.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(34, 197, 94, 0.04);\n  color: #22c55e;\n  border: 1px solid;\n}\n\n.p-button.p-button-success.p-button-outlined:enabled:active,\n.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-success>.p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-success>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-success>.p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-success>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-success.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: rgba(34, 197, 94, 0.16);\n  color: #22c55e;\n  border: 1px solid;\n}\n\n.p-button.p-button-success.p-button-text,\n.p-buttonset.p-button-success>.p-button.p-button-text,\n.p-splitbutton.p-button-success>.p-button.p-button-text,\n.p-fileupload-choose.p-button-success.p-button-text {\n  background-color: transparent;\n  color: #22c55e;\n  border-color: transparent;\n}\n\n.p-button.p-button-success.p-button-text:enabled:hover,\n.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-success>.p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-success>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-success>.p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-success>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-success.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(34, 197, 94, 0.04);\n  border-color: transparent;\n  color: #22c55e;\n}\n\n.p-button.p-button-success.p-button-text:enabled:active,\n.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-success>.p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-success>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-success>.p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-success>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-success.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background: rgba(34, 197, 94, 0.16);\n  border-color: transparent;\n  color: #22c55e;\n}\n\n.p-button.p-button-warning,\n.p-buttonset.p-button-warning>.p-button,\n.p-splitbutton.p-button-warning>.p-button,\n.p-fileupload-choose.p-button-warning {\n  color: #ffffff;\n  background: #f59e0b;\n  border: 1px solid #f59e0b;\n}\n\n.p-button.p-button-warning:enabled:hover,\n.p-button.p-button-warning:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-warning>.p-button:enabled:hover,\n.p-buttonset.p-button-warning>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-warning>.p-button:enabled:hover,\n.p-splitbutton.p-button-warning>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-warning:enabled:hover,\n.p-fileupload-choose.p-button-warning:not(button):not(a):not(.p-disabled):hover {\n  background: #d97706;\n  color: #ffffff;\n  border-color: #d97706;\n}\n\n.p-button.p-button-warning:enabled:focus,\n.p-button.p-button-warning:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-warning>.p-button:enabled:focus,\n.p-buttonset.p-button-warning>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-warning>.p-button:enabled:focus,\n.p-splitbutton.p-button-warning>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-warning:enabled:focus,\n.p-fileupload-choose.p-button-warning:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0 0 0 0.2rem #fde68a;\n}\n\n.p-button.p-button-warning:enabled:active,\n.p-button.p-button-warning:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-warning>.p-button:enabled:active,\n.p-buttonset.p-button-warning>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-warning>.p-button:enabled:active,\n.p-splitbutton.p-button-warning>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-warning:enabled:active,\n.p-fileupload-choose.p-button-warning:not(button):not(a):not(.p-disabled):active {\n  background: #b45309;\n  color: #ffffff;\n  border-color: #b45309;\n}\n\n.p-button.p-button-warning.p-button-outlined,\n.p-buttonset.p-button-warning>.p-button.p-button-outlined,\n.p-splitbutton.p-button-warning>.p-button.p-button-outlined,\n.p-fileupload-choose.p-button-warning.p-button-outlined {\n  background-color: transparent;\n  color: #f59e0b;\n  border: 1px solid;\n}\n\n.p-button.p-button-warning.p-button-outlined:enabled:hover,\n.p-button.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-warning>.p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-warning>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-warning>.p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-warning>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-warning.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(245, 158, 11, 0.04);\n  color: #f59e0b;\n  border: 1px solid;\n}\n\n.p-button.p-button-warning.p-button-outlined:enabled:active,\n.p-button.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-warning>.p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-warning>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-warning>.p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-warning>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-warning.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-warning.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: rgba(245, 158, 11, 0.16);\n  color: #f59e0b;\n  border: 1px solid;\n}\n\n.p-button.p-button-warning.p-button-text,\n.p-buttonset.p-button-warning>.p-button.p-button-text,\n.p-splitbutton.p-button-warning>.p-button.p-button-text,\n.p-fileupload-choose.p-button-warning.p-button-text {\n  background-color: transparent;\n  color: #f59e0b;\n  border-color: transparent;\n}\n\n.p-button.p-button-warning.p-button-text:enabled:hover,\n.p-button.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-warning>.p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-warning>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-warning>.p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-warning>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-warning.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(245, 158, 11, 0.04);\n  border-color: transparent;\n  color: #f59e0b;\n}\n\n.p-button.p-button-warning.p-button-text:enabled:active,\n.p-button.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-warning>.p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-warning>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-warning>.p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-warning>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-warning.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-warning.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background: rgba(245, 158, 11, 0.16);\n  border-color: transparent;\n  color: #f59e0b;\n}\n\n.p-button.p-button-help,\n.p-buttonset.p-button-help>.p-button,\n.p-splitbutton.p-button-help>.p-button,\n.p-fileupload-choose.p-button-help {\n  color: #ffffff;\n  background: #a855f7;\n  border: 1px solid #a855f7;\n}\n\n.p-button.p-button-help:enabled:hover,\n.p-button.p-button-help:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-help>.p-button:enabled:hover,\n.p-buttonset.p-button-help>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-help>.p-button:enabled:hover,\n.p-splitbutton.p-button-help>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-help:enabled:hover,\n.p-fileupload-choose.p-button-help:not(button):not(a):not(.p-disabled):hover {\n  background: #9333ea;\n  color: #ffffff;\n  border-color: #9333ea;\n}\n\n.p-button.p-button-help:enabled:focus,\n.p-button.p-button-help:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-help>.p-button:enabled:focus,\n.p-buttonset.p-button-help>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-help>.p-button:enabled:focus,\n.p-splitbutton.p-button-help>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-help:enabled:focus,\n.p-fileupload-choose.p-button-help:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0 0 0 0.2rem #e9d5ff;\n}\n\n.p-button.p-button-help:enabled:active,\n.p-button.p-button-help:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-help>.p-button:enabled:active,\n.p-buttonset.p-button-help>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-help>.p-button:enabled:active,\n.p-splitbutton.p-button-help>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-help:enabled:active,\n.p-fileupload-choose.p-button-help:not(button):not(a):not(.p-disabled):active {\n  background: #7e22ce;\n  color: #ffffff;\n  border-color: #7e22ce;\n}\n\n.p-button.p-button-help.p-button-outlined,\n.p-buttonset.p-button-help>.p-button.p-button-outlined,\n.p-splitbutton.p-button-help>.p-button.p-button-outlined,\n.p-fileupload-choose.p-button-help.p-button-outlined {\n  background-color: transparent;\n  color: #a855f7;\n  border: 1px solid;\n}\n\n.p-button.p-button-help.p-button-outlined:enabled:hover,\n.p-button.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-help>.p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-help>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-help>.p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-help>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-help.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(168, 85, 247, 0.04);\n  color: #a855f7;\n  border: 1px solid;\n}\n\n.p-button.p-button-help.p-button-outlined:enabled:active,\n.p-button.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-help>.p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-help>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-help>.p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-help>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-help.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-help.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: rgba(168, 85, 247, 0.16);\n  color: #a855f7;\n  border: 1px solid;\n}\n\n.p-button.p-button-help.p-button-text,\n.p-buttonset.p-button-help>.p-button.p-button-text,\n.p-splitbutton.p-button-help>.p-button.p-button-text,\n.p-fileupload-choose.p-button-help.p-button-text {\n  background-color: transparent;\n  color: #a855f7;\n  border-color: transparent;\n}\n\n.p-button.p-button-help.p-button-text:enabled:hover,\n.p-button.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-help>.p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-help>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-help>.p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-help>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-help.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(168, 85, 247, 0.04);\n  border-color: transparent;\n  color: #a855f7;\n}\n\n.p-button.p-button-help.p-button-text:enabled:active,\n.p-button.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-help>.p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-help>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-help>.p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-help>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-help.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-help.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background: rgba(168, 85, 247, 0.16);\n  border-color: transparent;\n  color: #a855f7;\n}\n\n.p-button.p-button-danger,\n.p-buttonset.p-button-danger>.p-button,\n.p-splitbutton.p-button-danger>.p-button,\n.p-fileupload-choose.p-button-danger {\n  color: #ffffff;\n  background: #ef4444;\n  border: 1px solid #ef4444;\n}\n\n.p-button.p-button-danger:enabled:hover,\n.p-button.p-button-danger:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-danger>.p-button:enabled:hover,\n.p-buttonset.p-button-danger>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-danger>.p-button:enabled:hover,\n.p-splitbutton.p-button-danger>.p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-danger:enabled:hover,\n.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):hover {\n  background: #dc2626;\n  color: #ffffff;\n  border-color: #dc2626;\n}\n\n.p-button.p-button-danger:enabled:focus,\n.p-button.p-button-danger:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-danger>.p-button:enabled:focus,\n.p-buttonset.p-button-danger>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-danger>.p-button:enabled:focus,\n.p-splitbutton.p-button-danger>.p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-danger:enabled:focus,\n.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0 0 0 0.2rem #fecaca;\n}\n\n.p-button.p-button-danger:enabled:active,\n.p-button.p-button-danger:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-danger>.p-button:enabled:active,\n.p-buttonset.p-button-danger>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-danger>.p-button:enabled:active,\n.p-splitbutton.p-button-danger>.p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-danger:enabled:active,\n.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):active {\n  background: #b91c1c;\n  color: #ffffff;\n  border-color: #b91c1c;\n}\n\n.p-button.p-button-danger.p-button-outlined,\n.p-buttonset.p-button-danger>.p-button.p-button-outlined,\n.p-splitbutton.p-button-danger>.p-button.p-button-outlined,\n.p-fileupload-choose.p-button-danger.p-button-outlined {\n  background-color: transparent;\n  color: #ef4444;\n  border: 1px solid;\n}\n\n.p-button.p-button-danger.p-button-outlined:enabled:hover,\n.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-danger>.p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-danger>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-danger>.p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-danger>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(239, 68, 68, 0.04);\n  color: #ef4444;\n  border: 1px solid;\n}\n\n.p-button.p-button-danger.p-button-outlined:enabled:active,\n.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-danger>.p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-danger>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-danger>.p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-danger>.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: rgba(239, 68, 68, 0.16);\n  color: #ef4444;\n  border: 1px solid;\n}\n\n.p-button.p-button-danger.p-button-text,\n.p-buttonset.p-button-danger>.p-button.p-button-text,\n.p-splitbutton.p-button-danger>.p-button.p-button-text,\n.p-fileupload-choose.p-button-danger.p-button-text {\n  background-color: transparent;\n  color: #ef4444;\n  border-color: transparent;\n}\n\n.p-button.p-button-danger.p-button-text:enabled:hover,\n.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-danger>.p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-danger>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-danger>.p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-danger>.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-danger.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(239, 68, 68, 0.04);\n  border-color: transparent;\n  color: #ef4444;\n}\n\n.p-button.p-button-danger.p-button-text:enabled:active,\n.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-danger>.p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-danger>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-danger>.p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-danger>.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-danger.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background: rgba(239, 68, 68, 0.16);\n  border-color: transparent;\n  color: #ef4444;\n}\n\n.p-button.p-button-link {\n  color: #4338ca;\n  background: transparent;\n  border: transparent;\n}\n\n.p-button.p-button-link:enabled:hover,\n.p-button.p-button-link:not(button):not(a):not(.p-disabled):hover {\n  background: transparent;\n  color: #4338ca;\n  border-color: transparent;\n}\n\n.p-button.p-button-link:enabled:hover .p-button-label,\n.p-button.p-button-link:not(button):not(a):not(.p-disabled):hover .p-button-label {\n  text-decoration: underline;\n}\n\n.p-button.p-button-link:enabled:focus,\n.p-button.p-button-link:not(button):not(a):not(.p-disabled):focus {\n  background: transparent;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: transparent;\n}\n\n.p-button.p-button-link:enabled:active,\n.p-button.p-button-link:not(button):not(a):not(.p-disabled):active {\n  background: transparent;\n  color: #4338ca;\n  border-color: transparent;\n}\n\n.p-splitbutton {\n  border-radius: 6px;\n}\n\n.p-splitbutton.p-button-outlined>.p-button {\n  background-color: transparent;\n  color: #6366f1;\n  border: 1px solid;\n}\n\n.p-splitbutton.p-button-outlined>.p-button:enabled:hover,\n.p-splitbutton.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(99, 102, 241, 0.04);\n  color: #6366f1;\n}\n\n.p-splitbutton.p-button-outlined>.p-button:enabled:active,\n.p-splitbutton.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(99, 102, 241, 0.16);\n  color: #6366f1;\n}\n\n.p-splitbutton.p-button-outlined.p-button-plain>.p-button {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n\n.p-splitbutton.p-button-outlined.p-button-plain>.p-button:enabled:hover,\n.p-splitbutton.p-button-outlined.p-button-plain>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: #e9ecef;\n  color: #6c757d;\n}\n\n.p-splitbutton.p-button-outlined.p-button-plain>.p-button:enabled:active,\n.p-splitbutton.p-button-outlined.p-button-plain>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: #dee2e6;\n  color: #6c757d;\n}\n\n.p-splitbutton.p-button-text>.p-button {\n  background-color: transparent;\n  color: #6366f1;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-text>.p-button:enabled:hover,\n.p-splitbutton.p-button-text>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(99, 102, 241, 0.04);\n  color: #6366f1;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-text>.p-button:enabled:active,\n.p-splitbutton.p-button-text>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(99, 102, 241, 0.16);\n  color: #6366f1;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-text.p-button-plain>.p-button {\n  color: #6c757d;\n}\n\n.p-splitbutton.p-button-text.p-button-plain>.p-button:enabled:hover,\n.p-splitbutton.p-button-text.p-button-plain>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: #e9ecef;\n  color: #6c757d;\n}\n\n.p-splitbutton.p-button-text.p-button-plain>.p-button:enabled:active,\n.p-splitbutton.p-button-text.p-button-plain>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: #dee2e6;\n  color: #6c757d;\n}\n\n.p-splitbutton.p-button-raised {\n  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.p-splitbutton.p-button-rounded {\n  border-radius: 2rem;\n}\n\n.p-splitbutton.p-button-rounded>.p-button {\n  border-radius: 2rem;\n}\n\n.p-splitbutton.p-button-sm>.p-button {\n  font-size: 0.875rem;\n  padding: 0.65625rem 1.09375rem;\n}\n\n.p-splitbutton.p-button-sm>.p-button .p-button-icon {\n  font-size: 0.875rem;\n}\n\n.p-splitbutton.p-button-lg>.p-button {\n  font-size: 1.25rem;\n  padding: 0.9375rem 1.5625rem;\n}\n\n.p-splitbutton.p-button-lg>.p-button.p-button-icon-only {\n  width: auto;\n}\n\n.p-splitbutton.p-button-lg>.p-button .p-button-icon {\n  font-size: 1.25rem;\n}\n\n.p-splitbutton.p-button-secondary.p-button-outlined>.p-button {\n  background-color: transparent;\n  color: #64748b;\n  border: 1px solid;\n}\n\n.p-splitbutton.p-button-secondary.p-button-outlined>.p-button:enabled:hover,\n.p-splitbutton.p-button-secondary.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(100, 116, 139, 0.04);\n  color: #64748b;\n}\n\n.p-splitbutton.p-button-secondary.p-button-outlined>.p-button:enabled:active,\n.p-splitbutton.p-button-secondary.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(100, 116, 139, 0.16);\n  color: #64748b;\n}\n\n.p-splitbutton.p-button-secondary.p-button-text>.p-button {\n  background-color: transparent;\n  color: #64748b;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-secondary.p-button-text>.p-button:enabled:hover,\n.p-splitbutton.p-button-secondary.p-button-text>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(100, 116, 139, 0.04);\n  border-color: transparent;\n  color: #64748b;\n}\n\n.p-splitbutton.p-button-secondary.p-button-text>.p-button:enabled:active,\n.p-splitbutton.p-button-secondary.p-button-text>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(100, 116, 139, 0.16);\n  border-color: transparent;\n  color: #64748b;\n}\n\n.p-splitbutton.p-button-info.p-button-outlined>.p-button {\n  background-color: transparent;\n  color: #3b82f6;\n  border: 1px solid;\n}\n\n.p-splitbutton.p-button-info.p-button-outlined>.p-button:enabled:hover,\n.p-splitbutton.p-button-info.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(59, 130, 246, 0.04);\n  color: #3b82f6;\n}\n\n.p-splitbutton.p-button-info.p-button-outlined>.p-button:enabled:active,\n.p-splitbutton.p-button-info.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(59, 130, 246, 0.16);\n  color: #3b82f6;\n}\n\n.p-splitbutton.p-button-info.p-button-text>.p-button {\n  background-color: transparent;\n  color: #3b82f6;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-info.p-button-text>.p-button:enabled:hover,\n.p-splitbutton.p-button-info.p-button-text>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(59, 130, 246, 0.04);\n  border-color: transparent;\n  color: #3b82f6;\n}\n\n.p-splitbutton.p-button-info.p-button-text>.p-button:enabled:active,\n.p-splitbutton.p-button-info.p-button-text>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(59, 130, 246, 0.16);\n  border-color: transparent;\n  color: #3b82f6;\n}\n\n.p-splitbutton.p-button-success.p-button-outlined>.p-button {\n  background-color: transparent;\n  color: #22c55e;\n  border: 1px solid;\n}\n\n.p-splitbutton.p-button-success.p-button-outlined>.p-button:enabled:hover,\n.p-splitbutton.p-button-success.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(34, 197, 94, 0.04);\n  color: #22c55e;\n}\n\n.p-splitbutton.p-button-success.p-button-outlined>.p-button:enabled:active,\n.p-splitbutton.p-button-success.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(34, 197, 94, 0.16);\n  color: #22c55e;\n}\n\n.p-splitbutton.p-button-success.p-button-text>.p-button {\n  background-color: transparent;\n  color: #22c55e;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-success.p-button-text>.p-button:enabled:hover,\n.p-splitbutton.p-button-success.p-button-text>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(34, 197, 94, 0.04);\n  border-color: transparent;\n  color: #22c55e;\n}\n\n.p-splitbutton.p-button-success.p-button-text>.p-button:enabled:active,\n.p-splitbutton.p-button-success.p-button-text>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(34, 197, 94, 0.16);\n  border-color: transparent;\n  color: #22c55e;\n}\n\n.p-splitbutton.p-button-warning.p-button-outlined>.p-button {\n  background-color: transparent;\n  color: #f59e0b;\n  border: 1px solid;\n}\n\n.p-splitbutton.p-button-warning.p-button-outlined>.p-button:enabled:hover,\n.p-splitbutton.p-button-warning.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(245, 158, 11, 0.04);\n  color: #f59e0b;\n}\n\n.p-splitbutton.p-button-warning.p-button-outlined>.p-button:enabled:active,\n.p-splitbutton.p-button-warning.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(245, 158, 11, 0.16);\n  color: #f59e0b;\n}\n\n.p-splitbutton.p-button-warning.p-button-text>.p-button {\n  background-color: transparent;\n  color: #f59e0b;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-warning.p-button-text>.p-button:enabled:hover,\n.p-splitbutton.p-button-warning.p-button-text>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(245, 158, 11, 0.04);\n  border-color: transparent;\n  color: #f59e0b;\n}\n\n.p-splitbutton.p-button-warning.p-button-text>.p-button:enabled:active,\n.p-splitbutton.p-button-warning.p-button-text>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(245, 158, 11, 0.16);\n  border-color: transparent;\n  color: #f59e0b;\n}\n\n.p-splitbutton.p-button-help.p-button-outlined>.p-button {\n  background-color: transparent;\n  color: #a855f7;\n  border: 1px solid;\n}\n\n.p-splitbutton.p-button-help.p-button-outlined>.p-button:enabled:hover,\n.p-splitbutton.p-button-help.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(168, 85, 247, 0.04);\n  color: #a855f7;\n}\n\n.p-splitbutton.p-button-help.p-button-outlined>.p-button:enabled:active,\n.p-splitbutton.p-button-help.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(168, 85, 247, 0.16);\n  color: #a855f7;\n}\n\n.p-splitbutton.p-button-help.p-button-text>.p-button {\n  background-color: transparent;\n  color: #a855f7;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-help.p-button-text>.p-button:enabled:hover,\n.p-splitbutton.p-button-help.p-button-text>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(168, 85, 247, 0.04);\n  border-color: transparent;\n  color: #a855f7;\n}\n\n.p-splitbutton.p-button-help.p-button-text>.p-button:enabled:active,\n.p-splitbutton.p-button-help.p-button-text>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(168, 85, 247, 0.16);\n  border-color: transparent;\n  color: #a855f7;\n}\n\n.p-splitbutton.p-button-danger.p-button-outlined>.p-button {\n  background-color: transparent;\n  color: #ef4444;\n  border: 1px solid;\n}\n\n.p-splitbutton.p-button-danger.p-button-outlined>.p-button:enabled:hover,\n.p-splitbutton.p-button-danger.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(239, 68, 68, 0.04);\n  color: #ef4444;\n}\n\n.p-splitbutton.p-button-danger.p-button-outlined>.p-button:enabled:active,\n.p-splitbutton.p-button-danger.p-button-outlined>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(239, 68, 68, 0.16);\n  color: #ef4444;\n}\n\n.p-splitbutton.p-button-danger.p-button-text>.p-button {\n  background-color: transparent;\n  color: #ef4444;\n  border-color: transparent;\n}\n\n.p-splitbutton.p-button-danger.p-button-text>.p-button:enabled:hover,\n.p-splitbutton.p-button-danger.p-button-text>.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: rgba(239, 68, 68, 0.04);\n  border-color: transparent;\n  color: #ef4444;\n}\n\n.p-splitbutton.p-button-danger.p-button-text>.p-button:enabled:active,\n.p-splitbutton.p-button-danger.p-button-text>.p-button:not(button):not(a):not(.p-disabled):active {\n  background: rgba(239, 68, 68, 0.16);\n  border-color: transparent;\n  color: #ef4444;\n}\n\n.p-speeddial-button.p-button.p-button-icon-only {\n  width: 4rem;\n  height: 4rem;\n}\n\n.p-speeddial-button.p-button.p-button-icon-only .p-button-icon {\n  font-size: 1.3rem;\n}\n\n.p-speeddial-button.p-button.p-button-icon-only .p-button-icon.p-icon {\n  width: 1.3rem;\n  height: 1.3rem;\n}\n\n.p-speeddial-action {\n  width: 3rem;\n  height: 3rem;\n  background: #495057;\n  color: #fff;\n}\n\n.p-speeddial-action:hover {\n  background: #022354;\n  color: #fff;\n}\n\n.p-speeddial-direction-up .p-speeddial-item {\n  margin: 0.25rem;\n}\n\n.p-speeddial-direction-up .p-speeddial-item:first-child {\n  margin-bottom: 0.5rem;\n}\n\n.p-speeddial-direction-down .p-speeddial-item {\n  margin: 0.25rem;\n}\n\n.p-speeddial-direction-down .p-speeddial-item:first-child {\n  margin-top: 0.5rem;\n}\n\n.p-speeddial-direction-left .p-speeddial-item {\n  margin: 0 0.25rem;\n}\n\n.p-speeddial-direction-left .p-speeddial-item:first-child {\n  margin-right: 0.5rem;\n}\n\n.p-speeddial-direction-right .p-speeddial-item {\n  margin: 0 0.25rem;\n}\n\n.p-speeddial-direction-right .p-speeddial-item:first-child {\n  margin-left: 0.5rem;\n}\n\n.p-speeddial-circle .p-speeddial-item,\n.p-speeddial-semi-circle .p-speeddial-item,\n.p-speeddial-quarter-circle .p-speeddial-item {\n  margin: 0;\n}\n\n.p-speeddial-circle .p-speeddial-item:first-child,\n.p-speeddial-circle .p-speeddial-item:last-child,\n.p-speeddial-semi-circle .p-speeddial-item:first-child,\n.p-speeddial-semi-circle .p-speeddial-item:last-child,\n.p-speeddial-quarter-circle .p-speeddial-item:first-child,\n.p-speeddial-quarter-circle .p-speeddial-item:last-child {\n  margin: 0;\n}\n\n.p-speeddial-mask {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.p-carousel .p-carousel-content .p-carousel-prev,\n.p-carousel .p-carousel-content .p-carousel-next {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  margin: 0.5rem;\n}\n\n.p-carousel .p-carousel-content .p-carousel-prev:enabled:hover,\n.p-carousel .p-carousel-content .p-carousel-next:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-carousel .p-carousel-content .p-carousel-prev:focus,\n.p-carousel .p-carousel-content .p-carousel-next:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-carousel .p-carousel-indicators {\n  padding: 1rem;\n}\n\n.p-carousel .p-carousel-indicators .p-carousel-indicator {\n  margin-right: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.p-carousel .p-carousel-indicators .p-carousel-indicator button {\n  background-color: #ced4da;\n  width: 2rem;\n  height: 0.5rem;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-carousel .p-carousel-indicators .p-carousel-indicator button:hover {\n  background: #adb5bd;\n}\n\n.p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-datatable .p-paginator-top {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-datatable .p-paginator-bottom {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-datatable .p-datatable-header {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 1px 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n}\n\n.p-datatable .p-datatable-footer {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n}\n\n.p-datatable .p-datatable-thead>tr>th {\n  text-align: left;\n  padding: 1rem 1rem;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  font-weight: 700;\n  color: #343a40;\n  background: #f8f9fa;\n  transition: box-shadow 0.2s;\n}\n\n.p-datatable .p-datatable-tfoot>tr>td {\n  text-align: left;\n  padding: 1rem 1rem;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  font-weight: 700;\n  color: #343a40;\n  background: #f8f9fa;\n}\n\n.p-datatable .p-sortable-column .p-sortable-column-icon {\n  color: #343a40;\n  margin-left: 0.5rem;\n}\n\n.p-datatable .p-sortable-column .p-sortable-column-badge {\n  border-radius: 50%;\n  height: 1.143rem;\n  min-width: 1.143rem;\n  line-height: 1.143rem;\n  color: #4338ca;\n  background: #eef2ff;\n  margin-left: 0.5rem;\n}\n\n.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover {\n  background: #e9ecef;\n  color: #343a40;\n}\n\n.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover .p-sortable-column-icon {\n  color: #343a40;\n}\n\n.p-datatable .p-sortable-column.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {\n  color: #4338ca;\n}\n\n.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon {\n  color: #4338ca;\n}\n\n.p-datatable .p-sortable-column:focus {\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n  outline: 0 none;\n}\n\n.p-datatable .p-datatable-tbody>tr {\n  background: #ffffff;\n  color: #495057;\n  transition: box-shadow 0.2s;\n}\n\n.p-datatable .p-datatable-tbody>tr>td {\n  text-align: left;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  padding: 1rem 1rem;\n}\n\n.p-datatable .p-datatable-tbody>tr>td .p-row-toggler,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-init,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-save,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-datatable .p-datatable-tbody>tr>td .p-row-toggler:enabled:hover,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-init:enabled:hover,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-save:enabled:hover,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-datatable .p-datatable-tbody>tr>td .p-row-toggler:focus,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-init:focus,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-save:focus,\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-cancel:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-datatable .p-datatable-tbody>tr>td .p-row-editor-save {\n  margin-right: 0.5rem;\n}\n\n.p-datatable .p-datatable-tbody>tr>td>.p-column-title {\n  font-weight: 700;\n}\n\n.p-datatable .p-datatable-tbody>tr>td.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-datatable .p-datatable-tbody>tr.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-top>td {\n  box-shadow: inset 0 2px 0 0 #eef2ff;\n}\n\n.p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-bottom>td {\n  box-shadow: inset 0 -2px 0 0 #eef2ff;\n}\n\n.p-datatable.p-datatable-selectable .p-datatable-tbody>tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-datatable.p-datatable-selectable .p-datatable-tbody>tr.p-selectable-row:focus {\n  outline: 0.15rem solid #c7d2fe;\n  outline-offset: -0.15rem;\n}\n\n.p-datatable.p-datatable-selectable-cell .p-datatable-tbody>tr.p-selectable-row>td.p-selectable-cell:not(.p-highlight):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-datatable.p-datatable-selectable-cell .p-datatable-tbody>tr.p-selectable-row>td.p-selectable-cell:focus {\n  outline: 0.15rem solid #c7d2fe;\n  outline-offset: -0.15rem;\n}\n\n.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody>tr:not(.p-highlight):not(.p-datatable-emptymessage):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-datatable .p-column-resizer-helper {\n  background: #6366f1;\n}\n\n.p-datatable .p-datatable-scrollable-header,\n.p-datatable .p-datatable-scrollable-footer {\n  background: #f8f9fa;\n}\n\n.p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-datatable-table>.p-datatable-thead,\n.p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-datatable-table>.p-datatable-tfoot,\n.p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-virtualscroller>.p-datatable-table>.p-datatable-thead,\n.p-datatable.p-datatable-scrollable>.p-datatable-wrapper>.p-virtualscroller>.p-datatable-table>.p-datatable-tfoot {\n  background-color: #f8f9fa;\n}\n\n.p-datatable .p-datatable-loading-icon {\n  font-size: 2rem;\n}\n\n.p-datatable .p-datatable-loading-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-header {\n  border-width: 1px 1px 0 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-footer {\n  border-width: 0 1px 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-paginator-top {\n  border-width: 0 1px 0 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-paginator-bottom {\n  border-width: 0 1px 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-thead>tr>th {\n  border-width: 1px 0 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-thead>tr>th:last-child {\n  border-width: 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td {\n  border-width: 1px 0 0 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td:last-child {\n  border-width: 1px 1px 0 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-tbody>tr:last-child>td {\n  border-width: 1px 0 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-tbody>tr:last-child>td:last-child {\n  border-width: 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-tfoot>tr>td {\n  border-width: 1px 0 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-tfoot>tr>td:last-child {\n  border-width: 1px 1px 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-thead+.p-datatable-tfoot>tr>td {\n  border-width: 0 0 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines .p-datatable-thead+.p-datatable-tfoot>tr>td:last-child {\n  border-width: 0 1px 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody>tr>td {\n  border-width: 0 0 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody>tr>td:last-child {\n  border-width: 0 1px 1px 1px;\n}\n\n.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody>tr:last-child>td {\n  border-width: 0 0 0 1px;\n}\n\n.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody>tr:last-child>td:last-child {\n  border-width: 0 1px 0 1px;\n}\n\n.p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd {\n  background: #fcfcfc;\n}\n\n.p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight .p-row-toggler {\n  color: #4338ca;\n}\n\n.p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd.p-highlight .p-row-toggler:hover {\n  color: #4338ca;\n}\n\n.p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd+.p-row-expanded {\n  background: #fcfcfc;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-header {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-thead>tr>th {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-tbody>tr>td {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-tfoot>tr>td {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-footer {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-datatable.p-datatable-lg .p-datatable-header {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-datatable.p-datatable-lg .p-datatable-thead>tr>th {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-datatable.p-datatable-lg .p-datatable-tbody>tr>td {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-datatable.p-datatable-lg .p-datatable-tfoot>tr>td {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-datatable.p-datatable-lg .p-datatable-footer {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-datatable-drag-selection-helper {\n  background: rgba(99, 102, 241, 0.16);\n}\n\n.p-dataview .p-paginator-top {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-dataview .p-paginator-bottom {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-dataview .p-dataview-header {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 1px 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n}\n\n.p-dataview .p-dataview-content {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  padding: 0;\n}\n\n.p-dataview.p-dataview-list .p-dataview-content>.p-grid>div {\n  border: solid #dee2e6;\n  border-width: 0 0 1px 0;\n}\n\n.p-dataview .p-dataview-footer {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-dataview .p-dataview-loading-icon {\n  font-size: 2rem;\n}\n\n.p-dataview .p-dataview-loading-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-datascroller .p-paginator-top {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-datascroller .p-paginator-bottom {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-datascroller .p-datascroller-header {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 1px 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n}\n\n.p-datascroller .p-datascroller-content {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  padding: 0;\n}\n\n.p-datascroller.p-datascroller-inline .p-datascroller-list>li {\n  border: solid #dee2e6;\n  border-width: 0 0 1px 0;\n}\n\n.p-datascroller .p-datascroller-footer {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-column-filter-row .p-column-filter-menu-button,\n.p-column-filter-row .p-column-filter-clear-button {\n  margin-left: 0.5rem;\n}\n\n.p-column-filter-menu-button {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-column-filter-menu-button:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-column-filter-menu-button.p-column-filter-menu-button-open,\n.p-column-filter-menu-button.p-column-filter-menu-button-open:hover {\n  background: #e9ecef;\n  color: #343a40;\n}\n\n.p-column-filter-menu-button.p-column-filter-menu-button-active,\n.p-column-filter-menu-button.p-column-filter-menu-button-active:hover {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-column-filter-menu-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-column-filter-clear-button {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-column-filter-clear-button:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-column-filter-clear-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-column-filter-overlay {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  min-width: 12.5rem;\n}\n\n.p-column-filter-overlay .p-column-filter-row-items {\n  padding: 0.75rem 0;\n}\n\n.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n}\n\n.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:not(.p-highlight):not(.p-disabled):hover {\n  color: #495057;\n  background: #e9ecef;\n}\n\n.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-row-item:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-column-filter-overlay .p-column-filter-row-items .p-column-filter-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-column-filter-overlay-menu .p-column-filter-operator {\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #dee2e6;\n  color: #343a40;\n  background: #f8f9fa;\n  margin: 0;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-column-filter-overlay-menu .p-column-filter-constraint {\n  padding: 1.25rem;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-matchmode-dropdown {\n  margin-bottom: 0.5rem;\n}\n\n.p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-remove-button {\n  margin-top: 0.5rem;\n}\n\n.p-column-filter-overlay-menu .p-column-filter-constraint:last-child {\n  border-bottom: 0 none;\n}\n\n.p-column-filter-overlay-menu .p-column-filter-add-rule {\n  padding: 0.75rem 1.25rem;\n}\n\n.p-column-filter-overlay-menu .p-column-filter-buttonbar {\n  padding: 1.25rem;\n}\n\n.fc {\n  /* FullCalendar 4 */\n  /* FullCalendar 5 */\n}\n\n.fc.fc-unthemed .fc-view-container th {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  color: #343a40;\n}\n\n.fc.fc-unthemed .fc-view-container td.fc-widget-content {\n  border: 1px solid #dee2e6;\n  color: #495057;\n}\n\n.fc.fc-unthemed .fc-view-container td.fc-head-container {\n  border: 1px solid #dee2e6;\n}\n\n.fc.fc-unthemed .fc-view-container .fc-view {\n  background: #ffffff;\n}\n\n.fc.fc-unthemed .fc-view-container .fc-row {\n  border-right: 1px solid #dee2e6;\n}\n\n.fc.fc-unthemed .fc-view-container .fc-event {\n  background: #4f46e5;\n  border: 1px solid #4f46e5;\n  color: #ffffff;\n}\n\n.fc.fc-unthemed .fc-view-container .fc-divider {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button {\n  color: #ffffff;\n  background: #6366f1;\n  border: 1px solid #6366f1;\n  font-size: 1rem;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button:enabled:hover {\n  background: #4f46e5;\n  color: #ffffff;\n  border-color: #4f46e5;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button:enabled:active {\n  background: #4338ca;\n  color: #ffffff;\n  border-color: #4338ca;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button:enabled:active:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-left {\n  font-family: \"PrimeIcons\" !important;\n  text-indent: 0;\n  font-size: 1rem;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-left:before {\n  content: \"\\e900\";\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-right {\n  font-family: \"PrimeIcons\" !important;\n  text-indent: 0;\n  font-size: 1rem;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button .fc-icon-chevron-right:before {\n  content: \"\\e901\";\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  color: #495057;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button:hover,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button:hover,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button:hover {\n  background: #e9ecef;\n  border-color: #ced4da;\n  color: #495057;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active {\n  background: #6366f1;\n  border-color: #6366f1;\n  color: #ffffff;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active:hover,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active:hover,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active:hover {\n  background: #4f46e5;\n  border-color: #4f46e5;\n  color: #ffffff;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-dayGridMonth-button:focus,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridWeek-button:focus,\n.fc.fc-unthemed .fc-toolbar .fc-button.fc-timeGridDay-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  z-index: 1;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button-group .fc-button {\n  border-radius: 0;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button-group .fc-button:first-child {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.fc.fc-unthemed .fc-toolbar .fc-button-group .fc-button:last-child {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-scrollgrid {\n  border-color: #dee2e6;\n}\n\n.fc.fc-theme-standard .fc-view-harness th {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n  color: #343a40;\n}\n\n.fc.fc-theme-standard .fc-view-harness td {\n  color: #495057;\n  border-color: #dee2e6;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-view {\n  background: #ffffff;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-popover {\n  background: none;\n  border: 0 none;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header {\n  border: 1px solid #dee2e6;\n  padding: 1.25rem;\n  background: #f8f9fa;\n  color: #343a40;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close {\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  font-family: \"PrimeIcons\" !important;\n  font-size: 1rem;\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close:before {\n  content: \"\\e90b\";\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header .fc-popover-close:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-body {\n  padding: 1.25rem;\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  border-top: 0 none;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-block-event {\n  color: #ffffff;\n  background: #4f46e5;\n  border-color: #4f46e5;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-block-event .fc-event-main {\n  color: #ffffff;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-dot-event .fc-daygrid-event-dot {\n  background: #4f46e5;\n  border-color: #4f46e5;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-event.fc-daygrid-dot-event:hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.fc.fc-theme-standard .fc-view-harness .fc-cell-shaded {\n  background: #f8f9fa;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button {\n  color: #ffffff;\n  background: #6366f1;\n  border: 1px solid #6366f1;\n  font-size: 1rem;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button:enabled:hover {\n  background: #4f46e5;\n  color: #ffffff;\n  border-color: #4f46e5;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button:enabled:active {\n  background: #4338ca;\n  color: #ffffff;\n  border-color: #4338ca;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button:enabled:active:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button:disabled {\n  opacity: 0.6;\n  color: #ffffff;\n  background: #6366f1;\n  border: 1px solid #6366f1;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-left {\n  font-family: \"PrimeIcons\" !important;\n  text-indent: 0;\n  font-size: 1rem;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-left:before {\n  content: \"\\e900\";\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-right {\n  font-family: \"PrimeIcons\" !important;\n  text-indent: 0;\n  font-size: 1rem;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button .fc-icon-chevron-right:before {\n  content: \"\\e901\";\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button {\n  background: #ffffff;\n  border: 1px solid #ced4da;\n  color: #495057;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button:hover,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button:hover,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button:hover {\n  background: #e9ecef;\n  border-color: #ced4da;\n  color: #495057;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active {\n  background: #6366f1;\n  border-color: #6366f1;\n  color: #ffffff;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button.fc-button-active:hover,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button.fc-button-active:hover,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button.fc-button-active:hover {\n  background: #4f46e5;\n  border-color: #4f46e5;\n  color: #ffffff;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-dayGridMonth-button:not(:disabled):focus,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridWeek-button:not(:disabled):focus,\n.fc.fc-theme-standard .fc-toolbar .fc-button.fc-timeGridDay-button:not(:disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  z-index: 1;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button-group .fc-button {\n  border-radius: 0;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button-group .fc-button:first-child {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.fc.fc-theme-standard .fc-toolbar .fc-button-group .fc-button:last-child {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.fc.fc-theme-standard .fc-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-orderlist .p-orderlist-controls {\n  padding: 1.25rem;\n}\n\n.p-orderlist .p-orderlist-controls .p-button {\n  margin-bottom: 0.5rem;\n}\n\n.p-orderlist .p-orderlist-header {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  padding: 1.25rem;\n  font-weight: 700;\n  border-bottom: 0 none;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-orderlist .p-orderlist-filter-container {\n  padding: 1.25rem;\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-bottom: 0 none;\n}\n\n.p-orderlist .p-orderlist-filter-container .p-orderlist-filter-input {\n  padding-right: 1.75rem;\n}\n\n.p-orderlist .p-orderlist-filter-container .p-orderlist-filter-icon {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-orderlist .p-orderlist-list {\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  padding: 0.75rem 0;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-orderlist .p-orderlist-list .p-orderlist-item {\n  padding: 0.75rem 1.25rem;\n  margin: 0;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.p-orderlist .p-orderlist-list .p-orderlist-item:not(.p-highlight):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-orderlist .p-orderlist-list .p-orderlist-item:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-orderlist .p-orderlist-list .p-orderlist-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even) {\n  background: #fcfcfc;\n}\n\n.p-orderlist.p-orderlist-striped .p-orderlist-list .p-orderlist-item:nth-child(even):hover {\n  background: #e9ecef;\n}\n\n.p-organizationchart .p-organizationchart-node-content.p-organizationchart-selectable-node:not(.p-highlight):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-organizationchart .p-organizationchart-node-content.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-organizationchart .p-organizationchart-node-content.p-highlight .p-node-toggler i {\n  color: #6f91ff;\n}\n\n.p-organizationchart .p-organizationchart-line-down {\n  background: #dee2e6;\n}\n\n.p-organizationchart .p-organizationchart-line-left {\n  border-right: 1px solid #dee2e6;\n  border-color: #dee2e6;\n}\n\n.p-organizationchart .p-organizationchart-line-top {\n  border-top: 1px solid #dee2e6;\n  border-color: #dee2e6;\n}\n\n.p-organizationchart .p-organizationchart-node-content {\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  padding: 1.25rem;\n}\n\n.p-organizationchart .p-organizationchart-node-content .p-node-toggler {\n  background: inherit;\n  color: inherit;\n  border-radius: 50%;\n}\n\n.p-organizationchart .p-organizationchart-node-content .p-node-toggler:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-paginator {\n  background: #ffffff;\n  color: #6c757d;\n  border: solid #e9ecef;\n  border-width: 0;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n}\n\n.p-paginator .p-paginator-first,\n.p-paginator .p-paginator-prev,\n.p-paginator .p-paginator-next,\n.p-paginator .p-paginator-last {\n  background-color: transparent;\n  border: 0 none;\n  color: #6c757d;\n  min-width: 3rem;\n  height: 3rem;\n  margin: 0.143rem;\n  transition: box-shadow 0.2s;\n  border-radius: 50%;\n}\n\n.p-paginator .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,\n.p-paginator .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,\n.p-paginator .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,\n.p-paginator .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {\n  background: #e9ecef;\n  border-color: transparent;\n  color: #343a40;\n}\n\n.p-paginator .p-paginator-first {\n  border-top-left-radius: 50%;\n  border-bottom-left-radius: 50%;\n}\n\n.p-paginator .p-paginator-last {\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n}\n\n.p-paginator .p-dropdown {\n  margin-left: 0.5rem;\n  height: 3rem;\n}\n\n.p-paginator .p-dropdown .p-dropdown-label {\n  padding-right: 0;\n}\n\n.p-paginator .p-paginator-page-input {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n.p-paginator .p-paginator-page-input .p-inputtext {\n  max-width: 3rem;\n}\n\n.p-paginator .p-paginator-current {\n  background-color: transparent;\n  border: 0 none;\n  color: #6c757d;\n  min-width: 3rem;\n  height: 3rem;\n  margin: 0.143rem;\n  padding: 0 0.5rem;\n}\n\n.p-paginator .p-paginator-pages .p-paginator-page {\n  background-color: transparent;\n  border: 0 none;\n  color: #6c757d;\n  min-width: 3rem;\n  height: 3rem;\n  margin: 0.143rem;\n  transition: box-shadow 0.2s;\n  border-radius: 50%;\n}\n\n.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {\n  background: #eef2ff;\n  border-color: #eef2ff;\n  color: #4338ca;\n}\n\n.p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {\n  background: #e9ecef;\n  border-color: transparent;\n  color: #343a40;\n}\n\n.p-picklist .p-picklist-buttons {\n  padding: 1.25rem;\n}\n\n.p-picklist .p-picklist-buttons .p-button {\n  margin-bottom: 0.5rem;\n}\n\n.p-picklist .p-picklist-header {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  padding: 1.25rem;\n  font-weight: 700;\n  border-bottom: 0 none;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-picklist .p-picklist-filter-container {\n  padding: 1.25rem;\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-bottom: 0 none;\n}\n\n.p-picklist .p-picklist-filter-container .p-picklist-filter-input {\n  padding-right: 1.75rem;\n}\n\n.p-picklist .p-picklist-filter-container .p-picklist-filter-icon {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-picklist .p-picklist-list {\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  padding: 0.75rem 0;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-picklist .p-picklist-list .p-picklist-item {\n  padding: 0.75rem 1.25rem;\n  margin: 0;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.p-picklist .p-picklist-list .p-picklist-item:not(.p-highlight):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-picklist .p-picklist-list .p-picklist-item:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-picklist .p-picklist-list .p-picklist-item.p-highlight {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.p-tree {\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  padding: 1.25rem;\n  border-radius: 6px;\n}\n\n.p-tree .p-tree-container .p-treenode {\n  padding: 0.143rem;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content {\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n  padding: 0.5rem;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {\n  margin-right: 0.5rem;\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon {\n  margin-right: 0.5rem;\n  color: #6c757d;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox {\n  margin-right: 0.5rem;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox .p-indeterminate .p-checkbox-icon {\n  color: #495057;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler,\n.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon {\n  color: #4338ca;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler:hover,\n.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-treenode-icon:hover {\n  color: #4338ca;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-dragover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-tree .p-tree-filter-container {\n  margin-bottom: 0.5rem;\n}\n\n.p-tree .p-tree-filter-container .p-tree-filter {\n  width: 100%;\n  padding-right: 1.75rem;\n}\n\n.p-tree .p-tree-filter-container .p-tree-filter-icon {\n  right: 0.75rem;\n  color: #6c757d;\n}\n\n.p-tree .p-treenode-children {\n  padding: 0 0 0 1rem;\n}\n\n.p-tree .p-tree-loading-icon {\n  font-size: 2rem;\n}\n\n.p-tree .p-tree-loading-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-tree .p-treenode-droppoint {\n  height: 0.5rem;\n}\n\n.p-tree .p-treenode-droppoint.p-treenode-droppoint-active {\n  background: #8ba7ff;\n}\n\n.p-treetable .p-paginator-top {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-treetable .p-paginator-bottom {\n  border-width: 0 0 1px 0;\n  border-radius: 0;\n}\n\n.p-treetable .p-treetable-header {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 1px 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n}\n\n.p-treetable .p-treetable-footer {\n  background: #f8f9fa;\n  color: #343a40;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  padding: 1rem 1rem;\n  font-weight: 700;\n}\n\n.p-treetable .p-treetable-thead>tr>th {\n  text-align: left;\n  padding: 1rem 1rem;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  font-weight: 700;\n  color: #343a40;\n  background: #f8f9fa;\n  transition: box-shadow 0.2s;\n}\n\n.p-treetable .p-treetable-tfoot>tr>td {\n  text-align: left;\n  padding: 1rem 1rem;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 1px 0;\n  font-weight: 700;\n  color: #343a40;\n  background: #f8f9fa;\n}\n\n.p-treetable .p-sortable-column {\n  outline-color: #c7d2fe;\n}\n\n.p-treetable .p-sortable-column .p-sortable-column-icon {\n  color: #343a40;\n  margin-left: 0.5rem;\n}\n\n.p-treetable .p-sortable-column .p-sortable-column-badge {\n  border-radius: 50%;\n  height: 1.143rem;\n  min-width: 1.143rem;\n  line-height: 1.143rem;\n  color: #4338ca;\n  background: #eef2ff;\n  margin-left: 0.5rem;\n}\n\n.p-treetable .p-sortable-column:not(.p-highlight):hover {\n  background: #e9ecef;\n  color: #343a40;\n}\n\n.p-treetable .p-sortable-column:not(.p-highlight):hover .p-sortable-column-icon {\n  color: #343a40;\n}\n\n.p-treetable .p-sortable-column.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-treetable .p-sortable-column.p-highlight .p-sortable-column-icon {\n  color: #4338ca;\n}\n\n.p-treetable .p-treetable-tbody>tr {\n  background: #ffffff;\n  color: #495057;\n  transition: box-shadow 0.2s;\n}\n\n.p-treetable .p-treetable-tbody>tr>td {\n  text-align: left;\n  border: 1px solid #acacac;\n  border-width: 0 0 1px 0;\n  padding: 1rem 1rem;\n}\n\n.p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  margin-right: 0.5rem;\n}\n\n.p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler+.p-checkbox {\n  margin-right: 0.5rem;\n}\n\n.p-treetable .p-treetable-tbody>tr>td .p-treetable-toggler+.p-checkbox .p-indeterminate .p-checkbox-icon {\n  color: #495057;\n}\n\n.p-treetable .p-treetable-tbody>tr:focus {\n  outline: 0.15rem solid #c7d2fe;\n  outline-offset: -0.15rem;\n}\n\n.p-treetable .p-treetable-tbody>tr.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-treetable .p-treetable-tbody>tr.p-highlight .p-treetable-toggler {\n  color: #4338ca;\n}\n\n.p-treetable .p-treetable-tbody>tr.p-highlight .p-treetable-toggler:hover {\n  color: #4338ca;\n}\n\n.p-treetable.p-treetable-selectable .p-treetable-tbody>tr:not(.p-highlight):hover,\n.p-treetable.p-treetable-hoverable-rows .p-treetable-tbody>tr:not(.p-highlight):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-treetable.p-treetable-selectable .p-treetable-tbody>tr:not(.p-highlight):hover .p-treetable-toggler,\n.p-treetable.p-treetable-hoverable-rows .p-treetable-tbody>tr:not(.p-highlight):hover .p-treetable-toggler {\n  color: #495057;\n}\n\n.p-treetable .p-column-resizer-helper {\n  background: #6366f1;\n}\n\n.p-treetable .p-treetable-scrollable-header,\n.p-treetable .p-treetable-scrollable-footer {\n  background: #f8f9fa;\n}\n\n.p-treetable .p-treetable-loading-icon {\n  font-size: 2rem;\n}\n\n.p-treetable .p-treetable-loading-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-treetable.p-treetable-gridlines .p-treetable-header {\n  border-width: 1px 1px 0 1px;\n}\n\n.p-treetable.p-treetable-gridlines .p-treetable-footer {\n  border-width: 0 1px 1px 1px;\n}\n\n.p-treetable.p-treetable-gridlines .p-treetable-top {\n  border-width: 0 1px 0 1px;\n}\n\n.p-treetable.p-treetable-gridlines .p-treetable-bottom {\n  border-width: 0 1px 1px 1px;\n}\n\n.p-treetable.p-treetable-gridlines .p-treetable-thead>tr>th {\n  border-width: 1px;\n}\n\n.p-treetable.p-treetable-gridlines .p-treetable-tbody>tr>td {\n  border-width: 1px;\n}\n\n.p-treetable.p-treetable-gridlines .p-treetable-tfoot>tr>td {\n  border-width: 1px;\n}\n\n.p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd {\n  background: #fcfcfc;\n}\n\n.p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight .p-row-toggler {\n  color: #4338ca;\n}\n\n.p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd.p-highlight .p-row-toggler:hover {\n  color: #4338ca;\n}\n\n.p-treetable.p-treetable-striped .p-treetable-tbody>tr.p-row-odd+.p-row-expanded {\n  background: #fcfcfc;\n}\n\n.p-treetable.p-treetable-sm .p-treetable-header {\n  padding: 0.875rem 0.875rem;\n}\n\n.p-treetable.p-treetable-sm .p-treetable-thead>tr>th {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-treetable.p-treetable-sm .p-treetable-tbody>tr>td {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-treetable.p-treetable-sm .p-treetable-tfoot>tr>td {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-treetable.p-treetable-sm .p-treetable-footer {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-treetable.p-treetable-lg .p-treetable-header {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-treetable.p-treetable-lg .p-treetable-thead>tr>th {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-treetable.p-treetable-lg .p-treetable-tbody>tr>td {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-treetable.p-treetable-lg .p-treetable-tfoot>tr>td {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-treetable.p-treetable-lg .p-treetable-footer {\n  padding: 1.25rem 1.25rem;\n}\n\n.p-timeline .p-timeline-event-marker {\n  border: 2px solid #6366f1;\n  border-radius: 50%;\n  width: 1rem;\n  height: 1rem;\n  background-color: #ffffff;\n}\n\n.p-timeline .p-timeline-event-connector {\n  background-color: #dee2e6;\n}\n\n.p-timeline.p-timeline-vertical .p-timeline-event-opposite,\n.p-timeline.p-timeline-vertical .p-timeline-event-content {\n  padding: 0 1rem;\n}\n\n.p-timeline.p-timeline-vertical .p-timeline-event-connector {\n  width: 2px;\n}\n\n.p-timeline.p-timeline-horizontal .p-timeline-event-opposite,\n.p-timeline.p-timeline-horizontal .p-timeline-event-content {\n  padding: 1rem 0;\n}\n\n.p-timeline.p-timeline-horizontal .p-timeline-event-connector {\n  height: 2px;\n}\n\n.p-accordion .p-accordion-header .p-accordion-header-link {\n  padding: 1.25rem;\n  border: 1px solid #dee2e6;\n  color: #6c757d;\n  background: #f8f9fa;\n  font-weight: 700;\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n}\n\n.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {\n  margin-right: 0.5rem;\n}\n\n.p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {\n  background: #e9ecef;\n  border-color: #dee2e6;\n  color: #343a40;\n}\n\n.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n  color: #343a40;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.p-accordion .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {\n  border-color: #dee2e6;\n  background: #e9ecef;\n  color: #343a40;\n}\n\n.p-accordion .p-accordion-content {\n  padding: 1.25rem;\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  border-top: 0;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-accordion .p-accordion-tab {\n  margin-bottom: 4px;\n}\n\n.p-card {\n  background: #ffffff;\n  color: #495057;\n  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),\n    0 1px 3px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 6px;\n}\n\n.p-card .p-card-body {\n  padding: 1.25rem;\n}\n\n.p-card .p-card-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.p-card .p-card-subtitle {\n  font-weight: 400;\n  margin-bottom: 0.5rem;\n  color: #6c757d;\n}\n\n.p-card .p-card-content {\n  padding: 1.25rem 0;\n}\n\n.p-card .p-card-footer {\n  padding: 1.25rem 0 0 0;\n}\n\n.p-fieldset {\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  border-radius: 6px;\n}\n\n.p-fieldset .p-fieldset-legend {\n  padding: 1.25rem;\n  border: 1px solid #dee2e6;\n  color: #343a40;\n  background: #f8f9fa;\n  font-weight: 700;\n  border-radius: 6px;\n}\n\n.p-fieldset.p-fieldset-toggleable .p-fieldset-legend {\n  padding: 0;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-fieldset.p-fieldset-toggleable .p-fieldset-legend a {\n  padding: 1.25rem;\n  color: #343a40;\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n}\n\n.p-fieldset.p-fieldset-toggleable .p-fieldset-legend a .p-fieldset-toggler {\n  margin-right: 0.5rem;\n}\n\n.p-fieldset.p-fieldset-toggleable .p-fieldset-legend a:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-fieldset.p-fieldset-toggleable .p-fieldset-legend:hover {\n  background: #e9ecef;\n  border-color: #dee2e6;\n  color: #343a40;\n}\n\n.p-fieldset .p-fieldset-content {\n  padding: 1.25rem;\n}\n\n.p-divider .p-divider-content {\n  background-color: #ffffff;\n}\n\n.p-divider.p-divider-horizontal {\n  margin: 1.25rem 0;\n  padding: 0 1.25rem;\n}\n\n.p-divider.p-divider-horizontal:before {\n  border-top: 1px #dee2e6;\n}\n\n.p-divider.p-divider-horizontal .p-divider-content {\n  padding: 0 0.5rem;\n}\n\n.p-divider.p-divider-vertical {\n  margin: 0 1.25rem;\n  padding: 1.25rem 0;\n}\n\n.p-divider.p-divider-vertical:before {\n  border-left: 1px #dee2e6;\n}\n\n.p-divider.p-divider-vertical .p-divider-content {\n  padding: 0.5rem 0;\n}\n\n.p-panel .p-panel-header {\n  border: 1px solid #dee2e6;\n  padding: 1.25rem;\n  background: #f8f9fa;\n  color: #343a40;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-panel .p-panel-header .p-panel-title {\n  font-weight: 700;\n}\n\n.p-panel .p-panel-header .p-panel-header-icon {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-panel .p-panel-header .p-panel-header-icon:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-panel .p-panel-header .p-panel-header-icon:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-panel.p-panel-toggleable .p-panel-header {\n  padding: 0.75rem 1.25rem;\n}\n\n.p-panel .p-panel-content {\n  padding: 1.25rem;\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n  border-top: 0 none;\n}\n\n.p-panel .p-panel-footer {\n  padding: 0.75rem 1.25rem;\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  border-top: 0 none;\n}\n\n.p-splitter {\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  border-radius: 6px;\n  color: #495057;\n}\n\n.p-splitter .p-splitter-gutter {\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  background: #f8f9fa;\n}\n\n.p-splitter .p-splitter-gutter .p-splitter-gutter-handle {\n  background: #dee2e6;\n}\n\n.p-splitter .p-splitter-gutter-resizing {\n  background: #dee2e6;\n}\n\n.p-scrollpanel .p-scrollpanel-bar {\n  background: #f8f9fa;\n  border: 0 none;\n}\n\n.p-tabview .p-tabview-nav {\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 2px 0;\n}\n\n.p-tabview .p-tabview-nav li {\n  margin-right: 0;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: solid #dee2e6;\n  border-width: 0 0 2px 0;\n  border-color: transparent transparent #dee2e6 transparent;\n  background: #ffffff;\n  color: #6c757d;\n  padding: 1.25rem;\n  font-weight: 700;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n  transition: box-shadow 0.2s;\n  margin: 0 0 -2px 0;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {\n  background: #ffffff;\n  border-color: #adb5bd;\n  color: #6c757d;\n}\n\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  background: #ffffff;\n  border-color: #6366f1;\n  color: #6366f1;\n}\n\n.p-tabview .p-tabview-close {\n  margin-left: 0.5rem;\n}\n\n.p-tabview .p-tabview-nav-btn.p-link {\n  background: #ffffff;\n  color: #6366f1;\n  width: 3rem;\n  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 0;\n}\n\n.p-tabview .p-tabview-nav-btn.p-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-tabview .p-tabview-panels {\n  background: #ffffff;\n  padding: 1.25rem;\n  border: 0 none;\n  color: #495057;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-toolbar {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  padding: 1.25rem;\n  border-radius: 6px;\n  gap: 0.5rem;\n}\n\n.p-toolbar .p-toolbar-separator {\n  margin: 0 0.5rem;\n}\n\n.p-confirm-popup {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.p-confirm-popup .p-confirm-popup-content {\n  padding: 1.25rem;\n}\n\n.p-confirm-popup .p-confirm-popup-footer {\n  text-align: right;\n  padding: 0 1.25rem 1.25rem 1.25rem;\n}\n\n.p-confirm-popup .p-confirm-popup-footer button {\n  margin: 0 0.5rem 0 0;\n  width: auto;\n}\n\n.p-confirm-popup .p-confirm-popup-footer button:last-child {\n  margin: 0;\n}\n\n.p-confirm-popup:after {\n  border: solid transparent;\n  border-color: rgba(255, 255, 255, 0);\n  border-bottom-color: #ffffff;\n}\n\n.p-confirm-popup:before {\n  border: solid transparent;\n  border-color: rgba(255, 255, 255, 0);\n  border-bottom-color: #ffffff;\n}\n\n.p-confirm-popup.p-confirm-popup-flipped:after {\n  border-top-color: #ffffff;\n}\n\n.p-confirm-popup.p-confirm-popup-flipped:before {\n  border-top-color: #ffffff;\n}\n\n.p-confirm-popup .p-confirm-popup-icon {\n  font-size: 1.5rem;\n}\n\n.p-confirm-popup .p-confirm-popup-icon.p-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.p-confirm-popup .p-confirm-popup-message {\n  margin-left: 1rem;\n}\n\n.p-dialog {\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  border: 0 none;\n}\n\n.p-dialog .p-dialog-header {\n  border-bottom: 0 none;\n  background: #ffffff;\n  color: #343a40;\n  padding: 1.5rem;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-dialog .p-dialog-header .p-dialog-title {\n  font-weight: 700;\n  font-size: 1.25rem;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  margin-right: 0.5rem;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon:last-child {\n  margin-right: 0;\n}\n\n.p-dialog .p-dialog-content {\n  background: #ffffff;\n  color: #495057;\n  padding: 0 1.5rem 2rem 1.5rem;\n}\n\n.p-dialog .p-dialog-content:last-of-type {\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-dialog .p-dialog-footer {\n  border-top: 0 none;\n  background: #ffffff;\n  color: #495057;\n  padding: 0 1.5rem 1.5rem 1.5rem;\n  text-align: right;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-dialog .p-dialog-footer button {\n  margin: 0 0.5rem 0 0;\n  width: auto;\n}\n\n.p-dialog.p-dialog-maximized .p-dialog-header,\n.p-dialog.p-dialog-maximized .p-dialog-content:last-of-type {\n  border-radius: 0;\n}\n\n.p-dialog.p-confirm-dialog .p-confirm-dialog-icon {\n  font-size: 2rem;\n}\n\n.p-dialog.p-confirm-dialog .p-confirm-dialog-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-dialog.p-confirm-dialog .p-confirm-dialog-message {\n  margin-left: 1rem;\n}\n\n.p-overlaypanel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.p-overlaypanel .p-overlaypanel-content {\n  padding: 1.25rem;\n}\n\n.p-overlaypanel .p-overlaypanel-close {\n  background: #6366f1;\n  color: #ffffff;\n  width: 2rem;\n  height: 2rem;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  border-radius: 50%;\n  position: absolute;\n  top: -1rem;\n  right: -1rem;\n}\n\n.p-overlaypanel .p-overlaypanel-close:enabled:hover {\n  background: #4f46e5;\n  color: #ffffff;\n}\n\n.p-overlaypanel:after {\n  border: solid transparent;\n  border-color: rgba(255, 255, 255, 0);\n  border-bottom-color: #ffffff;\n  border-width: 8px;\n  margin-left: -8px;\n}\n\n.p-overlaypanel:before {\n  border: solid transparent;\n  border-color: rgba(255, 255, 255, 0);\n  border-bottom-color: #f2f2f2;\n  border-width: 10px;\n  margin-left: -10px;\n}\n\n.p-overlaypanel.p-overlaypanel-flipped:after {\n  border-top-color: #ffffff;\n}\n\n.p-overlaypanel.p-overlaypanel-flipped:before {\n  border-top-color: #ffffff;\n}\n\n.p-sidebar {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.p-sidebar .p-sidebar-header {\n  padding: 1.25rem;\n}\n\n.p-sidebar .p-sidebar-header .p-sidebar-close,\n.p-sidebar .p-sidebar-header .p-sidebar-icon {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-sidebar .p-sidebar-header .p-sidebar-close:enabled:hover,\n.p-sidebar .p-sidebar-header .p-sidebar-icon:enabled:hover {\n  color: #343a40;\n  border-color: transparent;\n  background: #e9ecef;\n}\n\n.p-sidebar .p-sidebar-header .p-sidebar-close:focus,\n.p-sidebar .p-sidebar-header .p-sidebar-icon:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-sidebar .p-sidebar-header+.p-sidebar-content {\n  padding-top: 0;\n}\n\n.p-sidebar .p-sidebar-content {\n  padding: 1.25rem;\n}\n\n.p-tooltip .p-tooltip-text {\n  background: #495057;\n  color: #ffffff;\n  padding: 0.75rem 0.75rem;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n}\n\n.p-tooltip.p-tooltip-right .p-tooltip-arrow {\n  border-right-color: #495057;\n}\n\n.p-tooltip.p-tooltip-left .p-tooltip-arrow {\n  border-left-color: #495057;\n}\n\n.p-tooltip.p-tooltip-top .p-tooltip-arrow {\n  border-top-color: #495057;\n}\n\n.p-tooltip.p-tooltip-bottom .p-tooltip-arrow {\n  border-bottom-color: #495057;\n}\n\n.p-fileupload .p-fileupload-buttonbar {\n  background: #f8f9fa;\n  padding: 1.25rem;\n  border: 1px solid #dee2e6;\n  color: #343a40;\n  border-bottom: 0 none;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n  gap: 0.5rem;\n}\n\n.p-fileupload .p-fileupload-buttonbar .p-button {\n  margin-right: 0.5rem;\n}\n\n.p-fileupload .p-fileupload-content {\n  background: #ffffff;\n  padding: 2rem 1rem;\n  border: 1px solid #dee2e6;\n  color: #495057;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-fileupload .p-progressbar {\n  height: 0.25rem;\n}\n\n.p-fileupload .p-fileupload-row>div {\n  padding: 1rem 1rem;\n}\n\n.p-fileupload.p-fileupload-advanced .p-message {\n  margin-top: 0;\n}\n\n.p-breadcrumb {\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 1rem;\n}\n\n.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link {\n  transition: box-shadow 0.2s;\n  border-radius: 6px;\n}\n\n.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-breadcrumb .p-breadcrumb-list li .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {\n  margin: 0 0.5rem 0 0.5rem;\n  color: #495057;\n}\n\n.p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {\n  color: #495057;\n}\n\n.p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-contextmenu {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  width: 12.5rem;\n}\n\n.p-contextmenu .p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-contextmenu .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-contextmenu .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-contextmenu .p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-contextmenu .p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-contextmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-contextmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-contextmenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-contextmenu .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-contextmenu .p-submenu-list {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n}\n\n.p-contextmenu .p-menuitem.p-menuitem-active>.p-menuitem-link {\n  background: #eef2ff;\n}\n\n.p-contextmenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-text {\n  color: #4338ca;\n}\n\n.p-contextmenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-icon,\n.p-contextmenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-submenu-icon {\n  color: #4338ca;\n}\n\n.p-contextmenu .p-menu-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-contextmenu .p-submenu-icon {\n  font-size: 0.875rem;\n  transition: transform 0.2s;\n}\n\n.p-contextmenu .p-submenu-icon.p-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.p-dock .p-dock-list {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 0.5rem 0.5rem;\n  border-radius: 0.5rem;\n}\n\n.p-dock .p-dock-item {\n  padding: 0.5rem;\n}\n\n.p-dock .p-dock-action {\n  width: 4rem;\n  height: 4rem;\n}\n\n.p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-prev,\n.p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-next,\n.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-prev,\n.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-next {\n  margin: 0 0.9rem;\n}\n\n.p-dock.p-dock-magnification.p-dock-top .p-dock-item-prev,\n.p-dock.p-dock-magnification.p-dock-top .p-dock-item-next,\n.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-prev,\n.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-next {\n  margin: 0 1.3rem;\n}\n\n.p-dock.p-dock-magnification.p-dock-top .p-dock-item-current,\n.p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-current {\n  margin: 0 1.5rem;\n}\n\n.p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-prev,\n.p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-next,\n.p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-prev,\n.p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-next {\n  margin: 0.9rem 0;\n}\n\n.p-dock.p-dock-magnification.p-dock-left .p-dock-item-prev,\n.p-dock.p-dock-magnification.p-dock-left .p-dock-item-next,\n.p-dock.p-dock-magnification.p-dock-right .p-dock-item-prev,\n.p-dock.p-dock-magnification.p-dock-right .p-dock-item-next {\n  margin: 1.3rem 0;\n}\n\n.p-dock.p-dock-magnification.p-dock-left .p-dock-item-current,\n.p-dock.p-dock-magnification.p-dock-right .p-dock-item-current {\n  margin: 1.5rem 0;\n}\n\n@media screen and (max-width: 960px) {\n\n  .p-dock.p-dock-top .p-dock-container,\n  .p-dock.p-dock-bottom .p-dock-container {\n    overflow-x: auto;\n    width: 100%;\n  }\n\n  .p-dock.p-dock-top .p-dock-container .p-dock-list,\n  .p-dock.p-dock-bottom .p-dock-container .p-dock-list {\n    margin: 0 auto;\n  }\n\n  .p-dock.p-dock-left .p-dock-container,\n  .p-dock.p-dock-right .p-dock-container {\n    overflow-y: auto;\n    height: 100%;\n  }\n\n  .p-dock.p-dock-left .p-dock-container .p-dock-list,\n  .p-dock.p-dock-right .p-dock-container .p-dock-list {\n    margin: auto 0;\n  }\n\n  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-prev,\n  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-second-next,\n  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-prev,\n  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-next,\n  .p-dock.p-dock-magnification.p-dock-top .p-dock-item-current,\n  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-prev,\n  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-second-next,\n  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-prev,\n  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-next,\n  .p-dock.p-dock-magnification.p-dock-bottom .p-dock-item-current,\n  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-prev,\n  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-second-next,\n  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-prev,\n  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-next,\n  .p-dock.p-dock-magnification.p-dock-left .p-dock-item-current,\n  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-prev,\n  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-second-next,\n  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-prev,\n  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-next,\n  .p-dock.p-dock-magnification.p-dock-right .p-dock-item-current {\n    transform: none;\n    margin: 0;\n  }\n}\n\n.p-megamenu {\n  padding: 0.5rem;\n  background: #f8f9fa;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n  margin-left: 0.5rem;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link,\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover {\n  background: #eef2ff;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-text,\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #4338ca;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-icon,\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #4338ca;\n}\n\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link .p-submenu-icon,\n.p-megamenu .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #4338ca;\n}\n\n.p-megamenu .p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-megamenu .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-megamenu .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-megamenu .p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-megamenu .p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-megamenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-megamenu .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-megamenu .p-megamenu-panel {\n  background: #ffffff;\n  color: #495057;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-megamenu .p-megamenu-submenu-header {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  color: #343a40;\n  background: #ffffff;\n  font-weight: 700;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.p-megamenu .p-megamenu-submenu {\n  padding: 0.25rem 0;\n  width: 12.5rem;\n}\n\n.p-megamenu .p-megamenu-submenu .p-menu-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-megamenu .p-menuitem.p-menuitem-active>.p-menuitem-link {\n  background: #eef2ff;\n}\n\n.p-megamenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-text {\n  color: #4338ca;\n}\n\n.p-megamenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-icon,\n.p-megamenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-submenu-icon {\n  color: #4338ca;\n}\n\n.p-megamenu.p-megamenu-vertical {\n  width: 12.5rem;\n  padding: 0.25rem 0;\n}\n\n.p-megamenu .p-megamenu-button {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-megamenu .p-megamenu-button:hover {\n  color: #6c757d;\n  background: #e9ecef;\n}\n\n.p-megamenu .p-megamenu-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-megamenu .p-submenu-icon {\n  transition: transform 0.2s;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menu-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon {\n  font-size: 0.875rem;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-icon.p-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem {\n  width: 100%;\n  position: static;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem>.p-menuitem-link>.p-submenu-icon {\n  margin-left: auto;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n  transform: rotate(-180deg);\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list {\n  width: 100%;\n  position: static;\n  box-shadow: none;\n  border: 0 none;\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-submenu-icon {\n  transition: transform 0.2s;\n  transform: rotate(90deg);\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n  transform: rotate(-90deg);\n}\n\n.p-megamenu.p-megamenu-mobile-active .p-megamenu-root-list .p-menuitem {\n  width: 100%;\n  position: static;\n}\n\n.p-menu {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  width: 12.5rem;\n}\n\n.p-menu .p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-menu .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-menu .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-menu .p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-menu .p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-menu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-menu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-menu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-menu .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-menu.p-menu-overlay {\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-menu .p-submenu-header {\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  color: #343a40;\n  background: #ffffff;\n  font-weight: 700;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.p-menu .p-menu-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-menubar {\n  padding: 0.5rem;\n  background: #f8f9fa;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n}\n\n.p-menubar .p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-menubar .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-menubar .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-menubar .p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-menubar .p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-menubar .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-menubar .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-menubar .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-menubar .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n  margin-left: 0.5rem;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link,\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover {\n  background: #eef2ff;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-text,\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #4338ca;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-icon,\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #4338ca;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link .p-submenu-icon,\n.p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #4338ca;\n}\n\n.p-menubar .p-submenu-list {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  width: 12.5rem;\n}\n\n.p-menubar .p-submenu-list .p-menu-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-menubar .p-submenu-list .p-submenu-icon {\n  font-size: 0.875rem;\n}\n\n.p-menubar .p-submenu-list .p-submenu-icon.p-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.p-menubar .p-menuitem.p-menuitem-active>.p-menuitem-link {\n  background: #eef2ff;\n}\n\n.p-menubar .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-text {\n  color: #4338ca;\n}\n\n.p-menubar .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-icon,\n.p-menubar .p-menuitem.p-menuitem-active>.p-menuitem-link .p-submenu-icon {\n  color: #4338ca;\n}\n\n@media screen and (max-width: 960px) {\n  .p-menubar {\n    position: relative;\n  }\n\n  .p-menubar .p-menubar-button {\n    display: flex;\n    width: 2rem;\n    height: 2rem;\n    color: #6c757d;\n    border-radius: 50%;\n    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  }\n\n  .p-menubar .p-menubar-button:hover {\n    color: #6c757d;\n    background: #e9ecef;\n  }\n\n  .p-menubar .p-menubar-button:focus {\n    outline: 0 none;\n    outline-offset: 0;\n    box-shadow: 0 0 0 0.2rem #c7d2fe;\n  }\n\n  .p-menubar .p-menubar-root-list {\n    position: absolute;\n    display: none;\n    padding: 0.25rem 0;\n    background: #ffffff;\n    border: 0 none;\n    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n    width: 100%;\n  }\n\n  .p-menubar .p-menubar-root-list .p-menu-separator {\n    border-top: 1px solid #dee2e6;\n    margin: 0.25rem 0;\n  }\n\n  .p-menubar .p-menubar-root-list .p-submenu-icon {\n    font-size: 0.875rem;\n  }\n\n  .p-menubar .p-menubar-root-list .p-submenu-icon.p-icon {\n    width: 0.875rem;\n    height: 0.875rem;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem {\n    width: 100%;\n    position: static;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link {\n    padding: 0.75rem 1.25rem;\n    color: #495057;\n    border-radius: 0;\n    transition: box-shadow 0.2s;\n    user-select: none;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-text {\n    color: #495057;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-menuitem-icon {\n    color: #6c757d;\n    margin-right: 0.5rem;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-submenu-icon {\n    color: #6c757d;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover {\n    background: #e9ecef;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n    color: #495057;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n    color: #6c757d;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n    color: #6c757d;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link:focus {\n    outline: 0 none;\n    outline-offset: 0;\n    box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link>.p-submenu-icon {\n    margin-left: auto;\n    transition: transform 0.2s;\n  }\n\n  .p-menubar .p-menubar-root-list>.p-menuitem.p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n    transform: rotate(-180deg);\n  }\n\n  .p-menubar .p-menubar-root-list .p-submenu-list {\n    width: 100%;\n    position: static;\n    box-shadow: none;\n    border: 0 none;\n  }\n\n  .p-menubar .p-menubar-root-list .p-submenu-list .p-submenu-icon {\n    transition: transform 0.2s;\n    transform: rotate(90deg);\n  }\n\n  .p-menubar .p-menubar-root-list .p-submenu-list .p-menuitem-active>.p-menuitem-link>.p-submenu-icon {\n    transform: rotate(-90deg);\n  }\n\n  .p-menubar .p-menubar-root-list .p-menuitem {\n    width: 100%;\n    position: static;\n  }\n\n  .p-menubar .p-menubar-root-list ul li a {\n    padding-left: 2.25rem;\n  }\n\n  .p-menubar .p-menubar-root-list ul li ul li a {\n    padding-left: 3.75rem;\n  }\n\n  .p-menubar .p-menubar-root-list ul li ul li ul li a {\n    padding-left: 5.25rem;\n  }\n\n  .p-menubar .p-menubar-root-list ul li ul li ul li ul li a {\n    padding-left: 6.75rem;\n  }\n\n  .p-menubar .p-menubar-root-list ul li ul li ul li ul li ul li a {\n    padding-left: 8.25rem;\n  }\n\n  .p-menubar.p-menubar-mobile-active .p-menubar-root-list {\n    display: flex;\n    flex-direction: column;\n    top: 100%;\n    left: 0;\n    z-index: 1;\n  }\n}\n\n.p-panelmenu .p-panelmenu-header>a {\n  padding: 1.25rem;\n  border: 1px solid #dee2e6;\n  color: #6c757d;\n  background: #f8f9fa;\n  font-weight: 700;\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n}\n\n.p-panelmenu .p-panelmenu-header>a .p-panelmenu-icon {\n  margin-right: 0.5rem;\n}\n\n.p-panelmenu .p-panelmenu-header>a .p-menuitem-icon {\n  margin-right: 0.5rem;\n}\n\n.p-panelmenu .p-panelmenu-header>a:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-panelmenu .p-panelmenu-header:not(.p-highlight):not(.p-disabled)>a:hover {\n  background: #e9ecef;\n  border-color: #dee2e6;\n  color: #343a40;\n}\n\n.p-panelmenu .p-panelmenu-header.p-highlight {\n  margin-bottom: 0;\n}\n\n.p-panelmenu .p-panelmenu-header.p-highlight>a {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n  color: #343a40;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.p-panelmenu .p-panelmenu-header.p-highlight:not(.p-disabled)>a:hover {\n  border-color: #dee2e6;\n  background: #e9ecef;\n  color: #343a40;\n}\n\n.p-panelmenu .p-panelmenu-content {\n  padding: 0.25rem 0;\n  border: 1px solid #dee2e6;\n  background: #ffffff;\n  color: #495057;\n  border-top: 0;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-panelmenu-icon {\n  margin-right: 0.5rem;\n}\n\n.p-panelmenu .p-panelmenu-content .p-submenu-list:not(.p-panelmenu-root-submenu) {\n  padding: 0 0 0 1rem;\n}\n\n.p-panelmenu .p-panelmenu-panel {\n  margin-bottom: 4px;\n}\n\n.p-slidemenu {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  width: 12.5rem;\n}\n\n.p-slidemenu .p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-slidemenu .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-slidemenu .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-slidemenu .p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-slidemenu .p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-slidemenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-slidemenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-slidemenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-slidemenu .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-slidemenu.p-slidemenu-overlay {\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-slidemenu .p-slidemenu-list {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link {\n  background: #eef2ff;\n}\n\n.p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-text {\n  color: #4338ca;\n}\n\n.p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-icon,\n.p-slidemenu .p-slidemenu.p-slidemenu-active>.p-slidemenu-link .p-slidemenu-icon {\n  color: #4338ca;\n}\n\n.p-slidemenu .p-slidemenu-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-slidemenu .p-slidemenu-icon {\n  font-size: 0.875rem;\n}\n\n.p-slidemenu .p-slidemenu-icon.p-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.p-slidemenu .p-slidemenu-backward {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n}\n\n.p-steps .p-steps-item .p-menuitem-link {\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 6px;\n  background: #ffffff;\n}\n\n.p-steps .p-steps-item .p-menuitem-link .p-steps-number {\n  color: #495057;\n  border: 1px solid #e9ecef;\n  background: #ffffff;\n  min-width: 2rem;\n  height: 2rem;\n  line-height: 2rem;\n  font-size: 1.143rem;\n  z-index: 1;\n  border-radius: 50%;\n}\n\n.p-steps .p-steps-item .p-menuitem-link .p-steps-title {\n  margin-top: 0.5rem;\n  color: #6c757d;\n}\n\n.p-steps .p-steps-item .p-menuitem-link:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-steps .p-steps-item.p-highlight .p-steps-number {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-steps .p-steps-item.p-highlight .p-steps-title {\n  font-weight: 700;\n  color: #495057;\n}\n\n.p-steps .p-steps-item:before {\n  content: \" \";\n  border-top: 1px solid #dee2e6;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  display: block;\n  position: absolute;\n  margin-top: -1rem;\n}\n\n.p-tabmenu .p-tabmenu-nav {\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-width: 0 0 2px 0;\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem {\n  margin-right: 0;\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {\n  border: solid #dee2e6;\n  border-width: 0 0 2px 0;\n  border-color: transparent transparent #dee2e6 transparent;\n  background: #ffffff;\n  color: #6c757d;\n  padding: 1.25rem;\n  font-weight: 700;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n  transition: box-shadow 0.2s;\n  margin: 0 0 -2px 0;\n  height: calc(100% + 2px);\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link .p-menuitem-icon {\n  margin-right: 0.5rem;\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):not(.p-disabled):hover .p-menuitem-link {\n  background: #ffffff;\n  border-color: #adb5bd;\n  color: #6c757d;\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {\n  background: #ffffff;\n  border-color: #6366f1;\n  color: #6366f1;\n}\n\n.p-tieredmenu {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  width: 12.5rem;\n}\n\n.p-tieredmenu .p-menuitem-link {\n  padding: 0.75rem 1.25rem;\n  color: #495057;\n  border-radius: 0;\n  transition: box-shadow 0.2s;\n  user-select: none;\n}\n\n.p-tieredmenu .p-menuitem-link .p-menuitem-text {\n  color: #495057;\n}\n\n.p-tieredmenu .p-menuitem-link .p-menuitem-icon {\n  color: #6c757d;\n  margin-right: 0.5rem;\n}\n\n.p-tieredmenu .p-menuitem-link .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover {\n  background: #e9ecef;\n}\n\n.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {\n  color: #495057;\n}\n\n.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-icon {\n  color: #6c757d;\n}\n\n.p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {\n  color: #6c757d;\n}\n\n.p-tieredmenu .p-menuitem-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: inset 0 0 0 0.15rem #c7d2fe;\n}\n\n.p-tieredmenu.p-tieredmenu-overlay {\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-tieredmenu .p-submenu-list {\n  padding: 0.25rem 0;\n  background: #ffffff;\n  border: 0 none;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n}\n\n.p-tieredmenu .p-menuitem.p-menuitem-active>.p-menuitem-link {\n  background: #eef2ff;\n}\n\n.p-tieredmenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-text {\n  color: #4338ca;\n}\n\n.p-tieredmenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-menuitem-icon,\n.p-tieredmenu .p-menuitem.p-menuitem-active>.p-menuitem-link .p-submenu-icon {\n  color: #4338ca;\n}\n\n.p-tieredmenu .p-menu-separator {\n  border-top: 1px solid #dee2e6;\n  margin: 0.25rem 0;\n}\n\n.p-tieredmenu .p-submenu-icon {\n  font-size: 0.875rem;\n  transition: transform 0.2s;\n}\n\n.p-tieredmenu .p-submenu-icon.p-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.p-inline-message {\n  padding: 0.75rem 0.75rem;\n  margin: 0;\n  border-radius: 6px;\n}\n\n.p-inline-message.p-inline-message-info {\n  background: #e9e9ff;\n  border: solid #696cff;\n  border-width: 0px;\n  color: #696cff;\n}\n\n.p-inline-message.p-inline-message-info .p-inline-message-icon {\n  color: #696cff;\n}\n\n.p-inline-message.p-inline-message-success {\n  background: #e4f8f0;\n  border: solid #1ea97c;\n  border-width: 0px;\n  color: #1ea97c;\n}\n\n.p-inline-message.p-inline-message-success .p-inline-message-icon {\n  color: #1ea97c;\n}\n\n.p-inline-message.p-inline-message-warn {\n  background: #fff2e2;\n  border: solid #cc8925;\n  border-width: 0px;\n  color: #cc8925;\n}\n\n.p-inline-message.p-inline-message-warn .p-inline-message-icon {\n  color: #cc8925;\n}\n\n.p-inline-message.p-inline-message-error {\n  background: #ffe7e6;\n  border: solid #ff5757;\n  border-width: 0px;\n  color: #ff5757;\n}\n\n.p-inline-message.p-inline-message-error .p-inline-message-icon {\n  color: #ff5757;\n}\n\n.p-inline-message .p-inline-message-icon {\n  font-size: 1rem;\n  margin-right: 0.5rem;\n}\n\n.p-inline-message .p-inline-message-icon.p-icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.p-inline-message .p-inline-message-text {\n  font-size: 1rem;\n}\n\n.p-inline-message.p-inline-message-icon-only .p-inline-message-icon {\n  margin-right: 0;\n}\n\n.p-message {\n  margin: 1rem 0;\n  border-radius: 6px;\n}\n\n.p-message .p-message-wrapper {\n  padding: 1.25rem 1.75rem;\n}\n\n.p-message .p-message-close {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background: transparent;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-message .p-message-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.p-message .p-message-close:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-message.p-message-info {\n  background: #e9e9ff;\n  border: solid #696cff;\n  border-width: 0 0 0 6px;\n  color: #696cff;\n}\n\n.p-message.p-message-info .p-message-icon {\n  color: #696cff;\n}\n\n.p-message.p-message-info .p-message-close {\n  color: #696cff;\n}\n\n.p-message.p-message-success {\n  background: #e4f8f0;\n  border: solid #1ea97c;\n  border-width: 0 0 0 6px;\n  color: #1ea97c;\n}\n\n.p-message.p-message-success .p-message-icon {\n  color: #1ea97c;\n}\n\n.p-message.p-message-success .p-message-close {\n  color: #1ea97c;\n}\n\n.p-message.p-message-warn {\n  background: #fff2e2;\n  border: solid #cc8925;\n  border-width: 0 0 0 6px;\n  color: #cc8925;\n}\n\n.p-message.p-message-warn .p-message-icon {\n  color: #cc8925;\n}\n\n.p-message.p-message-warn .p-message-close {\n  color: #cc8925;\n}\n\n.p-message.p-message-error {\n  background: #ffe7e6;\n  border: solid #ff5757;\n  border-width: 0 0 0 6px;\n  color: #ff5757;\n}\n\n.p-message.p-message-error .p-message-icon {\n  color: #ff5757;\n}\n\n.p-message.p-message-error .p-message-close {\n  color: #ff5757;\n}\n\n.p-message .p-message-text {\n  font-size: 1rem;\n  font-weight: 400;\n}\n\n.p-message .p-message-icon {\n  font-size: 1.5rem;\n  margin-right: 0.5rem;\n}\n\n.p-message .p-message-icon.p-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.p-message .p-message-summary {\n  font-weight: 700;\n}\n\n.p-message .p-message-detail {\n  margin-left: 0.5rem;\n}\n\n.p-toast {\n  opacity: 0.9;\n}\n\n.p-toast .p-toast-message {\n  margin: 0 0 1rem 0;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n}\n\n.p-toast .p-toast-message .p-toast-message-content {\n  padding: 1rem;\n  border-width: 0 0 0 6px;\n}\n\n.p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {\n  margin: 0 0 0 1rem;\n}\n\n.p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon {\n  font-size: 2rem;\n}\n\n.p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-toast .p-toast-message .p-toast-message-content .p-toast-summary {\n  font-weight: 700;\n}\n\n.p-toast .p-toast-message .p-toast-message-content .p-toast-detail {\n  margin: 0.5rem 0 0 0;\n}\n\n.p-toast .p-toast-message .p-toast-icon-close {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background: transparent;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-toast .p-toast-message .p-toast-icon-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.p-toast .p-toast-message .p-toast-icon-close:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-toast .p-toast-message.p-toast-message-info {\n  background: #e9e9ff;\n  border: solid #696cff;\n  border-width: 0 0 0 6px;\n  color: #696cff;\n}\n\n.p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon,\n.p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close {\n  color: #696cff;\n}\n\n.p-toast .p-toast-message.p-toast-message-success {\n  background: #e4f8f0;\n  border: solid #1ea97c;\n  border-width: 0 0 0 6px;\n  color: #1ea97c;\n}\n\n.p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,\n.p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close {\n  color: #1ea97c;\n}\n\n.p-toast .p-toast-message.p-toast-message-warn {\n  background: #fff2e2;\n  border: solid #cc8925;\n  border-width: 0 0 0 6px;\n  color: #cc8925;\n}\n\n.p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon,\n.p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close {\n  color: #cc8925;\n}\n\n.p-toast .p-toast-message.p-toast-message-error {\n  background: #ffe7e6;\n  border: solid #ff5757;\n  border-width: 0 0 0 6px;\n  color: #ff5757;\n}\n\n.p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon,\n.p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {\n  color: #ff5757;\n}\n\n.p-galleria .p-galleria-close {\n  margin: 0.5rem;\n  background: transparent;\n  color: #f8f9fa;\n  width: 4rem;\n  height: 4rem;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  border-radius: 50%;\n}\n\n.p-galleria .p-galleria-close .p-galleria-close-icon {\n  font-size: 2rem;\n}\n\n.p-galleria .p-galleria-close .p-galleria-close-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-galleria .p-galleria-close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f8f9fa;\n}\n\n.p-galleria .p-galleria-item-nav {\n  background: transparent;\n  color: #f8f9fa;\n  width: 4rem;\n  height: 4rem;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  border-radius: 6px;\n  margin: 0 0.5rem;\n}\n\n.p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon,\n.p-galleria .p-galleria-item-nav .p-galleria-item-next-icon {\n  font-size: 2rem;\n}\n\n.p-galleria .p-galleria-item-nav .p-galleria-item-prev-icon.p-icon,\n.p-galleria .p-galleria-item-nav .p-galleria-item-next-icon.p-icon {\n  width: 2rem;\n  height: 2rem;\n}\n\n.p-galleria .p-galleria-item-nav:not(.p-disabled):hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f8f9fa;\n}\n\n.p-galleria .p-galleria-caption {\n  background: rgba(0, 0, 0, 0.5);\n  color: #f8f9fa;\n  padding: 1rem;\n}\n\n.p-galleria .p-galleria-indicators {\n  padding: 1rem;\n}\n\n.p-galleria .p-galleria-indicators .p-galleria-indicator button {\n  background-color: #ced4da;\n  width: 1rem;\n  height: 1rem;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  border-radius: 50%;\n}\n\n.p-galleria .p-galleria-indicators .p-galleria-indicator button:hover {\n  background: #adb5bd;\n}\n\n.p-galleria .p-galleria-indicators .p-galleria-indicator.p-highlight button {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-galleria.p-galleria-indicators-bottom .p-galleria-indicator,\n.p-galleria.p-galleria-indicators-top .p-galleria-indicator {\n  margin-right: 0.5rem;\n}\n\n.p-galleria.p-galleria-indicators-left .p-galleria-indicator,\n.p-galleria.p-galleria-indicators-right .p-galleria-indicator {\n  margin-bottom: 0.5rem;\n}\n\n.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator button:hover {\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.p-galleria.p-galleria-indicator-onitem .p-galleria-indicators .p-galleria-indicator.p-highlight button {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.p-galleria .p-galleria-thumbnail-container {\n  background: rgba(0, 0, 0, 0.9);\n  padding: 1rem 0.25rem;\n}\n\n.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev,\n.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next {\n  margin: 0.5rem;\n  background-color: transparent;\n  color: #f8f9fa;\n  width: 2rem;\n  height: 2rem;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  border-radius: 50%;\n}\n\n.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev:hover,\n.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f8f9fa;\n}\n\n.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content {\n  transition: box-shadow 0.2s;\n}\n\n.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-item-content:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-galleria-mask {\n  --maskbg: rgba(0, 0, 0, 0.9);\n}\n\n.p-image-mask {\n  --maskbg: rgba(0, 0, 0, 0.9);\n}\n\n.p-image-preview-indicator {\n  background-color: transparent;\n  color: #f8f9fa;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-image-preview-indicator .p-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.p-image-preview-container:hover>.p-image-preview-indicator {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.p-image-toolbar {\n  padding: 1rem;\n}\n\n.p-image-action.p-link {\n  color: #f8f9fa;\n  background-color: transparent;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  margin-right: 0.5rem;\n}\n\n.p-image-action.p-link:last-child {\n  margin-right: 0;\n}\n\n.p-image-action.p-link:hover {\n  color: #f8f9fa;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.p-image-action.p-link span {\n  font-size: 1.5rem;\n}\n\n.p-image-action.p-link .p-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.p-avatar {\n  background-color: #dee2e6;\n  border-radius: 6px;\n}\n\n.p-avatar.p-avatar-lg {\n  width: 3rem;\n  height: 3rem;\n  font-size: 1.5rem;\n}\n\n.p-avatar.p-avatar-lg .p-avatar-icon {\n  font-size: 1.5rem;\n}\n\n.p-avatar.p-avatar-xl {\n  width: 4rem;\n  height: 4rem;\n  font-size: 2rem;\n}\n\n.p-avatar.p-avatar-xl .p-avatar-icon {\n  font-size: 2rem;\n}\n\n.p-avatar-group .p-avatar {\n  border: 2px solid #ffffff;\n}\n\n.p-chip {\n  background-color: #dee2e6;\n  color: #495057;\n  border-radius: 16px;\n  padding: 0 0.75rem;\n}\n\n.p-chip .p-chip-text {\n  line-height: 1.5;\n  margin-top: 0.375rem;\n  margin-bottom: 0.375rem;\n}\n\n.p-chip .p-chip-icon {\n  margin-right: 0.5rem;\n}\n\n.p-chip img {\n  width: 2.25rem;\n  height: 2.25rem;\n  margin-left: -0.75rem;\n  margin-right: 0.5rem;\n}\n\n.p-chip .p-chip-remove-icon {\n  border-radius: 6px;\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n  margin-left: 0.5rem;\n}\n\n.p-chip .p-chip-remove-icon:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-scrolltop {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n}\n\n.p-scrolltop.p-link {\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.p-scrolltop.p-link:hover {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.p-scrolltop .p-scrolltop-icon {\n  font-size: 1.5rem;\n  color: #f8f9fa;\n}\n\n.p-scrolltop .p-scrolltop-icon.p-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.p-skeleton {\n  background-color: #dee2e6;\n  border-radius: 6px;\n}\n\n.p-skeleton:after {\n  background: linear-gradient(90deg,\n      rgba(255, 255, 255, 0),\n      rgba(255, 255, 255, 0.4),\n      rgba(255, 255, 255, 0));\n}\n\n.p-tag {\n  background: #6366f1;\n  color: #ffffff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.25rem 0.4rem;\n  border-radius: 6px;\n}\n\n.p-tag.p-tag-success {\n  background-color: #22c55e;\n  color: #ffffff;\n}\n\n.p-tag.p-tag-info {\n  background-color: #3b82f6;\n  color: #ffffff;\n}\n\n.p-tag.p-tag-warning {\n  background-color: #f59e0b;\n  color: #ffffff;\n}\n\n.p-tag.p-tag-danger {\n  background-color: #ef4444;\n  color: #ffffff;\n}\n\n.p-tag .p-tag-icon {\n  margin-right: 0.25rem;\n  font-size: 0.75rem;\n}\n\n.p-tag .p-tag-icon.p-icon {\n  width: 0.75rem;\n  height: 0.75rem;\n}\n\n.p-inplace .p-inplace-display {\n  padding: 0.75rem 0.75rem;\n  border-radius: 6px;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-inplace .p-inplace-display:not(.p-disabled):hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.p-inplace .p-inplace-display:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n}\n\n.p-progressbar {\n  border: 0 none;\n  height: 1.5rem;\n  background: #dee2e6;\n  border-radius: 6px;\n}\n\n.p-progressbar .p-progressbar-value {\n  border: 0 none;\n  margin: 0;\n  background: #6366f1;\n}\n\n.p-progressbar .p-progressbar-label {\n  color: #ffffff;\n  line-height: 1.5rem;\n}\n\n.p-terminal {\n  background: #ffffff;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  padding: 1.25rem;\n}\n\n.p-terminal .p-terminal-input {\n  font-size: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n\n.p-badge {\n  background: #6366f1;\n  color: #ffffff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  min-width: 1.5rem;\n  height: 1.5rem;\n  line-height: 1.5rem;\n}\n\n.p-badge.p-badge-secondary {\n  background-color: #64748b;\n  color: #ffffff;\n}\n\n.p-badge.p-badge-success {\n  background-color: #22c55e;\n  color: #ffffff;\n}\n\n.p-badge.p-badge-info {\n  background-color: #3b82f6;\n  color: #ffffff;\n}\n\n.p-badge.p-badge-warning {\n  background-color: #f59e0b;\n  color: #ffffff;\n}\n\n.p-badge.p-badge-danger {\n  background-color: #ef4444;\n  color: #ffffff;\n}\n\n.p-badge.p-badge-lg {\n  font-size: 1.125rem;\n  min-width: 2.25rem;\n  height: 2.25rem;\n  line-height: 2.25rem;\n}\n\n.p-badge.p-badge-xl {\n  font-size: 1.5rem;\n  min-width: 3rem;\n  height: 3rem;\n  line-height: 3rem;\n}\n\n.p-tag {\n  background: #6366f1;\n  color: #ffffff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.25rem 0.4rem;\n  border-radius: 6px;\n}\n\n.p-tag.p-tag-success {\n  background-color: #22c55e;\n  color: #ffffff;\n}\n\n.p-tag.p-tag-info {\n  background-color: #3b82f6;\n  color: #ffffff;\n}\n\n.p-tag.p-tag-warning {\n  background-color: #f59e0b;\n  color: #ffffff;\n}\n\n.p-tag.p-tag-danger {\n  background-color: #ef4444;\n  color: #ffffff;\n}\n\n.p-button-label {\n  font-weight: 700;\n}\n\n.p-accordion .p-accordion-header .p-accordion-header-link {\n  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.p-tabview .p-tabview-nav .p-tabview-ink-bar {\n  z-index: 1;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  height: 2px;\n  background-color: #6366f1;\n  transition: 500ms cubic-bezier(0.35, 0, 0.25, 1);\n}\n\n.p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {\n  background-color: #6366f1;\n}\n\n.p-galleria .p-galleria-indicators .p-galleria-indicator.p-highlight button {\n  background-color: #6366f1;\n}\n\n.p-button:focus {\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b1b3f8, 0 1px 2px 0 rgb(0, 0, 0);\n}\n\n.p-button.p-button-secondary:enabled:focus {\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b0b9c6, 0 1px 2px 0 rgb(0, 0, 0);\n}\n\n.p-button.p-button-success:enabled:focus {\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #88eaac, 0 1px 2px 0 rgb(0, 0, 0);\n}\n\n.p-button.p-button-info:enabled:focus {\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #9dc1fb, 0 1px 2px 0 rgb(0, 0, 0);\n}\n\n.p-button.p-button-warning:enabled:focus {\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #facf85, 0 1px 2px 0 rgb(0, 0, 0);\n}\n\n.p-button.p-button-help:enabled:focus {\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #d4aafb, 0 1px 2px 0 rgb(0, 0, 0);\n}\n\n.p-button.p-button-danger:enabled:focus {\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #f7a2a2, 0 1px 2px 0 rgb(0, 0, 0);\n}\n\n.p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-top>td {\n  box-shadow: inset 0 2px 0 0 #6366f1;\n}\n\n.p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-bottom>td {\n  box-shadow: inset 0 -2px 0 0 #6366f1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
